<template>
    <v-container fluid request-edit>

        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title style="text-align: center;">
                    <span class="headline">Есть некорректно заполненные поля, пожалуста подтвердите переход</span>
                </v-card-title>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue" flat @click="close">Отменить</v-btn>
                    <v-btn color="success" flat @click="nextStep">Далее</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>

            </v-card>
        </v-dialog>

        <v-dialog v-model="saveDialog" persistent max-width="500">
            <v-card>
                <v-card-title style="text-align: center;" class="headline">Заявка не может быть сохранена , так как есть некорректно заполнение поля, пожалуйста проверьте </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" flat @click="saveDialog = false">Продолжить работу</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="errorDialog" persistent max-width="500">
            <v-card>
                <v-card-title style="text-align: center;" class="headline">Заявка не может быть сохранена , произошла ошибка </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" flat @click="errorDialog = false">Продолжить</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>

                <v-expansion-panel expand>

                    <v-expansion-panel-content>
                        <template v-slot:header>Подробнее</template>
                        <v-card>
                            <v-card-text>
                                <div>{{ this.errFileName }}</div>
                                <div v-for="(value,key) in this.errorMessage" :key="key">
                                    <b> {{key}} </b>  - {{ value }}
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-expansion-panel-content>

                </v-expansion-panel>
            </v-card>
        </v-dialog>

        <v-dialog v-model="duplicateDialog" persistent max-width="500">
            <v-card>
                <v-card-title style="text-align: center;" class="headline">Название файлов не должны повторятся в одном документе. <br> Пожалуйста измените. </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" flat @click="duplicateDialog = false">Продолжить</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="emptyDocumentDialog" persistent max-width="500">
            <v-card>
                <v-card-title style="text-align: center;" class="headline">Не пустой файл должен быть прикреплен. </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" flat @click="emptyDocumentDialog = false">Продолжить</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
                v-model="saveLoading"
                persistent
                width="300"
        >
            <v-card
                    color="primary"
                    dark
            >
                <v-card-text>
                    Подождите, пожалуйста
                    <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog
                v-model="successRequest"
                persistent
                width="400"
        >
            <v-card
                    class="success-card"
            >
                <v-card-text>
                    Заявка успешно сохранилась
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="supplierDefinitionInfoDialog" max-width="800">
            <v-card>
                <v-card-title style="justify-content: center;" class="headline">Реквизит счета</v-card-title>
                <v-card-text>
                    <v-layout wrap v-if="accountDetailsItemsFiltered.length > 0">
                        <v-flex xs3>Получатель:</v-flex>
                        <v-flex xs9 class="text-xs-right">{{ accountDetailsItemsFiltered[0].receiver }}</v-flex>
                        <v-flex xs3>Лицевой счет:</v-flex>
                        <v-flex xs9 class="text-xs-right">{{ accountDetailsItemsFiltered[0].personalAccount }}</v-flex>
                        <v-flex xs3>ИНН:</v-flex>
                        <v-flex xs9 class="text-xs-right">{{ accountDetailsItemsFiltered[0].inn }}</v-flex>
                        <v-flex xs3>КПП:</v-flex>
                        <v-flex xs9 class="text-xs-right">{{ accountDetailsItemsFiltered[0].kpp }}</v-flex>
                        <v-flex xs3>Расчетный счет:</v-flex>
                        <v-flex xs9 class="text-xs-right">{{ accountDetailsItemsFiltered[0].account }}</v-flex>
                        <v-flex xs3>БИК:</v-flex>
                        <v-flex xs9 class="text-xs-right">{{ accountDetailsItemsFiltered[0].bic }}</v-flex>
                        <v-flex xs3>Корреспондентский счет:</v-flex>
                        <v-flex xs9 class="text-xs-right">{{ accountDetailsItemsFiltered[0].correspondentAccount }}</v-flex>
                        <v-flex xs3>Наименование банка:</v-flex>
                        <v-flex xs9 class="text-xs-right">{{ accountDetailsItemsFiltered[0].bankName }}</v-flex>
                        <v-flex xs3>Код цели:</v-flex>
                        <v-flex xs9 class="text-xs-right">{{ accountDetailsItemsFiltered[0].goalCode }}</v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="closeSupplierDefinitionInfo()">Закрыть</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <div v-if="cancelChangeStatus.status" class="cancel-changes">
            <v-btn flat small color="success" @click="cancelChanges">Вернуться к последним сохранённым изменениям</v-btn>
        </div>

        <v-stepper v-model="e1">
            <v-stepper-header>
                <v-stepper-step
                        @click="e1 = 1"
                        step="1"
                >
                    Сведения о заказчике
                </v-stepper-step>
                <!--editable-->
                <v-divider></v-divider>

                <v-stepper-step
                        @click="validateStep1()"
                        step="2"
                >
                    Общие сведения о закупке
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step
                        @click="validateStep2"
                        step="3"
                >
                    Преимущества и ограничения
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step
                        @click="validateStep3"
                        step="4">
                    Документы
                </v-stepper-step>

                <v-divider
                        class="mx-2"
                        inset
                        vertical
                ></v-divider>

                <v-btn flat color="primary" style="margin: 18px 0;" @click="e1 = 'comments'">История изменений</v-btn>

            </v-stepper-header>

            <v-stepper-items>

                <v-stepper-content step="1">
                    <v-form
                            ref="form1"
                            v-model="validStep1"
                            lazy-validation
                    >
                        <v-card
                                class="mb-5"
                        >

                            <h3 class="headline mb-0">Название заказчика, контактная информация</h3>
                            <v-container fluid grid-list-md >
                                <v-layout wrap>
                                    <v-flex xs12 sm6 md6>
                                        <p class="filed-title">ИНН</p>
                                        <div class="filed-block">{{customerItem.inn}}</div>
                                    </v-flex>

                                    <v-flex xs12 sm6 md6>
                                        <p class="filed-title">Адрес элетронной почты</p>
                                        <div class="filed-block">{{customerItem.email}}</div>
                                    </v-flex>

                                    <v-flex xs12 sm6 md6>
                                        <p class="filed-title">Наименование</p>
                                        <div class="filed-block-area">{{customerItem.name}}</div>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                        <p class="filed-title">Телефон</p>
                                        <div class="filed-block-area">{{customerItem.phone}}</div>
                                    </v-flex>

                                    <v-flex xs12 sm6 md6>
                                        <p class="filed-title">Адрес (место нахождения)</p>
                                        <div class="filed-block-area">{{customerItem.address}}</div>
                                    </v-flex>

                                    <v-flex xs12 sm6 md6>
                                        <p class="filed-title">Почтовый адрес</p>
                                        <div class="filed-block-area">{{customerItem.mailAddress}}</div>
                                    </v-flex>


                                </v-layout>

                            </v-container>

                            <h3 class="headline mb-0">Информация о контрактной службе, контрактном управляющем, ответственных за заключение контракта</h3>
                            <v-container fluid grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 sm6 md6 field-block>
                                        <div v-if="contractItem.contractManagerFIO.length >= 232 && contractItem.contractManagerFIO.length < 256" class='max-length-block'>Осталось {{256 - contractItem.contractManagerFIO.length}} символов</div>
                                        <v-text-field v-model="contractItem.contractManagerFIO" :append-icon="contractItemChange.contractManagerFIO ? 'fa-exclamation-triangle' : ''" :disabled="!this.allowFiledEdit" validate-on-blur :rules="requiredRules256" :error-messages="accountInputErrors.contractManagerFIO" maxlength="256"  required>
                                            <template slot="label">
                                                Ф.И.О. контрактного управляющего <span class='error-file'>*</span>
                                            </template>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                        <v-text-field v-model="contractItem.contractManagerPhone" :append-icon="contractItemChange.contractManagerPhone ? 'fa-exclamation-triangle' : ''" prefix="+7" validate-on-blur mask="(###) ###-##-##"  :rules="phoneRules" :counter="10" :error-messages="accountInputErrors.contractManagerPhone" :disabled="!this.allowFiledEdit"  required>
                                            <template slot="label">
                                                Телефон <span class='error-file'>*</span>
                                            </template>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 field-block>
                                        <div v-if="contractItem.contractManagerEmail.length >= 76 && contractItem.contractManagerEmail.length < 100" class='max-length-block'>Осталось {{100 - contractItem.contractManagerEmail.length}} символов</div>

                                        <v-text-field v-model="contractItem.contractManagerEmail" :append-icon="contractItemChange.contractManagerEmail ? 'fa-exclamation-triangle' : ''" validate-on-blur :rules="emailRules" :error-messages="accountInputErrors.contractManagerEmail" maxlength="100" :disabled="!this.allowFiledEdit" required>
                                            <template slot="label">
                                                Адрес элетронной почты <span class='error-file'>*</span>
                                            </template>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 field-block>
                                        <div v-if="contractItem.contractDocumentName.length >= 488 && contractItem.contractDocumentName.length < 512" class='max-length-block'>Осталось {{512 - contractItem.contractDocumentName.length}} символов</div>
                                        <v-textarea
                                                rows="3"
                                                v-model="contractItem.contractDocumentName"
                                                :rules="requiredRules512"
                                                validate-on-blur
                                                maxlength="512"
                                                :append-icon="contractItemChange.contractDocumentName ? 'fa-exclamation-triangle' : ''"
                                                :error-messages="inputErrors.contractDocumentName"
                                                :disabled="!this.allowFiledEdit"
                                                required
                                        >
                                            <template slot="label">
                                                Наименование документа, на основании которого действует руководитель контрактной службы / контрактный управляющий <span class='error-file'>*</span>
                                            </template>
                                        </v-textarea>
                                    </v-flex>
                                        <v-flex xs12>Номер и дата документа, на основании которого действует руководитель контрактной службы / контрактный управляющий</v-flex>

                                        <v-flex xs12 sm3 md3 field-block>
                                            <v-menu
                                                    v-if="this.allowFiledEdit"
                                                    v-model="menuDate"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    lazy
                                                    transition="scale-transition"
                                                    offset-y
                                                    full-width
                                                    min-width="290px"
                                            >
                                                <v-text-field
                                                        slot="activator"
                                                        :value="dateFormatted"
                                                        small
                                                        prepend-icon="event"
                                                        validate-on-blur
                                                        :append-icon="contractItemChange.contractDocumentDate ? 'fa-exclamation-triangle' : ''"
                                                        :rules="requiredRules"
                                                        readonly
                                                >
                                                    <template slot="label">
                                                        Дата документа <span class='error-file'>*</span>
                                                    </template>
                                                </v-text-field>
                                                <v-date-picker v-model="contractItem.contractDocumentDate" no-title @input="menuDate = false" locale="ru"></v-date-picker>
                                            </v-menu>
                                            <v-text-field
                                                    v-else
                                                    slot="activator"
                                                    :value="dateFormatted"
                                                    prepend-icon="event"
                                                    validate-on-blur
                                                    :append-icon="contractItemChange.contractDocumentDate ? 'fa-exclamation-triangle' : ''"
                                                    :rules="requiredRules"
                                                    disabled
                                                    readonly
                                            >
                                                <template slot="label">
                                                    Дата документа <span class='error-file'>*</span>
                                                </template>
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm9 md9 field-block>
                                            <div v-if="contractItem.contractDocumentNumber.length >= 232 && contractItem.contractDocumentNumber.length < 256" class='max-length-block'>Осталось {{256 - contractItem.contractDocumentNumber.length}} символов</div>

                                            <v-text-field v-model="contractItem.contractDocumentNumber"  :append-icon="contractItemChange.contractDocumentNumber ? 'fa-exclamation-triangle' : ''" validate-on-blur :rules="requiredRules256" :error-messages="accountInputErrors.contractDocumentNumber" maxlength="256" :disabled="!this.allowFiledEdit" required>
                                                <template slot="label">
                                                    Номер документа <span class='error-file'>*</span>
                                                </template>
                                            </v-text-field>
                                        </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card>
                        <v-card-actions class="step-bottom-block">
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="validateStep1()">Далее</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-stepper-content>

                <v-stepper-content step="2">
                    <v-form ref="form2" lazy-validation>
                        <v-card
                                class="mb-5"
                        >
                            <v-container fluid grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-select
                                                :items="supplierDefinitionTypes"
                                                item-text="name"
                                                item-value="val"
                                                no-data-text="Нет доступных для выбора"
                                                v-model="contractItem.supplierDefinitionType"
                                                :error-messages="inputErrors.supplierDefinitionType"
                                                :disabled="!this.allowFiledEdit"
                                                :append-icon="contractItemChange.supplierDefinitionType ? 'fa-exclamation-triangle' : ''"
                                                required
                                                :menu-props="{
                                                      transition: 'scale-transition',
                                                      offsetY: true,
                                                }"
                                        >
                                            <template slot="label">
                                                Способ определения поставщика <span class='error-file'>*</span>
                                            </template>
                                        </v-select>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field v-model="contractItem.purchaseId" :append-icon="contractItemChange.purchaseId ? 'fa-exclamation-triangle' : ''" :rules="purchaseIdRules" mask="####################################" :counter="36" :error-messages="inputErrors.purchaseId" :disabled="!this.allowFiledEdit" required>
                                            <template slot="label">
                                                Идентификационный код закупки <span class='error-file'>*</span>
                                            </template>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 field-block>
                                        <div v-if="contractItem.name.length >= 488 && contractItem.name.length < 512" class='max-length-block'>Осталось {{512 - contractItem.name.length}} символов</div>
                                        <v-textarea
                                                rows="3"
                                                v-model="contractItem.name"
                                                :rules="requiredRules512"
                                                maxlength="512"
                                                :error-messages="inputErrors.name"
                                                :disabled="!this.allowFiledEdit"
                                                :append-icon="contractItemChange.name ? 'fa-exclamation-triangle' : ''"
                                                required
                                        >
                                            <template slot="label">
                                                Наименование закупки (предмет лота) <span class='error-file'>*</span>
                                            </template>
                                        </v-textarea>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field v-model="contractItem.purchaseRegNumber" :append-icon="contractItemChange.purchaseRegNumber ? 'fa-exclamation-triangle' : ''" mask="######-##" :counter="8" :rules="purchaseRegNumberRules" :error-messages="inputErrors.purchaseRegNumber" :disabled="!this.allowFiledEdit" required>
                                            <template slot="label">
                                                Реестровый номер закупки в ЕАСУЗ <span class='error-file'>*</span>
                                            </template>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 field-block style="display: flex">
                                        <div class="file-info" style="cursor: pointer;margin: 12px 5px 0;" @click="openSupplierDefinitionInfo(contractItem.accountDetailsId)">
                                            <img src="@/assets/hint-icon.svg" >
                                        </div>
                                        <v-select
                                                :items="accountDetails2"
                                                item-text="personalAccount"
                                                item-value="id"
                                                v-model="contractItem.accountDetailsId"
                                                :error-messages="inputErrors.accountDetailsId"
                                                :append-icon="contractItemChange.accountDetailsId ? 'fa-exclamation-triangle' : ''"
                                                :disabled="!this.allowFiledEdit"
                                                required
                                                :menu-props="{
                                                      transition: 'scale-transition',
                                                      offsetY: true,
                                                }"
                                        >
                                            <template slot="label">
                                                Реквизиты счета для перечисления денежных средств <span class='error-file'>*</span>
                                            </template>
                                        </v-select>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-checkbox
                                                color="primary"
                                                label="Невозможно определить количество поставляемых товаров, объем подлежащих выполнению работ, оказанию услуг"
                                                v-model="contractItem.undefinedQuantityUnitsSupplied"
                                                :append-icon="contractItemChange.undefinedQuantityUnitsSupplied ? 'fa-exclamation-triangle' : ''"
                                                :disabled="!this.allowFiledEdit"
                                        ></v-checkbox>
                                        <v-divider style="margin-bottom: 10px"></v-divider>
                                    </v-flex>

                                    <v-flex xs12 field-block v-if="contractItem.undefinedQuantityUnitsSupplied">
                                        <div v-if="contractItem.startServicePrice && contractItem.startServicePrice.length >= 104 && contractItem.startServicePrice.length < 128" class='max-length-block'>Осталось {{128 - contractItem.startServicePrice.length}} символов</div>

                                        <v-text-field
                                                      v-model="contractItem.startServicePrice"
                                                      @keypress="validateForPrice($event, contractItem.startServicePrice)"
                                                      :append-icon="contractItemChange.startServicePrice ? 'fa-exclamation-triangle' : ''"
                                                      :disabled="!this.allowFiledEdit"
                                                      :error-messages="inputErrors.startServicePrice"
                                                      :rules="requiredRules"
                                                      validate-on-blur
                                                      maxlength="128"
                                                      required
                                        >
                                            <template slot="label">
                                                Начальная цена единицы товара, работы, услуги (в руб) <span class='error-file'>*</span>
                                            </template>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 field-block v-if="contractItem.undefinedQuantityUnitsSupplied">
                                        <div v-if="contractItem.startServiceUnitsSum && contractItem.startServiceUnitsSum.length >= 104 && contractItem.startServiceUnitsSum.length < 128" class='max-length-block'>Осталось {{128 - contractItem.startServiceUnitsSum.length}} символов</div>

                                        <v-text-field
                                                      v-model="contractItem.startServiceUnitsSum"
                                                      @keypress="validateForPrice($event, contractItem.startServiceUnitsSum)"
                                                      :append-icon="contractItemChange.startServiceUnitsSum ? 'fa-exclamation-triangle' : ''"
                                                      :disabled="!this.allowFiledEdit"
                                                      :error-messages="inputErrors.startServiceUnitsSum"
                                                      :rules="requiredRules"
                                                      validate-on-blur
                                                      maxlength="128"
                                                      required>
                                            <template slot="label">
                                                Начальная сумма цен указанных единиц (в руб) <span class='error-file'>*</span>
                                            </template>
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs12 field-block v-if="contractItem.undefinedQuantityUnitsSupplied">
                                        <div v-if="contractItem.maxContractPrice && contractItem.maxContractPrice.length >= 104 && contractItem.maxContractPrice.length < 128" class='max-length-block'>Осталось {{128 - contractItem.maxContractPrice.length}} символов</div>

                                        <v-text-field
                                                v-model="contractItem.maxContractPrice"
                                                @keypress="validateForPrice($event, contractItem.maxContractPrice)"
                                                :append-icon="contractItemChange.maxContractPrice ? 'fa-exclamation-triangle' : ''"
                                                :disabled="!this.allowFiledEdit"
                                                :error-messages="inputErrors.maxContractPrice"
                                                :rules="requiredRules"
                                                maxlength="128"
                                                required
                                        >
                                            <template slot="label">
                                                Максимальное значение цены контракта (в руб) <span class='error-file'>*</span>
                                            </template>
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs12 field-block v-if="!contractItem.undefinedQuantityUnitsSupplied">
                                        <div v-if="contractItem.startContractPrice && contractItem.startContractPrice.length >= 104 && contractItem.startContractPrice.length < 128" class='max-length-block'>Осталось {{128 - contractItem.startContractPrice.length}} символов</div>
                                        <v-text-field v-model="contractItem.startContractPrice" :append-icon="contractItemChange.startContractPrice ? 'fa-exclamation-triangle' : ''" @blur="changeStartContractPrice(contractItem.startContractPrice)" @keypress="validateForPrice($event, contractItem.startContractPrice)" :rules="requiredRules" maxlength="128" :error-messages="inputErrors.startContractPrice" :disabled="!this.allowFiledEdit" validate-on-blur
                                                      required>
                                            <template slot="label">
                                                Начальная (максимальная) цена контракта (в руб) <span class='error-file'>*</span>
                                            </template>
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs12 v-if="!contractItem.undefinedQuantityUnitsSupplied">
                                        <v-select
                                                :items="justificationMethodItems"
                                                item-text="name"
                                                item-value="val"
                                                no-data-text="Нет доступных для выбора"
                                                v-model="contractItem.justificationMethod"
                                                :error-messages="inputErrors.justificationMethod"
                                                :disabled="!this.allowFiledEdit"
                                                :append-icon="contractItemChange.justificationMethod ? 'fa-exclamation-triangle' : ''"
                                                :rules="requiredRules"
                                                required
                                                :menu-props="{
                                                      transition: 'scale-transition',
                                                      offsetY: true,
                                                }"
                                        >
                                            <template slot="label">
                                                Метод обоснования НМЦК <span class='error-file'>*</span>
                                            </template>
                                        </v-select>
                                    </v-flex>

                                    <v-flex xs12 field-block>
                                        <div v-if="contractItem.otherTaxInPrice && contractItem.otherTaxInPrice.length >= 488 && contractItem.otherTaxInPrice.length < 512" class='max-length-block'>Осталось {{512 - contractItem.otherTaxInPrice.length}} символов</div>
                                        <v-textarea
                                                rows="4"
                                                v-model="contractItem.otherTaxInPrice"
                                                :rules="requiredRules512"
                                                maxlength="512"
                                                :error-messages="inputErrors.otherTaxInPrice"
                                                :disabled="!this.allowFiledEdit"
                                                :append-icon="contractItemChange.otherTaxInPrice ? 'fa-exclamation-triangle' : ''"
                                                required
                                        >
                                            <template slot="label">
                                                Сведения о включенных в цену товара налогов, сборов и других обязательных платежах, а также других расходов <span class='error-file'>*</span>
                                            </template>
                                        </v-textarea>
                                    </v-flex>

                                    <v-flex xs12 field-block>
                                        <div v-if="contractItem.contractExecutionPlace && contractItem.contractExecutionPlace.length >= 2024 && contractItem.contractExecutionPlace.length < 2048" class='max-length-block'>Осталось {{2048 - contractItem.contractExecutionPlace.length}} символов</div>
                                        <v-textarea
                                                rows="6"
                                                v-model="contractItem.contractExecutionPlace"
                                                :rules="requiredRules2048"
                                                maxlength="2048"
                                                :error-messages="inputErrors.contractExecutionPlace"
                                                :disabled="!this.allowFiledEdit"
                                                :append-icon="contractItemChange.contractExecutionPlace ? 'fa-exclamation-triangle' : ''"
                                                required
                                        >
                                            <template slot="label">
                                                Место поставки товаров, выполнения работ, оказания услуг <span class='error-file'>*</span>
                                            </template>
                                        </v-textarea>
                                    </v-flex>

                                    <v-flex xs12 field-block>
                                        <div v-if="contractItem.contractExecutionDeadline && contractItem.contractExecutionDeadline.length >= 488 && contractItem.contractExecutionDeadline.length < 512" class='max-length-block'>Осталось {{512 - contractItem.contractExecutionDeadline.length}} символов</div>
                                        <v-textarea
                                                rows="3"
                                                v-model="contractItem.contractExecutionDeadline"
                                                :rules="requiredRules512"
                                                maxlength="512"
                                                :error-messages="inputErrors.contractExecutionDeadline"
                                                :disabled="!this.allowFiledEdit"
                                                :append-icon="contractItemChange.contractExecutionDeadline ? 'fa-exclamation-triangle' : ''"
                                                required
                                        >
                                            <template slot="label">
                                                Сроки поставки товара или завершения работы либо график оказания услуг <span class='error-file'>*</span>
                                            </template>
                                        </v-textarea>
                                    </v-flex>

                                    <v-flex xs12 field-block>
                                        <div v-if="contractItem.contractPaymentProcedureAndTerms && contractItem.contractPaymentProcedureAndTerms.length >= 1000 && contractItem.contractPaymentProcedureAndTerms.length < 1024" class='max-length-block'>Осталось {{1024 - contractItem.contractPaymentProcedureAndTerms.length}} символов</div>
                                        <v-textarea
                                                rows="5"
                                                v-model="contractItem.contractPaymentProcedureAndTerms"
                                                :rules="requiredRules1024"
                                                maxlength="1024"
                                                :error-messages="inputErrors.contractPaymentProcedureAndTerms"
                                                :disabled="!this.allowFiledEdit"
                                                :append-icon="contractItemChange.contractPaymentProcedureAndTerms ? 'fa-exclamation-triangle' : ''"
                                                required
                                        >
                                            <template slot="label">
                                                Порядок и сроки оплаты товара, работы или услуги <span class='error-file'>*</span>
                                            </template>
                                        </v-textarea>
                                    </v-flex>

                                    <v-flex xs12 field-block>
                                        <div v-if="contractItem.financeSource && contractItem.financeSource.length >= 488 && contractItem.financeSource.length < 512" class='max-length-block'>Осталось {{512 - contractItem.financeSource.length}} символов</div>
                                        <v-textarea
                                                rows="3"
                                                v-model="contractItem.financeSource"
                                                :rules="requiredRules512"
                                                maxlength="512"
                                                :error-messages="inputErrors.financeSource"
                                                :disabled="!this.allowFiledEdit"
                                                :append-icon="contractItemChange.financeSource ? 'fa-exclamation-triangle' : ''"
                                                required
                                        >
                                            <template slot="label">
                                                Источник финансирования <span class='error-file'>*</span>
                                            </template>
                                        </v-textarea>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-select
                                                v-model="contractItem.yearsOfFinancing"
                                                :items="yearsFinancing"
                                                :rules="requiredRules"
                                                multiple
                                                :error-messages="inputErrors.yearsOfFinancing"
                                                :disabled="!this.allowFiledEdit"
                                                :append-icon="contractItemChange.yearsOfFinancing ? 'fa-exclamation-triangle' : ''"
                                                required
                                                :menu-props="{
                                                      transition: 'scale-transition',
                                                      offsetY: true,
                                                }"
                                        >
                                            <template slot="label">
                                                Год финансирования <span class='error-file'>*</span>
                                            </template>
                                        </v-select>
                                    </v-flex>


                                    <v-flex xs12 field-block v-if="contractItem.supplierDefinitionType != 'QUOTATION_REQUEST_EL_FORM' && makeValidNumber(contractItem.startContractPrice) >= 1000000">
                                        <v-layout wrap>
                                            <v-flex xs12 sm10 md10>
                                                <div v-if="requests.provisionSize && requests.provisionSize.length >= 104 && requests.provisionSize.length < 128" class='max-length-block'>Осталось {{128 - requests.provisionSize.length}} символов</div>
                                                <v-text-field v-model="requests.provisionSize" disabled maxlength="128">
                                                    <template slot="label">
                                                        Размер обеспечения заявки (в руб) <span class='error-file'>*</span>
                                                    </template>
                                                </v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm2 md2>
                                                <v-text-field v-model="requests.provisionSizePercent" :append-icon="contractItemChange.provisionSizeRequest ? 'fa-exclamation-triangle' : ''"
                                                              :disabled="!this.allowFiledEdit" suffix="%"
                                                              @blur="minmaxRequest(requests.provisionSizePercent,0,5)"
                                                              @keypress="validateForPrice($event, requests.provisionSizePercent)"
                                                              v-on:keyup="requests.provisionSizePercent = minmaxAmount2(requests.provisionSizePercent, 0, 5)"
                                                              :rules="requests.provisionSize != '' ? rulesPersentRequest : requiredRulesPersentRequest" required>
                                                    <template slot="label">
                                                        Процент (от 0 до 5%)
                                                    </template>
                                                </v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs12 field-block v-if="(contractItem.supplierDefinitionType == 'OPEN_CONTEST_EL_FORM' || contractItem.supplierDefinitionType == 'LIMITED_CONTEST' || contractItem.supplierDefinitionType == 'AUCTION_EL_FORM') && makeValidNumber(contractItem.startContractPrice) > 0">

                                        <v-layout wrap>
                                            <v-flex xs12 sm10 md10>
                                                <div v-if="contractItem.provisionSize && contractItem.provisionSize.length >= 104 && contractItem.provisionSize.length < 128" class='max-length-block'>Осталось {{128 - contractItem.provisionSize.length}} символов</div>

                                                <v-text-field  v-model="contractItem.provisionSize" disabled maxlength="128">
                                                    <template slot="label">
                                                        Размер обеспечения исполнения контракта (в руб) <span class='error-file'>*</span>
                                                    </template>
                                                </v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm2 md2>
                                                <v-text-field v-model="contractItem.provisionSizePercent" :append-icon="contractItemChange.provisionSize ? 'fa-exclamation-triangle' : ''"
                                                              :disabled="!this.allowFiledEdit" suffix="%"
                                                              @blur="minmaxContract(contractItem.provisionSizePercent,0.50,30)"
                                                              @keypress="validateForPrice($event, contractItem.provisionSizePercent)"
                                                              v-on:keyup="contractItem.provisionSizePercent = minmaxAmount2(contractItem.provisionSizePercent, 0.50, 30)"
                                                              :rules="contractItem.provisionSize ? rulesPersentContract : requiredRulesPersentContract">
                                                    <template slot="label">
                                                        Процент (от 0.5 до 30%)
                                                    </template>
                                                </v-text-field>

                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs12 field-block v-else-if="makeValidNumber(contractItem.startContractPrice) > 0">

                                        <v-layout wrap>
                                            <v-flex xs12 sm10 md10>
                                                <div v-if="contractItem.provisionSize && contractItem.provisionSize.length >= 104 && contractItem.provisionSize.length < 128" class='max-length-block'>Осталось {{128 - contractItem.provisionSize.length}} символов</div>

                                                <v-text-field v-model="contractItem.provisionSize" disabled maxlength="128">
                                                    <template slot="label">
                                                        Размер обеспечения исполнения контракта (в руб)
                                                    </template>
                                                </v-text-field>
                                            </v-flex>

                                            <v-flex xs12 sm2 md2>
                                                <v-text-field v-model="contractItem.provisionSizePercent" :append-icon="contractItemChange.provisionSize ? 'fa-exclamation-triangle' : ''"
                                                              :disabled="!this.allowFiledEdit" suffix="%"
                                                              @blur="minmaxContract(contractItem.provisionSizePercent,0,30)"
                                                              @keypress="validateForPrice($event, contractItem.provisionSizePercent)"
                                                              v-on:keyup="contractItem.provisionSizePercent = minmaxAmount2(contractItem.provisionSizePercent, 0, 30)"
                                                              :rules="rulesPersentContract2">
                                                    <template slot="label">
                                                        Процент (от 0 до 30%)
                                                    </template>
                                                </v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-divider></v-divider>
                                        <v-checkbox
                                                color="primary"
                                                :label="`${contractItem.contractConditionsCanBeChanged1 ? 'Предусмотрено' : 'Не предусмотрено'} `"
                                                v-model="contractItem.contractConditionsCanBeChanged1"
                                                :append-icon="contractItemChange.contractConditionsCanBeChanged1 ? 'fa-exclamation-triangle' : ''"
                                                :disabled="!this.allowFiledEdit"
                                        ></v-checkbox>
                                        <label class="v-label">При снижении цены контракта без изменения предусмотренных контрактом количества товара, объема работы или услуги, качества поставляемого товара, выполняемой работы, оказываемой услуги и иных условий контракта</label>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-divider></v-divider>
                                        <v-checkbox
                                                color="primary"
                                                :label="`${contractItem.contractConditionsCanBeChanged2 ? 'Предусмотрено' : 'Не предусмотрено'} `"
                                                v-model="contractItem.contractConditionsCanBeChanged2"
                                                :append-icon="contractItemChange.contractConditionsCanBeChanged2 ? 'fa-exclamation-triangle' : ''"
                                                :disabled="!this.allowFiledEdit"
                                        ></v-checkbox>
                                        <label class="v-label">Если по предложению заказчика увеличиваются/уменьшается предусмотренные контрактом (за исключением работ по строительству, реконструкции, капитальному ремонту, сносу объекта капитального строительства) количество товара, объем работы или услуги не более чем на десять процентов</label>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-divider></v-divider>
                                        <v-checkbox
                                                color="primary"
                                                :label="`${contractItem.contractConditionsCanBeChanged3 ? 'Предусмотрено' : 'Не предусмотрено'} `"
                                                v-model="contractItem.contractConditionsCanBeChanged3"
                                                :append-icon="contractItemChange.contractConditionsCanBeChanged3 ? 'fa-exclamation-triangle' : ''"
                                                :disabled="!this.allowFiledEdit"
                                        ></v-checkbox>
                                        <label class="v-label">При заключении контракта увеличение количества поставляемого товара на сумму, не превышающую разницы между ценой контракта, предложенной таким участником, и начальной (максимальной) ценой контракта (ценой лота)</label>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-divider></v-divider>
                                        <v-checkbox
                                                color="primary"
                                                :label="`${contractItem.contractConditionsCanBeChanged4 ? 'Предусмотрено' : 'Не предусмотрено'} `"
                                                v-model="contractItem.contractConditionsCanBeChanged4"
                                                :append-icon="contractItemChange.contractConditionsCanBeChanged4 ? 'fa-exclamation-triangle' : ''"
                                                :disabled="!this.allowFiledEdit"
                                        ></v-checkbox>
                                        <label class="v-label">При изменении объема и (или) видов выполняемых работ по контракту, предметом которого является выполнение работ по строительству, реконструкции, капитальному ремонту, сносу объекта капитального строительства, проведению работ по сохранению объектов культурного наследия. При этом допускается изменение с учетом положений бюджетного законодательства Российской Федерации цены контракта не более чем на десять процентов цены контракта</label>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-divider></v-divider>
                                        <v-checkbox
                                                color="primary"
                                                :label="`${contractItem.unilateralRefusal ? 'Предусмотрено' : 'Не предусмотрено'} `"
                                                v-model="contractItem.unilateralRefusal"
                                                :append-icon="contractItemChange.unilateralRefusal ? 'fa-exclamation-triangle' : ''"
                                                :disabled="!this.allowFiledEdit"
                                        ></v-checkbox>
                                        <label class="v-label">Возможность одностороннего отказа от исполнения контракта</label>
                                    </v-flex>
                                </v-layout>
                            </v-container>

                        </v-card>

                        <v-card-actions class="step-bottom-block">
                            <v-spacer></v-spacer>
                            <v-btn @click="e1 =1" flat>Назад</v-btn>
                            <v-btn color="primary" @click="validateStep2">Далее</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-stepper-content>

                <v-stepper-content step="3">
                    <v-form ref="form3" lazy-validation>
                        <v-card
                                class="mb-5"
                        >
                            <v-container fluid grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-divider></v-divider>
                                        <v-checkbox
                                                color="primary"
                                                :label="`${contractItem.penalSystemPart ? 'Предусмотрено' : 'Не предусмотрено'} `"
                                                v-model="contractItem.penalSystemPart"
                                                :append-icon="contractItemChange.penalSystemPart ? 'fa-exclamation-triangle' : ''"
                                                :disabled="!this.allowFiledEdit"
                                        ></v-checkbox>
                                        <label class="v-label">Преимущества учреждениям и предприятиям уголовно-исполнительной системы</label>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-divider></v-divider>
                                        <v-checkbox
                                                color="primary"
                                                :label="`${contractItem.disabledPeopleOrgPart ? 'Предусмотрено' : 'Не предусмотрено'} `"
                                                v-model="contractItem.disabledPeopleOrgPart"
                                                :append-icon="contractItemChange.disabledPeopleOrgPart ? 'fa-exclamation-triangle' : ''"
                                                :disabled="!this.allowFiledEdit"
                                        ></v-checkbox>
                                        <label class="v-label">Преимущества организациям инвалидов</label>
                                    </v-flex>

                                    <v-flex xs12 v-if="!((this.role == 'ROLE_ADMIN' || this.role == 'ROLE_EXPERT') && (makeValidNumber(contractItem.startContractPrice) > 20000000 || contractItem.requirementForParticipant))">
                                        <v-divider></v-divider>
                                        <v-tooltip top v-if="makeValidNumber(contractItem.startContractPrice) > 20000000 && contractItem.requirementForParticipant">
                                            <v-checkbox
                                                    slot="activator"
                                                    color="primary"
                                                    disabled
                                                    input-value="false"
                                                    label="Не предусмотрено"
                                                    :append-icon="contractItemChange.definitionCustomerPart ? 'fa-exclamation-triangle' : ''"
                                                    v-model="contractItem.definitionCustomerPart"
                                            ></v-checkbox>
                                            <span>Недоступно, так как Начальная (максимальная) цена контракта больше 20 млн.руб и выбрано "Требование к участнику, не являющемуся субъектом малого предпринимательства или социально ориентированной некоммерческой организацией, о привлечении к исполнению контракта субподрядчиков, соисполнителей из числа субъектов малого предпринимательства, социально ориентированных некоммерческих организаций.</span>
                                        </v-tooltip>
                                        <v-tooltip top v-else-if="makeValidNumber(contractItem.startContractPrice) > 20000000">
                                            <v-checkbox
                                                    slot="activator"
                                                    color="primary"
                                                    disabled
                                                    input-value="false"
                                                    label="Не предусмотрено"
                                                    v-model="contractItem.definitionCustomerPart"
                                                    :append-icon="contractItemChange.definitionCustomerPart ? 'fa-exclamation-triangle' : ''"
                                            ></v-checkbox>
                                            <span>Недоступно, так как Начальная (максимальная) цена контракта больше 20 млн.руб.</span>
                                        </v-tooltip>
                                        <v-tooltip top v-else-if="contractItem.requirementForParticipant">
                                            <v-checkbox
                                                    slot="activator"
                                                    color="primary"
                                                    disabled
                                                    input-value="false"
                                                    label="Не предусмотрено"
                                                    v-model="contractItem.definitionCustomerPart"
                                                    :append-icon="contractItemChange.definitionCustomerPart ? 'fa-exclamation-triangle' : ''"
                                            ></v-checkbox>
                                            <span>Недоступно, так как выбрано "Требование к участнику, не являющемуся субъектом малого предпринимательства или социально ориентированной некоммерческой организацией, о привлечении к исполнению контракта субподрядчиков, соисполнителей из числа субъектов малого предпринимательства, социально ориентированных некоммерческих организаций"</span>
                                        </v-tooltip>
                                        <v-checkbox
                                                v-else
                                                slot="activator"
                                                color="primary"
                                                :disabled="!this.allowFiledEdit"
                                                :label="`${contractItem.definitionCustomerPart ? 'Предусмотрено' : 'Не предусмотрено'} `"
                                                v-model="contractItem.definitionCustomerPart"
                                                :append-icon="contractItemChange.definitionCustomerPart ? 'fa-exclamation-triangle' : ''"
                                        ></v-checkbox>
                                        <label class="v-label">Участие в определении поставщика (подрядчика, исполнителя) субъектов малого предпринимательства или социально ориентированных некоммерческих организаций</label>
                                    </v-flex>


                                    <v-flex xs12 v-if="!((this.role == 'ROLE_ADMIN' || this.role == 'ROLE_EXPERT') && contractItem.definitionCustomerPart)">
                                        <v-divider></v-divider>
                                        <v-tooltip top v-if="contractItem.definitionCustomerPart">
                                            <v-checkbox
                                                    slot="activator"
                                                    color="primary"
                                                    input-value="false"
                                                    disabled
                                                    :label="`${contractItem.requirementForParticipant && !contractItem.definitionCustomerPart ? 'предусмотрено' : 'Не предусмотрено'} `"
                                                    v-model="contractItem.requirementForParticipant"
                                                    :append-icon="contractItemChange.requirementForParticipant ? 'fa-exclamation-triangle' : ''"
                                            ></v-checkbox>
                                            <span>Недоступно, так как выбрано "Участие в определении поставщика (подрядчика, исполнителя) субъектов малого предпринимательства или социально ориентированных некоммерческих организаций" </span>
                                        </v-tooltip>
                                        <v-checkbox
                                                v-else
                                                slot="activator"
                                                color="primary"
                                                :disabled="!this.allowFiledEdit"
                                                :label="`${contractItem.requirementForParticipant ? 'Предусмотрено' : 'Не предусмотрено'} `"
                                                v-model="contractItem.requirementForParticipant"
                                                :append-icon="contractItemChange.requirementForParticipant ? 'fa-exclamation-triangle' : ''"
                                        ></v-checkbox>
                                        <label class="v-label">Требование к участнику, не являющемуся субъектом малого предпринимательства или социально ориентированной некоммерческой организацией, о привлечении к исполнению контракта субподрядчиков, соисполнителей из числа субъектов малого предпринимательства, социально ориентированных некоммерческих организаций
                                        </label>
                                    </v-flex>
                                    <v-flex xs12 field-block v-if="contractItem.requirementForParticipant">
                                        <div v-if="contractItem.attractionPercent && contractItem.attractionPercent.length >= 104 && contractItem.attractionPercent.length < 128" class='max-length-block'>Осталось {{128 - contractItem.attractionPercent.length}} символов</div>

                                        <v-text-field  v-model="contractItem.attractionPercent" :append-icon="contractItemChange.attractionPercent ? 'fa-exclamation-triangle' : ''" :rules="requiredRules128" suffix="%" mask="###" v-on:keyup="contractItem.attractionPercent = minmaxAmount(contractItem.attractionPercent, 1, 100)">
                                            <template slot="label">
                                                Объем привлечения (в процентах) <span class='error-file'>*</span>
                                            </template>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 field-block>
                                        <v-divider v-if="!contractItem.requirementForParticipant" style="margin-bottom: 20px;"></v-divider>
                                        <div v-if="contractItem.fz_44 && contractItem.fz_44.length >= 1000 && contractItem.fz_44.length < 1024" class='max-length-block'>Осталось {{1024 - contractItem.fz_44.length}} символов</div>
                                        <v-textarea
                                                v-model="contractItem.fz_44"
                                                :rules="requiredRules1024"
                                                maxlength="1024"
                                                rows="6"
                                                :error-messages="inputErrors.fz_44"
                                                :disabled="!this.allowFiledEdit"
                                                :append-icon="contractItemChange.fz_44 ? 'fa-exclamation-triangle' : ''"
                                                required
                                        >
                                            <template slot="label">
                                                Требование к участнику в соответствии с пунктом 1 части 1 и частью 2 статьи 31 Федерального закона №44-ФЗ <span class='error-file'>*</span>
                                            </template>
                                        </v-textarea>
                                    </v-flex>
                                </v-layout>
                            </v-container>

                        </v-card>

                        <v-card-actions class="step-bottom-block">
                            <v-spacer></v-spacer>
                            <v-btn flat @click="e1 =2">Назад</v-btn>
                            <v-btn color="primary" @click="validateStep3">Далее</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-stepper-content>

                <v-stepper-content step="4">
                    <v-card
                            class="mb-5"
                    >
                        <v-container fluid grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <label class="v-label theme--light">
                                        Обоснование потребности в планируемой закупке и ее соответствие мероприятию соответствующей муниципальной программы: обоснования закупок товаров, работ и услуг для обеспечения государственных и муниципальных нужд при формировании и утверждении плана закупок
                                        <span v-if="requiredStatus('procurementPlan')" class="error-file">*</span>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" class="file-info">
                                                    <img src="@/assets/hint-icon.svg" >
                                                </div>
                                            </template>
                                            <span> Поддерживаемые типы файлов: .bmp ,.gif, .jpeg, .jpg, .jpe, .jp2, .png, .raw, .tga, .tiff, .tif, .wdp, .hdp, .xpm, .pdn, .pdf</span>
                                        </v-tooltip>
                                    </label>
                                    <file-pond
                                            v-if="hideFiles"
                                            ref="procurementPlanpond"
                                            :label-idle="this.allowFiledEdit ? 'Прикрепить файлы.. ' : ''"
                                            allow-multiple="true"
                                            :accepted-file-types="FileTypes1"
                                            labelFileTypeNotAllowed="Файл недопустимого типа"
                                            fileValidateTypeLabelExpectedTypes="Допустимы .bmp ,.gif, .jpeg, .jpg, .jpe, .jp2, .png, .raw, .tga, .tiff, .tif, .wdp, .hdp, .xpm, .pdn, .pdf"
                                            v-bind:documentInfo="procurementPlanFilesDetails"
                                            :fileValidateTypeDetectType="detectorFunction1"
                                    />
                                    <div v-if="procurementPlanFilesDetails.length > 0">
                                        <span v-for="(item1,index) in procurementPlanFilesDetails" :key="index">
                                            <span v-if="!item1.deleteStatus" class="download-block">
                                                <v-tooltip top>
                                                       <v-btn slot="activator" small color="blue-grey" class="white--text download-file" @click="saveFile(item1)">{{item1.filename}}
                                                            <v-icon right dark>fa-download</v-icon>
                                                       </v-btn>
                                                      <span>Скачать файл</span>
                                                </v-tooltip>
                                                <v-tooltip v-if="hideFiles" top>
                                                      <v-btn slot="activator" small flat icon color="error" class="remove-file" @click="deleteFile(item1)">
                                                           <v-icon>fa-trash</v-icon>
                                                      </v-btn>
                                                      <span>Удалить файл</span>
                                                </v-tooltip>
                                             </span>
                                        </span>
                                    </div>
                                    <div v-else-if="!hideFiles" class="error-file">Нет прикрепленных файлов</div>
                                    <span class="error-file">{{fileErrors.procurementPlan}}</span>
                                    <v-divider v-if="!hideFiles"></v-divider>
                                </v-flex>
                                <v-flex xs12>
                                    <label class="v-label theme--light">
                                        Обоснование потребности в планируемой закупке и ее соответствие мероприятию соответствующей муниципальной программы: обоснования закупок товаров, работ и услуг для обеспечения государственных и муниципальных нужд при формировании и утверждении плана-графика закупок
                                        <span v-if="requiredStatus('procurementSchedule')" class="error-file">*</span>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" class="file-info">
                                                    <img src="@/assets/hint-icon.svg" >
                                                </div>
                                            </template>
                                            <span> Поддерживаемые типы файлов: .bmp ,.gif, .jpeg, .jpg, .jpe, .jp2, .png, .raw, .tga, .tiff, .tif, .wdp, .hdp, .xpm, .pdn, .pdf</span>
                                        </v-tooltip>
                                    </label>
                                    <file-pond
                                            v-if="hideFiles"
                                            ref="procurementSchedulepond"
                                            :label-idle="this.allowFiledEdit ? 'Прикрепить файлы..' : ''"
                                            allow-multiple="true"
                                            :accepted-file-types="FileTypes1"
                                            labelFileTypeNotAllowed="Файл недопустимого типа"
                                            fileValidateTypeLabelExpectedTypes="Допустимы .bmp ,.gif, .jpeg, .jpg, .jpe, .jp2, .png, .raw, .tga, .tiff, .tif, .wdp, .hdp, .xpm, .pdn, .pdf"
                                            v-bind:documentInfo="procurementScheduleFilesDetails"
                                            :fileValidateTypeDetectType="detectorFunction1"
                                    />
                                    <div v-if="procurementScheduleFilesDetails.length > 0">
                                        <span v-for="(item1,index) in procurementScheduleFilesDetails" :key="index">
                                            <span v-if="!item1.deleteStatus" class="download-block">
                                                <v-tooltip top>
                                                       <v-btn slot="activator" small color="blue-grey" class="white--text download-file" @click="saveFile(item1)">{{item1.filename}}
                                                            <v-icon right dark>fa-download</v-icon>
                                                       </v-btn>
                                                      <span>Скачать файл</span>
                                                </v-tooltip>
                                                <v-tooltip v-if="hideFiles" top>
                                                      <v-btn slot="activator" small flat icon color="error" class="remove-file" @click="deleteFile(item1)">
                                                           <v-icon>fa-trash</v-icon>
                                                      </v-btn>
                                                      <span>Удалить файл</span>
                                                </v-tooltip>
                                             </span>
                                        </span>
                                    </div>
                                    <div v-else-if="!hideFiles" class="error-file">Нет прикрепленных файлов</div>
                                    <span class="error-file">{{fileErrors.procurementSchedule}}</span>
                                    <v-divider v-if="!hideFiles"></v-divider>
                                </v-flex>
                                <v-flex xs12>
                                    <label class="v-label theme--light">
                                        Техническое задание
                                        <span v-if="requiredStatus('technicalTask')" class="error-file">*</span>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" class="file-info">
                                                    <img src="@/assets/hint-icon.svg" >
                                                </div>
                                            </template>
                                            <span> Поддерживаемые типы файлов: .odt, .docx, .doc, .docm, .xlsx, .xls</span>
                                        </v-tooltip>
                                    </label>
                                    <file-pond
                                            v-if="hideFiles"
                                            ref="technicalTaskpond"
                                            :label-idle="this.allowFiledEdit ? 'Прикрепить файлы..' : ''"
                                            allow-multiple="true"
                                            :accepted-file-types="FileTypes8"
                                            labelFileTypeNotAllowed="Файл недопустимого типа"
                                            fileValidateTypeLabelExpectedTypes="Допустимы .odt, .docx, .doc, .docm, .xlsx, .xls"
                                            v-bind:documentInfo="technicalTaskFilesDetails"
                                            :fileValidateTypeDetectType="detectorFunction8"
                                    />
                                    <div v-if="technicalTaskFilesDetails.length > 0">
                                         <span v-for="(item1,index) in technicalTaskFilesDetails" :key="index">
                                        <span v-if="!item1.deleteStatus" class="download-block">
                                            <v-tooltip top>
                                                   <v-btn slot="activator" small color="blue-grey" class="white--text download-file" @click="saveFile(item1)">{{item1.filename}}
                                                        <v-icon right dark>fa-download</v-icon>
                                                   </v-btn>
                                                  <span>Скачать файл</span>
                                            </v-tooltip>
                                            <v-tooltip v-if="hideFiles" top>
                                                  <v-btn slot="activator" small flat icon color="error" class="remove-file" @click="deleteFile(item1)">
                                                       <v-icon>fa-trash</v-icon>
                                                  </v-btn>
                                                  <span>Удалить файл</span>
                                            </v-tooltip>
                                         </span>
                                    </span>
                                    </div>
                                    <div v-else-if="!hideFiles" class="error-file">Нет прикрепленных файлов</div>
                                    <span class="error-file">{{fileErrors.technicalTask}}</span>
                                    <v-divider v-if="!hideFiles"></v-divider>
                                </v-flex>
                                <v-flex xs12>
                                    <label class="v-label theme--light">
                                        Сметы
                                        <span v-if="requiredStatus('estimates')" class="error-file">*</span>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" class="file-info">
                                                    <img src="@/assets/hint-icon.svg" >
                                                </div>
                                            </template>
                                            <span> Поддерживаемые типы файлов: .pdf</span>
                                        </v-tooltip>
                                    </label>
                                    <file-pond
                                            v-if="hideFiles"
                                            ref="estimatespond"
                                            :label-idle="this.allowFiledEdit ? 'Прикрепить файлы..' : ''"
                                            allow-multiple="true"
                                            accepted-file-types="application/pdf"
                                            labelFileTypeNotAllowed="Файл недопустимого типа"
                                            fileValidateTypeLabelExpectedTypes="Допустимы .pdf"
                                            v-bind:documentInfo="estimatesFilesDetails"
                                    />
                                    <div v-if="estimatesFilesDetails.length > 0">
                                        <span v-for="(item1,index) in estimatesFilesDetails" :key="index">
                                            <span v-if="!item1.deleteStatus" class="download-block">
                                                <v-tooltip top>
                                                       <v-btn slot="activator" small color="blue-grey" class="white--text download-file" @click="saveFile(item1)">{{item1.filename}}
                                                            <v-icon right dark>fa-download</v-icon>
                                                       </v-btn>
                                                      <span>Скачать файл</span>
                                                </v-tooltip>
                                                <v-tooltip v-if="hideFiles" top>
                                                      <v-btn slot="activator" small flat icon color="error" class="remove-file" @click="deleteFile(item1)">
                                                           <v-icon>fa-trash</v-icon>
                                                      </v-btn>
                                                      <span>Удалить файл</span>
                                                </v-tooltip>
                                             </span>
                                        </span>
                                    </div>
                                    <div v-else-if="!hideFiles" class="error-file">Нет прикрепленных файлов</div>
                                    <span class="error-file">{{fileErrors.estimates}}</span>
                                    <v-divider v-if="!hideFiles"></v-divider>
                                </v-flex>
                                <v-flex xs12>
                                    <label class="v-label theme--light">
                                        Дефектные ведомости
                                        <span v-if="requiredStatus('defectiveStatements')" class="error-file">*</span>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" class="file-info">
                                                    <img src="@/assets/hint-icon.svg" >
                                                </div>
                                            </template>
                                            <span> Поддерживаемые типы файлов: .pdf</span>
                                        </v-tooltip>
                                    </label>
                                    <file-pond
                                            v-if="hideFiles"
                                            ref="defectiveStatementspond"
                                            :label-idle="this.allowFiledEdit ? 'Прикрепить файлы..' : ''"
                                            allow-multiple="true"
                                            accepted-file-types="application/pdf"
                                            labelFileTypeNotAllowed="Файл недопустимого типа"
                                            fileValidateTypeLabelExpectedTypes="Допустимы .pdf"
                                            v-bind:documentInfo="defectiveStatementsFilesDetails"
                                    />
                                    <div v-if="defectiveStatementsFilesDetails.length > 0">
                                        <span v-for="(item1,index) in defectiveStatementsFilesDetails" :key="index">
                                            <span v-if="!item1.deleteStatus" class="download-block">
                                                <v-tooltip top>
                                                       <v-btn slot="activator" small color="blue-grey" class="white--text download-file" @click="saveFile(item1)">{{item1.filename}}
                                                            <v-icon right dark>fa-download</v-icon>
                                                       </v-btn>
                                                      <span>Скачать файл</span>
                                                </v-tooltip>
                                                <v-tooltip v-if="hideFiles" top>
                                                      <v-btn slot="activator" small flat icon color="error" class="remove-file" @click="deleteFile(item1)">
                                                           <v-icon>fa-trash</v-icon>
                                                      </v-btn>
                                                      <span>Удалить файл</span>
                                                </v-tooltip>
                                             </span>
                                        </span>
                                    </div>
                                    <div v-else-if="!hideFiles" class="error-file">Нет прикрепленных файлов</div>
                                    <span class="error-file">{{fileErrors.defectiveStatements}}</span>
                                    <v-divider v-if="!hideFiles"></v-divider>
                                </v-flex>
                                <v-flex xs12>
                                    <label class="v-label theme--light">
                                        Проекты
                                        <span v-if="requiredStatus('projects')" class="error-file">*</span>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" class="file-info">
                                                    <img src="@/assets/hint-icon.svg" >
                                                </div>
                                            </template>
                                            <span> Поддерживаемые типы файлов: .pdf, .7z, .rar, .zip</span>
                                        </v-tooltip>
                                    </label>
                                    <file-pond
                                            v-if="hideFiles"
                                            ref="projectspond"
                                            :label-idle="this.allowFiledEdit ? 'Прикрепить файлы..' : ''"
                                            allow-multiple="true"
                                            :accepted-file-types="FileTypes3"
                                            labelFileTypeNotAllowed="Файл недопустимого типа"
                                            fileValidateTypeLabelExpectedTypes="Допустимы .pdf, .7z, .rar, .zip"
                                            v-bind:documentInfo="projectsFilesDetails"
                                            :fileValidateTypeDetectType="detectorFunction3"
                                    />
                                    <div v-if="projectsFilesDetails.length > 0">
                                        <span v-for="(item1,index) in projectsFilesDetails" :key="index">
                                            <span v-if="!item1.deleteStatus" class="download-block">
                                                <v-tooltip top>
                                                       <v-btn slot="activator" small color="blue-grey" class="white--text download-file" @click="saveFile(item1)">{{item1.filename}}
                                                            <v-icon right dark>fa-download</v-icon>
                                                       </v-btn>
                                                      <span>Скачать файл</span>
                                                </v-tooltip>
                                                <v-tooltip v-if="hideFiles" top>
                                                      <v-btn slot="activator" small flat icon color="error" class="remove-file" @click="deleteFile(item1)">
                                                           <v-icon>fa-trash</v-icon>
                                                      </v-btn>
                                                      <span>Удалить файл</span>
                                                </v-tooltip>
                                             </span>
                                        </span>
                                    </div>
                                    <div v-else-if="!hideFiles" class="error-file">Нет прикрепленных файлов</div>
                                    <span class="error-file">{{fileErrors.projects}}</span>
                                    <v-divider v-if="!hideFiles"></v-divider>
                                </v-flex>
                                <v-flex xs12>
                                    <label class="v-label theme--light">
                                        Эскизы
                                        <span v-if="requiredStatus('sketches')" class="error-file">*</span>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" class="file-info">
                                                    <img src="@/assets/hint-icon.svg" >
                                                </div>
                                            </template>
                                            <span> Поддерживаемые типы файлов: .bmp ,.gif, .jpeg, .jpg, .jpe, .jp2, .png, .raw, .tga, .tiff, .tif, .wdp, .hdp, .xpm, .pdn, .pdf, .7z, .rar, .zip</span>
                                        </v-tooltip>
                                    </label>
                                    <file-pond
                                            v-if="hideFiles"
                                            ref="sketchespond"
                                            :label-idle="this.allowFiledEdit ? 'Прикрепить файлы..' : ''"
                                            allow-multiple="true"
                                            :accepted-file-types="FileTypes4"
                                            labelFileTypeNotAllowed="Файл недопустимого типа"
                                            fileValidateTypeLabelExpectedTypes="Допустимы .bmp ,.gif, .jpeg, .jpg, .jpe, .jp2, .png, .raw, .tga, .tiff, .tif, .wdp, .hdp, .xpm, .pdn, .pdf, .7z, .rar, .zip"
                                            v-bind:documentInfo="sketchesFilesDetails"
                                            :fileValidateTypeDetectType="detectorFunction4"
                                    />
                                    <div v-if="sketchesFilesDetails.length > 0">
                                        <span v-for="(item1,index) in sketchesFilesDetails" :key="index">
                                            <span v-if="!item1.deleteStatus" class="download-block">
                                                <v-tooltip top>
                                                       <v-btn slot="activator" small color="blue-grey" class="white--text download-file" @click="saveFile(item1)">{{item1.filename}}
                                                            <v-icon right dark>fa-download</v-icon>
                                                       </v-btn>
                                                      <span>Скачать файл</span>
                                                </v-tooltip>
                                                <v-tooltip v-if="hideFiles" top>
                                                      <v-btn slot="activator" small flat icon color="error" class="remove-file" @click="deleteFile(item1)">
                                                           <v-icon>fa-trash</v-icon>
                                                      </v-btn>
                                                      <span>Удалить файл</span>
                                                </v-tooltip>
                                             </span>
                                        </span>
                                    </div>
                                    <div v-else-if="!hideFiles" class="error-file">Нет прикрепленных файлов</div>
                                    <span class="error-file">{{fileErrors.sketches}}</span>
                                    <v-divider v-if="!hideFiles"></v-divider>
                                </v-flex>
                                <v-flex xs12>
                                    <label class="v-label theme--light">
                                        Требования к функциональным характеристикам (потребительским свойствам) товара (показатели, связанные с определением соответствия поставляемого товара, выполняемых работ, оказываемых услуг потребностям Заказчика) «Форма 2»
                                        <span v-if="requiredStatus('performanceRequirements')" class="error-file">*</span>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" class="file-info">
                                                    <img src="@/assets/hint-icon.svg" >
                                                </div>
                                            </template>
                                            <span> Поддерживаемые типы файлов: .odt, .docx, .doc, .docm</span>
                                        </v-tooltip>
                                    </label>
                                    <file-pond
                                            v-if="hideFiles"
                                            ref="performanceRequirementspond"
                                            :label-idle="this.allowFiledEdit ? 'Прикрепить файлы..' : ''"
                                            allow-multiple="true"
                                            :accepted-file-types="FileTypes2"
                                            labelFileTypeNotAllowed="Файл недопустимого типа"
                                            fileValidateTypeLabelExpectedTypes="Допустимы .odt, .docx, .doc, .docm"
                                            v-bind:documentInfo="performanceRequirementsFilesDetails"
                                            :fileValidateTypeDetectType="detectorFunction2"
                                    />
                                    <div v-if="performanceRequirementsFilesDetails.length > 0">
                                        <span v-for="(item1,index) in performanceRequirementsFilesDetails" :key="index">
                                            <span v-if="!item1.deleteStatus" class="download-block">
                                                <v-tooltip top>
                                                       <v-btn slot="activator" small color="blue-grey" class="white--text download-file" @click="saveFile(item1)">{{item1.filename}}
                                                            <v-icon right dark>fa-download</v-icon>
                                                       </v-btn>
                                                      <span>Скачать файл</span>
                                                </v-tooltip>
                                                <v-tooltip v-if="hideFiles" top>
                                                      <v-btn slot="activator" small flat icon color="error" class="remove-file" @click="deleteFile(item1)">
                                                           <v-icon>fa-trash</v-icon>
                                                      </v-btn>
                                                      <span>Удалить файл</span>
                                                </v-tooltip>
                                             </span>
                                        </span>
                                    </div>
                                    <div v-else-if="!hideFiles" class="error-file">Нет прикрепленных файлов</div>
                                    <span class="error-file">{{fileErrors.performanceRequirements}}</span>
                                    <v-divider v-if="!hideFiles"></v-divider>
                                </v-flex>
                                <v-flex xs12>
                                    <label class="v-label theme--light">
                                        Соглашение на предоставление целевой субсидии
                                        <span v-if="requiredStatus('targetedSubsidySubmission')" class="error-file">*</span>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" class="file-info">
                                                    <img src="@/assets/hint-icon.svg" >
                                                </div>
                                            </template>
                                            <span> Поддерживаемые типы файлов: .pdf</span>
                                        </v-tooltip>
                                    </label>
                                    <file-pond
                                            v-if="hideFiles"
                                            ref="targetedSubsidySubmissionpond"
                                            :label-idle="this.allowFiledEdit ? 'Прикрепить файлы..' : ''"
                                            allow-multiple="true"
                                            accepted-file-types="application/pdf"
                                            labelFileTypeNotAllowed="Файл недопустимого типа"
                                            fileValidateTypeLabelExpectedTypes="Допустимы .pdf"
                                            v-bind:documentInfo="targetedSubsidySubmissionFilesDetails"
                                    />
                                    <div v-if="targetedSubsidySubmissionFilesDetails.length > 0">
                                        <span v-for="(item1,index) in targetedSubsidySubmissionFilesDetails" :key="index">
                                            <span v-if="!item1.deleteStatus" class="download-block">
                                                <v-tooltip top>
                                                       <v-btn slot="activator" small color="blue-grey" class="white--text download-file" @click="saveFile(item1)">{{item1.filename}}
                                                            <v-icon right dark>fa-download</v-icon>
                                                       </v-btn>
                                                      <span>Скачать файл</span>
                                                </v-tooltip>
                                                <v-tooltip v-if="hideFiles" top>
                                                      <v-btn slot="activator" small flat icon color="error" class="remove-file" @click="deleteFile(item1)">
                                                           <v-icon>fa-trash</v-icon>
                                                      </v-btn>
                                                      <span>Удалить файл</span>
                                                </v-tooltip>
                                             </span>
                                        </span>
                                    </div>
                                    <div v-else-if="!hideFiles" class="error-file">Нет прикрепленных файлов</div>
                                    <span class="error-file">{{fileErrors.targetedSubsidySubmission}}</span>
                                    <v-divider v-if="!hideFiles"></v-divider>
                                </v-flex>
                                <v-flex xs12>
                                    <label class="v-label theme--light">
                                        Ценовая информация, используемая для расчета начальной максимальной цены контракта, в том числе для расчета проектно-сметным методом и расчет с обоснованием начальной (максимальной) цены контракта (договора)
                                        <span v-if="requiredStatus('priceInfo')" class="error-file">*</span>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" class="file-info">
                                                    <img src="@/assets/hint-icon.svg" >
                                                </div>
                                            </template>
                                            <span> Поддерживаемые типы файлов: .bmp ,.gif, .jpeg, .jpg, .jpe, .jp2, .png, .raw, .tga, .tiff, .tif, .wdp, .hdp, .xpm, .pdn, .pdf, .7z, .rar, .zip</span>
                                        </v-tooltip>
                                    </label>
                                    <file-pond
                                            v-if="hideFiles"
                                            ref="priceInfopond"
                                            :label-idle="this.allowFiledEdit ? 'Прикрепить файлы..' : ''"
                                            allow-multiple="true"
                                            :accepted-file-types="FileTypes4"
                                            labelFileTypeNotAllowed="Файл недопустимого типа"
                                            fileValidateTypeLabelExpectedTypes="Допустимы .bmp ,.gif, .jpeg, .jpg, .jpe, .jp2, .png, .raw, .tga, .tiff, .tif, .wdp, .hdp, .xpm, .pdn, .pdf, .7z, .rar, .zip"
                                            v-bind:documentInfo="priceInfoFilesDetails"
                                            :fileValidateTypeDetectType="detectorFunction4"
                                    />
                                    <div v-if="priceInfoFilesDetails.length > 0">
                                        <span v-for="(item1,index) in priceInfoFilesDetails" :key="index">
                                            <span v-if="!item1.deleteStatus" class="download-block">
                                                <v-tooltip top>
                                                       <v-btn slot="activator" small color="blue-grey" class="white--text download-file" @click="saveFile(item1)">{{item1.filename}}
                                                            <v-icon right dark>fa-download</v-icon>
                                                       </v-btn>
                                                      <span>Скачать файл</span>
                                                </v-tooltip>
                                                <v-tooltip v-if="hideFiles" top>
                                                      <v-btn slot="activator" small flat icon color="error" class="remove-file" @click="deleteFile(item1)">
                                                           <v-icon>fa-trash</v-icon>
                                                      </v-btn>
                                                      <span>Удалить файл</span>
                                                </v-tooltip>
                                             </span>
                                        </span>
                                    </div>
                                    <div v-else-if="!hideFiles" class="error-file">Нет прикрепленных файлов</div>
                                    <span class="error-file">{{fileErrors.priceInfo}}</span>
                                    <v-divider v-if="!hideFiles"></v-divider>
                                </v-flex>
                                <v-flex xs12>
                                    <label class="v-label theme--light">
                                        Обоснование необходимости выплаты аванса (в случае, если Заказчиком принято решение о выплате аванса по контракту (договору)
                                        <span v-if="requiredStatus('infoForAdvancePayment')" class="error-file">*</span>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" class="file-info">
                                                    <img src="@/assets/hint-icon.svg" >
                                                </div>
                                            </template>
                                            <span> Поддерживаемые типы файлов: .bmp ,.gif, .jpeg, .jpg, .jpe, .jp2, .png, .raw, .tga, .tiff, .tif, .wdp, .hdp, .xpm, .pdn, .pdf</span>
                                        </v-tooltip>
                                    </label>
                                    <file-pond
                                            v-if="hideFiles"
                                            ref="infoForAdvancePaymentpond"
                                            :label-idle="this.allowFiledEdit ? 'Прикрепить файлы..' : ''"
                                            allow-multiple="true"
                                            :accepted-file-types="FileTypes1"
                                            labelFileTypeNotAllowed="Файл недопустимого типа"
                                            fileValidateTypeLabelExpectedTypes="Допустимы .bmp ,.gif, .jpeg, .jpg, .jpe, .jp2, .png, .raw, .tga, .tiff, .tif, .wdp, .hdp, .xpm, .pdn, .pdf"
                                            v-bind:documentInfo="infoForAdvancePaymentFilesDetails"
                                            :fileValidateTypeDetectType="detectorFunction1"
                                    />
                                    <div v-if="infoForAdvancePaymentFilesDetails.length > 0">
                                        <span v-for="(item1,index) in infoForAdvancePaymentFilesDetails" :key="index">
                                             <span v-if="!item1.deleteStatus" class="download-block">
                                                <v-tooltip top>
                                                       <v-btn slot="activator" small color="blue-grey" class="white--text download-file" @click="saveFile(item1)">{{item1.filename}}
                                                            <v-icon right dark>fa-download</v-icon>
                                                       </v-btn>
                                                      <span>Скачать файл</span>
                                                </v-tooltip>
                                                <v-tooltip v-if="hideFiles" top>
                                                      <v-btn slot="activator" small flat icon color="error" class="remove-file" @click="deleteFile(item1)">
                                                           <v-icon>fa-trash</v-icon>
                                                      </v-btn>
                                                      <span>Удалить файл</span>
                                                </v-tooltip>
                                             </span>
                                        </span>
                                    </div>
                                    <div v-else-if="!hideFiles" class="error-file">Нет прикрепленных файлов</div>
                                    <span class="error-file">{{fileErrors.infoForAdvancePayment}}</span>
                                    <v-divider v-if="!hideFiles"></v-divider>
                                </v-flex>
                                <v-flex xs12>
                                    <label class="v-label theme--light">
                                        Проект контракта (договора) (в случае определения поставщика (подрядчика, исполнителя) по нескольким лотам - проект контракта (договора) в отношении каждого лота)
                                        <span v-if="requiredStatus('contractProject')" class="error-file">*</span>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" class="file-info">
                                                    <img src="@/assets/hint-icon.svg" >
                                                </div>
                                            </template>
                                            <span> Поддерживаемые типы файлов: .odt, .docx, .doc, .docm</span>
                                        </v-tooltip>
                                    </label>
                                    <file-pond
                                            v-if="hideFiles"
                                            ref="contractProjectpond"
                                            :label-idle="this.allowFiledEdit ? 'Прикрепить файлы..' : ''"
                                            allow-multiple="true"
                                            :accepted-file-types="FileTypes2"
                                            labelFileTypeNotAllowed="Файл недопустимого типа"
                                            fileValidateTypeLabelExpectedTypes="Допустимы .odt, .docx, .doc, .docm"
                                            v-bind:documentInfo="contractProjectFilesDetails"
                                            :fileValidateTypeDetectType="detectorFunction2"
                                    />
                                    <div v-if="contractProjectFilesDetails.length > 0">
                                        <span v-for="(item1,index) in contractProjectFilesDetails" :key="index">
                                            <span v-if="!item1.deleteStatus" class="download-block">
                                                <v-tooltip top>
                                                       <v-btn slot="activator" small color="blue-grey" class="white--text download-file" @click="saveFile(item1)">{{item1.filename}}
                                                            <v-icon right dark>fa-download</v-icon>
                                                       </v-btn>
                                                      <span>Скачать файл</span>
                                                </v-tooltip>
                                                <v-tooltip v-if="hideFiles" top>
                                                      <v-btn slot="activator" small flat icon color="error" class="remove-file" @click="deleteFile(item1)">
                                                           <v-icon>fa-trash</v-icon>
                                                      </v-btn>
                                                      <span>Удалить файл</span>
                                                </v-tooltip>
                                             </span>
                                        </span>
                                    </div>
                                    <div v-else-if="!hideFiles" class="error-file">Нет прикрепленных файлов</div>
                                    <span class="error-file">{{fileErrors.contractProject}}</span>
                                    <v-divider v-if="!hideFiles"></v-divider>
                                </v-flex>
                                <v-flex xs12>
                                    <label class="v-label theme--light">
                                        Приложение к Проекту контракта (ПИК)
                                        <span v-if="requiredStatus('contractProjectApplication')" class="error-file">*</span>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" class="file-info">
                                                    <img src="@/assets/hint-icon.svg" >
                                                </div>
                                            </template>
                                            <span> Поддерживаемые типы файлов: .odt, .docx, .doc, .docm</span>
                                        </v-tooltip>
                                    </label>
                                    <file-pond
                                            v-if="hideFiles"
                                            ref="contractProjectApplicationpond"
                                            :label-idle="this.allowFiledEdit ? 'Прикрепить файлы..' : ''"
                                            allow-multiple="true"
                                            :accepted-file-types="FileTypes2"
                                            labelFileTypeNotAllowed="Файл недопустимого типа"
                                            fileValidateTypeLabelExpectedTypes="Допустимы .odt, .docx, .doc, .docm"
                                            v-bind:documentInfo="contractProjectApplicationFilesDetails"
                                            :fileValidateTypeDetectType="detectorFunction2"
                                    />
                                    <div v-if="contractProjectApplicationFilesDetails.length > 0">
                                        <span v-for="(item1,index) in contractProjectApplicationFilesDetails" :key="index">
                                            <span v-if="!item1.deleteStatus" class="download-block">
                                                <v-tooltip top>
                                                       <v-btn slot="activator" small color="blue-grey" class="white--text download-file" @click="saveFile(item1)">{{item1.filename}}
                                                            <v-icon right dark>fa-download</v-icon>
                                                       </v-btn>
                                                      <span>Скачать файл</span>
                                                </v-tooltip>
                                                <v-tooltip v-if="hideFiles" top>
                                                      <v-btn slot="activator" small flat icon color="error" class="remove-file" @click="deleteFile(item1)">
                                                           <v-icon>fa-trash</v-icon>
                                                      </v-btn>
                                                      <span>Удалить файл</span>
                                                </v-tooltip>
                                             </span>
                                        </span>
                                    </div>
                                    <div v-else-if="!hideFiles" class="error-file">Нет прикрепленных файлов</div>
                                    <span class="error-file">{{fileErrors.contractProjectApplication}}</span>
                                    <v-divider v-if="!hideFiles"></v-divider>
                                </v-flex>
                                <v-flex xs12 v-if="contractItem.supplierDefinitionType == 'OPEN_CONTEST_EL_FORM' || contractItem.supplierDefinitionType == 'LIMITED_CONTEST'">
                                    <label class="v-label theme--light">
                                        Критерии и порядок оценки заявок на участие в конкурсе с указанием значимости каждого из критериев
                                        <span v-if="requiredStatus('evaluationRules')" class="error-file">*</span>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" class="file-info">
                                                    <img src="@/assets/hint-icon.svg" >
                                                </div>
                                            </template>
                                            <span> Поддерживаемые типы файлов: .odt, .docx, .doc, .docm</span>
                                        </v-tooltip>
                                    </label>
                                    <file-pond
                                            v-if="hideFiles"
                                            ref="evaluationRulespond"
                                            :label-idle="this.allowFiledEdit ? 'Прикрепить файлы..' : ''"
                                            allow-multiple="true"
                                            :accepted-file-types="FileTypes2"
                                            labelFileTypeNotAllowed="Файл недопустимого типа"
                                            fileValidateTypeLabelExpectedTypes="Допустимы .odt, .docx, .doc, .docm"
                                            v-bind:documentInfo="evaluationRulesFilesDetails"
                                            :fileValidateTypeDetectType="detectorFunction2"
                                    />
                                    <div v-if="evaluationRulesFilesDetails.length > 0">
                                        <span v-for="(item1,index) in evaluationRulesFilesDetails" :key="index">
                                            <span v-if="!item1.deleteStatus" class="download-block">
                                                <v-tooltip top>
                                                       <v-btn slot="activator" small color="blue-grey" class="white--text download-file" @click="saveFile(item1)">{{item1.filename}}
                                                            <v-icon right dark>fa-download</v-icon>
                                                       </v-btn>
                                                      <span>Скачать файл</span>
                                                </v-tooltip>
                                                <v-tooltip v-if="hideFiles" top>
                                                      <v-btn slot="activator" small flat icon color="error" class="remove-file" @click="deleteFile(item1)">
                                                           <v-icon>fa-trash</v-icon>
                                                      </v-btn>
                                                      <span>Удалить файл</span>
                                                </v-tooltip>
                                             </span>
                                        </span>
                                    </div>
                                    <div v-else-if="!hideFiles" class="error-file">Нет прикрепленных файлов</div>
                                     <span class="error-file">{{fileErrors.evaluationRules}}</span>
                                    <v-divider v-if="!hideFiles"></v-divider>
                                </v-flex>
                                <v-flex xs12>
                                    <label class="v-label theme--light">
                                        Обоснование начальной (максимальной) цены контракта
                                        <span v-if="requiredStatus('infoForStartContractPrice')" class="error-file">*</span>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" class="file-info">
                                                    <img src="@/assets/hint-icon.svg" >
                                                </div>
                                            </template>
                                            <span> Поддерживаемые типы файлов: .bmp ,.gif, .jpeg, .jpg, .jpe, .jp2, .png, .raw, .tga, .tiff, .tif, .wdp, .hdp, .xpm, .pdn, .pdf</span>
                                        </v-tooltip>
                                    </label>
                                    <file-pond
                                            v-if="hideFiles"
                                            ref="infoForStartContractPricepond"
                                            :label-idle="this.allowFiledEdit ? 'Прикрепить файлы..' : ''"
                                            allow-multiple="true"
                                            :accepted-file-types="FileTypes1"
                                            labelFileTypeNotAllowed="Файл недопустимого типа"
                                            fileValidateTypeLabelExpectedTypes="Допустимы .bmp ,.gif, .jpeg, .jpg, .jpe, .jp2, .png, .raw, .tga, .tiff, .tif, .wdp, .hdp, .xpm, .pdn, .pdf"
                                            v-bind:documentInfo="infoForStartContractPriceFilesDetails"
                                            :fileValidateTypeDetectType="detectorFunction1"
                                    />
                                    <div v-if="infoForStartContractPriceFilesDetails.length > 0">
                                        <span v-for="(item1,index) in infoForStartContractPriceFilesDetails" :key="index">
                                            <span v-if="!item1.deleteStatus" class="download-block">
                                                <v-tooltip top>
                                                       <v-btn slot="activator" small color="blue-grey" class="white--text download-file" @click="saveFile(item1)">{{item1.filename}}
                                                            <v-icon right dark>fa-download</v-icon>
                                                       </v-btn>
                                                      <span>Скачать файл</span>
                                                </v-tooltip>
                                                <v-tooltip v-if="hideFiles" top>
                                                      <v-btn slot="activator" small flat icon color="error" class="remove-file" @click="deleteFile(item1)">
                                                           <v-icon>fa-trash</v-icon>
                                                      </v-btn>
                                                      <span>Удалить файл</span>
                                                </v-tooltip>
                                             </span>
                                        </span>
                                    </div>
                                    <div v-else-if="!hideFiles" class="error-file">Нет прикрепленных файлов</div>
                                    <span class="error-file">{{fileErrors.infoForStartContractPrice}}</span>
                                    <v-divider v-if="!hideFiles"></v-divider>
                                </v-flex>
                                <v-flex xs12>
                                    <label class="v-label theme--light">
                                        Расчет начальной (максимальной) цены контракта
                                        <span v-if="requiredStatus('startContractPriceCalc')" class="error-file">*</span>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" class="file-info">
                                                    <img src="@/assets/hint-icon.svg" >
                                                </div>
                                            </template>
                                            <span> Поддерживаемые типы файлов: .odt, .docx, .doc, .docm, .pdf, .xlsx, .xls</span>
                                        </v-tooltip>
                                    </label>
                                    <file-pond
                                            v-if="hideFiles"
                                            ref="startContractPriceCalcpond"
                                            :label-idle="this.allowFiledEdit ? 'Прикрепить файлы..' : ''"
                                            allow-multiple="true"
                                            :accepted-file-types="FileTypes7"
                                            labelFileTypeNotAllowed="Файл недопустимого типа"
                                            fileValidateTypeLabelExpectedTypes="Допустимы .odt, .docx, .doc, .docm, .pdf, .xlsx, .xls"
                                            v-bind:documentInfo="startContractPriceCalcFilesDetails"
                                            :fileValidateTypeDetectType="detectorFunction7"
                                    />
                                    <div v-if="startContractPriceCalcFilesDetails.length > 0">
                                        <span v-for="(item1,index) in startContractPriceCalcFilesDetails" :key="index">
                                            <span v-if="!item1.deleteStatus" class="download-block">
                                                <v-tooltip top>
                                                       <v-btn slot="activator" small color="blue-grey" class="white--text download-file" @click="saveFile(item1)">{{item1.filename}}
                                                            <v-icon right dark>fa-download</v-icon>
                                                       </v-btn>
                                                      <span>Скачать файл</span>
                                                </v-tooltip>
                                                <v-tooltip v-if="hideFiles" top>
                                                      <v-btn slot="activator" small flat icon color="error" class="remove-file" @click="deleteFile(item1)">
                                                           <v-icon>fa-trash</v-icon>
                                                      </v-btn>
                                                      <span>Удалить файл</span>
                                                </v-tooltip>
                                             </span>
                                        </span>
                                    </div>
                                    <div v-else-if="!hideFiles" class="error-file">Нет прикрепленных файлов</div>
                                    <span class="error-file">{{fileErrors.startContractPriceCalc}}</span>
                                    <v-divider v-if="!hideFiles"></v-divider>
                                </v-flex>
                                <v-flex xs12>
                                    <label class="v-label theme--light">
                                        Подтверждение Финансирования / письмо ГРБС
                                        <span v-if="requiredStatus('financingProof')" class="error-file">*</span>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" class="file-info">
                                                    <img src="@/assets/hint-icon.svg" >
                                                </div>
                                            </template>
                                            <span> Поддерживаемые типы файлов: .bmp ,.gif, .jpeg, .jpg, .jpe, .jp2, .png, .raw, .tga, .tiff, .tif, .wdp, .hdp, .xpm, .pdn, .pdf</span>
                                        </v-tooltip>
                                    </label>
                                    <file-pond
                                            v-if="hideFiles"
                                            ref="financingProofpond"
                                            :label-idle="this.allowFiledEdit ? 'Прикрепить файлы..' : ''"
                                            allow-multiple="true"
                                            :accepted-file-types="FileTypes1"
                                            labelFileTypeNotAllowed="Файл недопустимого типа"
                                            fileValidateTypeLabelExpectedTypes="Допустимы .bmp ,.gif, .jpeg, .jpg, .jpe, .jp2, .png, .raw, .tga, .tiff, .tif, .wdp, .hdp, .xpm, .pdn, .pdf"
                                            v-bind:documentInfo="financingProofFilesDetails"
                                            :fileValidateTypeDetectType="detectorFunction1"
                                    />
                                    <div v-if="financingProofFilesDetails.length > 0">
                                        <span v-for="(item1,index) in financingProofFilesDetails" :key="index">
                                            <span v-if="!item1.deleteStatus" class="download-block">
                                                <v-tooltip top>
                                                       <v-btn slot="activator" small color="blue-grey" class="white--text download-file" @click="saveFile(item1)">{{item1.filename}}
                                                            <v-icon right dark>fa-download</v-icon>
                                                       </v-btn>
                                                      <span>Скачать файл</span>
                                                </v-tooltip>
                                                <v-tooltip v-if="hideFiles" top>
                                                      <v-btn slot="activator" small flat icon color="error" class="remove-file" @click="deleteFile(item1)">
                                                           <v-icon>fa-trash</v-icon>
                                                      </v-btn>
                                                      <span>Удалить файл</span>
                                                </v-tooltip>
                                             </span>
                                        </span>
                                    </div>
                                    <div v-else-if="!hideFiles" class="error-file">Нет прикрепленных файлов</div>
                                    <span class="error-file">{{fileErrors.financingProof}}</span>
                                    <v-divider v-if="!hideFiles"></v-divider>
                                </v-flex>
                                <v-flex xs12>
                                    <label class="v-label theme--light">
                                        Скан образ, подтверждающий наличие закупки в Плане-графике в ЕИС
                                        <span v-if="requiredStatus('presenceInEIS')" class="error-file">*</span>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" class="file-info">
                                                    <img src="@/assets/hint-icon.svg" >
                                                </div>
                                            </template>
                                            <span> Поддерживаемые типы файлов: .bmp ,.gif, .jpeg, .jpg, .jpe, .jp2, .png, .raw, .tga, .tiff, .tif, .wdp, .hdp, .xpm, .pdn, .pdf</span>
                                        </v-tooltip>
                                    </label>
                                    <file-pond
                                            v-if="hideFiles"
                                            ref="presenceInEISpond"
                                            :label-idle="this.allowFiledEdit ? 'Прикрепить файлы..' : ''"
                                            allow-multiple="true"
                                            :accepted-file-types="FileTypes1"
                                            labelFileTypeNotAllowed="Файл недопустимого типа"
                                            fileValidateTypeLabelExpectedTypes="Допустимы .bmp ,.gif, .jpeg, .jpg, .jpe, .jp2, .png, .raw, .tga, .tiff, .tif, .wdp, .hdp, .xpm, .pdn, .pdf"
                                            v-bind:documentInfo="presenceInEISFilesDetails"
                                            :fileValidateTypeDetectType="detectorFunction1"
                                    />
                                    <div v-if="presenceInEISFilesDetails.length > 0">
                                        <span v-for="(item1,index) in presenceInEISFilesDetails" :key="index">
                                            <span v-if="!item1.deleteStatus" class="download-block">
                                                <v-tooltip top>
                                                       <v-btn slot="activator" small color="blue-grey" class="white--text download-file" @click="saveFile(item1)">{{item1.filename}}
                                                            <v-icon right dark>fa-download</v-icon>
                                                       </v-btn>
                                                      <span>Скачать файл</span>
                                                </v-tooltip>
                                                <v-tooltip v-if="hideFiles" top>
                                                      <v-btn slot="activator" small flat icon color="error" class="remove-file" @click="deleteFile(item1)">
                                                           <v-icon>fa-trash</v-icon>
                                                      </v-btn>
                                                      <span>Удалить файл</span>
                                                </v-tooltip>
                                             </span>
                                        </span>
                                    </div>
                                    <div v-else-if="!hideFiles" class="error-file">Нет прикрепленных файлов</div>
                                    <span class="error-file">{{fileErrors.presenceInEIS}}</span>
                                    <v-divider v-if="!hideFiles"></v-divider>
                                </v-flex>
                                <v-flex xs12>
                                    <label class="v-label theme--light">
                                        Скан образ, подтверждающий наличие закупки в Плане-графике в ЕАСУЗ
                                        <span v-if="requiredStatus('presenceInEASUZ')" class="error-file">*</span>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" class="file-info">
                                                    <img src="@/assets/hint-icon.svg" >
                                                </div>
                                            </template>
                                            <span> Поддерживаемые типы файлов: .bmp ,.gif, .jpeg, .jpg, .jpe, .jp2, .png, .raw, .tga, .tiff, .tif, .wdp, .hdp, .xpm, .pdn, .pdf, .odt, .docx, .doc, .docm</span>
                                        </v-tooltip>
                                    </label>
                                    <file-pond
                                            v-if="hideFiles"
                                            ref="presenceInEASUZpond"
                                            :label-idle="this.allowFiledEdit ? 'Прикрепить файлы..' : ''"
                                            allow-multiple="true"
                                            :accepted-file-types="FileTypes5"
                                            labelFileTypeNotAllowed="Файл недопустимого типа"
                                            fileValidateTypeLabelExpectedTypes="Допустимы .bmp ,.gif, .jpeg, .jpg, .jpe, .jp2, .png, .raw, .tga, .tiff, .tif, .wdp, .hdp, .xpm, .pdn, .pdf, .odt, .docx, .doc, .docm"
                                            v-bind:documentInfo="presenceInEASUZFilesDetails"
                                            :fileValidateTypeDetectType="detectorFunction5"
                                    />
                                    <div v-if="presenceInEASUZFilesDetails.length > 0">
                                        <span v-for="(item1,index) in presenceInEASUZFilesDetails" :key="index">
                                            <span v-if="!item1.deleteStatus" class="download-block">
                                                <v-tooltip top>
                                                       <v-btn slot="activator" small color="blue-grey" class="white--text download-file" @click="saveFile(item1)">{{item1.filename}}
                                                            <v-icon right dark>fa-download</v-icon>
                                                       </v-btn>
                                                      <span>Скачать файл</span>
                                                </v-tooltip>
                                                <v-tooltip v-if="hideFiles" top>
                                                      <v-btn slot="activator" small flat icon color="error" class="remove-file" @click="deleteFile(item1)">
                                                           <v-icon>fa-trash</v-icon>
                                                      </v-btn>
                                                      <span>Удалить файл</span>
                                                </v-tooltip>
                                             </span>
                                        </span>
                                    </div>
                                    <div v-else-if="!hideFiles" class="error-file">Нет прикрепленных файлов</div>
                                    <span class="error-file">{{fileErrors.presenceInEASUZ}}</span>
                                    <v-divider v-if="!hideFiles"></v-divider>
                                </v-flex>
                                <v-flex xs12>
                                    <label class="v-label theme--light">
                                        Скан образ, подтверждающий наличие сформированной карточки в ПИК ЕАСУЗ
                                        <span v-if="requiredStatus('presenceInPIK')" class="error-file">*</span>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" class="file-info">
                                                    <img src="@/assets/hint-icon.svg" >
                                                </div>
                                            </template>
                                            <span> Поддерживаемые типы файлов: .bmp ,.gif, .jpeg, .jpg, .jpe, .jp2, .png, .raw, .tga, .tiff, .tif, .wdp, .hdp, .xpm, .pdn, .pdf, .odt, .docx, .doc, .docm</span>
                                        </v-tooltip>
                                    </label>
                                    <file-pond
                                            v-if="hideFiles"
                                            ref="presenceInPIKpond"
                                            :label-idle="this.allowFiledEdit ? 'Прикрепить файлы..' : ''"
                                            allow-multiple="true"
                                            :accepted-file-types="FileTypes5"
                                            labelFileTypeNotAllowed="Файл недопустимого типа"
                                            fileValidateTypeLabelExpectedTypes="Допустимы .bmp ,.gif, .jpeg, .jpg, .jpe, .jp2, .png, .raw, .tga, .tiff, .tif, .wdp, .hdp, .xpm, .pdn, .pdf, .odt, .docx, .doc, .docm"
                                            v-bind:documentInfo="presenceInPIKFilesDetails"
                                            :fileValidateTypeDetectType="detectorFunction5"
                                    />
                                    <div v-if="presenceInPIKFilesDetails.length > 0">
                                        <span v-for="(item1,index) in presenceInPIKFilesDetails" :key="index">
                                            <span v-if="!item1.deleteStatus" class="download-block">
                                                <v-tooltip top>
                                                       <v-btn slot="activator" small color="blue-grey" class="white--text download-file" @click="saveFile(item1)">{{item1.filename}}
                                                            <v-icon right dark>fa-download</v-icon>
                                                       </v-btn>
                                                      <span>Скачать файл</span>
                                                </v-tooltip>
                                                <v-tooltip v-if="hideFiles" top>
                                                      <v-btn slot="activator" small flat icon color="error" class="remove-file" @click="deleteFile(item1)">
                                                           <v-icon>fa-trash</v-icon>
                                                      </v-btn>
                                                      <span>Удалить файл</span>
                                                </v-tooltip>
                                             </span>
                                        </span>
                                    </div>
                                    <div v-else-if="!hideFiles" class="error-file">Нет прикрепленных файлов</div>
                                    <span class="error-file">{{fileErrors.presenceInPIK}}</span>
                                    <v-divider v-if="!hideFiles"></v-divider>
                                </v-flex>
                                <v-flex xs12>
                                    <label class="v-label theme--light">
                                        Письмо о включении в состав комиссии
                                        <span v-if="requiredStatus('letterToAddToCommission')" class="error-file">*</span>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" class="file-info">
                                                    <img src="@/assets/hint-icon.svg" >
                                                </div>
                                            </template>
                                            <span> Поддерживаемые типы файлов: .bmp ,.gif, .jpeg, .jpg, .jpe, .jp2, .png, .raw, .tga, .tiff, .tif, .wdp, .hdp, .xpm, .pdn, .pdf</span>
                                        </v-tooltip>
                                    </label>
                                    <file-pond
                                            v-if="hideFiles"
                                            ref="letterToAddToCommissionpond"
                                            :label-idle="this.allowFiledEdit ? 'Прикрепить файлы..' : ''"
                                            allow-multiple="true"
                                            :accepted-file-types="FileTypes1"
                                            labelFileTypeNotAllowed="Файл недопустимого типа"
                                            fileValidateTypeLabelExpectedTypes="Допустимы .bmp ,.gif, .jpeg, .jpg, .jpe, .jp2, .png, .raw, .tga, .tiff, .tif, .wdp, .hdp, .xpm, .pdn, .pdf"
                                            v-bind:documentInfo="letterToAddToCommissionFilesDetails"
                                            :fileValidateTypeDetectType="detectorFunction1"
                                    />
                                    <div v-if="letterToAddToCommissionFilesDetails.length > 0">
                                        <span v-for="(item1,index) in letterToAddToCommissionFilesDetails" :key="index">
                                            <span v-if="!item1.deleteStatus" class="download-block">
                                                <v-tooltip top>
                                                       <v-btn slot="activator" small color="blue-grey" class="white--text download-file" @click="saveFile(item1)">{{item1.filename}}
                                                            <v-icon right dark>fa-download</v-icon>
                                                       </v-btn>
                                                      <span>Скачать файл</span>
                                                </v-tooltip>
                                                <v-tooltip v-if="hideFiles" top>
                                                      <v-btn slot="activator" small flat icon color="error" class="remove-file" @click="deleteFile(item1)">
                                                           <v-icon>fa-trash</v-icon>
                                                      </v-btn>
                                                      <span>Удалить файл</span>
                                                </v-tooltip>
                                             </span>
                                        </span>
                                    </div>
                                    <div v-else-if="!hideFiles" class="error-file">Нет прикрепленных файлов</div>
                                    <span class="error-file">{{fileErrors.letterToAddToCommission}}</span>
                                    <v-divider v-if="!hideFiles"></v-divider>
                                </v-flex>
                                <v-flex xs12>
                                    <label class="v-label theme--light">
                                        Иные документы по усмотрению Заказчика, подтверждающие обоснованность и целесообразность планируемой закупки
                                        <span v-if="requiredStatus('otherFiles')" class="error-file">*</span>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" class="file-info">
                                                    <img src="@/assets/hint-icon.svg" >
                                                </div>
                                            </template>
                                            <span> Поддерживаемые типы файлов: .bmp ,.gif, .jpeg, .jpg, .jpe, .jp2, .png, .raw, .tga, .tiff, .tif, .wdp, .hdp, .xpm, .pdn, .pdf, .odt, .docx, .doc, .docm, .7z, .rar, .zip, .xlsx, .xls</span>
                                        </v-tooltip>
                                    </label>
                                    <file-pond
                                            v-if="hideFiles"
                                            ref="otherFilespond"
                                            :label-idle="this.allowFiledEdit ? 'Прикрепить файлы..' : ''"
                                            allow-multiple="true"
                                            :accepted-file-types="FileTypes6"
                                            labelFileTypeNotAllowed="Файл недопустимого типа"
                                            fileValidateTypeLabelExpectedTypes="Допустимы .bmp ,.gif, .jpeg, .jpg, .jpe, .jp2, .png, .raw, .tga, .tiff, .tif, .wdp, .hdp, .xpm, .pdn, .pdf, .odt, .docx, .doc, .docm, .7z, .rar, .zip, .xlsx, .xls"
                                            v-bind:documentInfo="otherFilesFilesDetails"
                                            :fileValidateTypeDetectType="detectorFunction6"
                                    />
                                    <div v-if="otherFilesFilesDetails.length > 0">
                                        <span v-for="(item1,index) in otherFilesFilesDetails" :key="index">
                                            <span v-if="!item1.deleteStatus" class="download-block">
                                                <v-tooltip top>
                                                       <v-btn slot="activator" small color="blue-grey" class="white--text download-file" @click="saveFile(item1)">{{item1.filename}}
                                                            <v-icon right dark>fa-download</v-icon>
                                                       </v-btn>
                                                      <span>Скачать файл</span>
                                                </v-tooltip>
                                                <v-tooltip v-if="hideFiles" top>
                                                      <v-btn slot="activator" small flat icon color="error" class="remove-file" @click="deleteFile(item1)">
                                                           <v-icon>fa-trash</v-icon>
                                                      </v-btn>
                                                      <span>Удалить файл</span>
                                                </v-tooltip>
                                             </span>
                                        </span>
                                    </div>
                                    <div v-else-if="!hideFiles" class="error-file">Нет прикрепленных файлов</div>
                                    <span class="error-file">{{fileErrors.otherFiles}}</span>
                                    <v-divider v-if="!hideFiles"></v-divider>
                                </v-flex>
                            </v-layout>
                        </v-container>

                    </v-card>

                    <v-card-actions class="step-bottom-block">
                        <v-spacer></v-spacer>
                        <v-btn flat @click="e1 =3">Назад</v-btn>
                        <v-btn v-if="this.allowFiledEdit" color="blue darken-1" flat @click="save">Сохранить</v-btn>
                    </v-card-actions>

                </v-stepper-content>

                <v-stepper-content step="comments">

                    <v-card class="mb-5 comment-block">

                        <v-timeline v-if="this.commentsTotal">
                            <v-timeline-item v-for="(item,index) in comments" :key="index" color="primary" small>

                                <span slot="opposite">{{item.createdBy}}</span>
                                <v-card class="elevation-2">
                                    <v-card-title>
                                        <b>{{showStatus(item.status)}}</b>
                                        <v-spacer></v-spacer>
                                        <span>{{convertDate(item.createdAt)}} </span></v-card-title>
                                    <v-card-text>{{item.comment}}</v-card-text>
                                    <v-card-text>
                                    <span v-for="(item1,index2) in item.files" :key="index2">
                                            <v-tooltip top>
                                                   <v-btn slot="activator" small color="blue-grey" class="white--text download-file" @click="saveFile(item1)">{{item1.filename}}
                                                        <v-icon right dark>fa-download</v-icon>
                                                   </v-btn>
                                                  <span>Скачать файл</span>
                                            </v-tooltip>
                                    </span>
                                    </v-card-text>
                                </v-card>
                            </v-timeline-item>
                        </v-timeline>
                        <span v-else>Нет истории изменений</span>
                        <div class="text-xs-center comment-paging">
                            <v-pagination
                                    v-model="commentsPagination"
                                    :length="pages"
                                    :total-visible="7"
                                    @input="getComments(requests.id)"
                            ></v-pagination>
                        </div>
                    </v-card>

                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>

    </v-container>
</template>

<script>
    import Vue from 'vue'
    import axios from 'axios'

    import {validateForPrice} from '@/helpers/numbers/validateForPrice';
    import {decimalPriceFormat} from '@/helpers/numbers/decimalPriceFormat';
    import {makeValidNumber} from '@/helpers/numbers/makeValidNumber';

    // Import Vue FilePond
    import vueFilePond from 'vue-filepond';

    // Import plugins
    import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js';

    // Import FilePond styles
    import 'filepond/dist/filepond.min.css';

    // Create component
    const FilePond = vueFilePond(FilePondPluginFileValidateType);

    export default{

        components: {
            FilePond
        },

        data: () => ({
            backUrl: null,
            commentsPagination: 1,
            rowsPerPage: 10,
            commentsTotal: null,
            isRequestChanged: true,
            cancelChangeStatus:{
                status:false
            },
            duplicateDialog: false,
            supplierDefinitionInfoDialog: false,
            emptyDocumentDialog: false,
            saveLoading: false,
            successRequest: false,
            menuDate: false,
            isInputActive: false,
            validStep1: true,
            allowFiledEdit: true,
            hideFiles: true,
            dialog: false,
            saveDialog: false,
            errorDialog: false,
            step: '',
            errFileName: null,
            errorMessage: null,
            requiredDocuments: [],

            procurementPlanFilesDetails: [],
            procurementScheduleFilesDetails: [],
            technicalTaskFilesDetails: [],
            estimatesFilesDetails: [],
            defectiveStatementsFilesDetails: [],
            projectsFilesDetails: [],
            sketchesFilesDetails: [],
            performanceRequirementsFilesDetails: [],
            targetedSubsidySubmissionFilesDetails: [],
            priceInfoFilesDetails: [],
            infoForAdvancePaymentFilesDetails: [],
            contractProjectFilesDetails: [],
            contractProjectApplicationFilesDetails: [],
            evaluationRulesFilesDetails: [],
            infoForStartContractPriceFilesDetails: [],
            startContractPriceCalcFilesDetails: [],
            financingProofFilesDetails: [],
            presenceInEISFilesDetails: [],
            presenceInEASUZFilesDetails: [],
            presenceInPIKFilesDetails: [],
            letterToAddToCommissionFilesDetails: [],
            otherFilesFilesDetails: [],

            accountDetails2: [],
            accountDetailsItems: [],
            accountDetailsItemsFiltered: [],
            comments: [],
            accountInputErrors: [],
            myFiles: '',
            contactInfo: [],

            fileErrors:{
                // procurementPlan: null,
                // procurementSchedule: null,
                // technicalTask: null,
                // evaluationRules: null,
                // infoForStartContractPrice: null,
                // startContractPriceCalc: null,
                // contractProject: null,
                // contractProjectApplication: null,
                // presenceInEIS: null,
                // presenceInEASUZ: null,
                // presenceInPIK: null,
                // letterToAddToCommission: null,
            },

            requests: {
                provisionSize: '',
                provisionSizePercent: null,
                procurementPlan: null,
                procurementSchedule: null,
                technicalTask: null,
                estimates: null,
                defectiveStatements: null,
                projects: null,
                sketches: null,
                performanceRequirements: null,
                targetedSubsidySubmission: null,
                priceInfo: null,
                infoForAdvancePayment: null,
                contractProject: null,
                contractProjectApplication: null,
                evaluationRules: null,
                infoForStartContractPrice: null,
                startContractPriceCalc: null,
                financingProof: null,
                presenceInEIS: null,
                presenceInEASUZ: null,
                presenceInPIK: null,
                letterToAddToCommission: null,
                otherFiles: null,
            },

            customerItem: {
                name: '',
                inn: '',
                address: '',
                mailAddress: '',
                phone: '',
                email: '',
            },

            accountEditedItem:{
                inn: '',
                kpp: '',
                account: '',
                bic: '',
                correspondentAccount: '',
                bankName: '',
                goalCode: '',
            },

            contractItemOld: {},

            contractItem:{
                contractDocumentName: '',
                contractDocumentNumber: '',
                contractDocumentDate: '',
                contractManagerFIO: '',
                contractManagerPhone: '',
                contractManagerEmail: '',
                name: '',
                supplierDefinitionType: '',
                purchaseRegNumber: '',
                purchaseId:'',
                startContractPrice:'',
                justificationMethod: null,
                otherTaxInPrice:'',
                startServicePrice:'',
                startServiceUnitsSum: null,
                maxContractPrice: null,
                contractExecutionPlace: null,
                contractExecutionDeadline: null,
                contractPaymentProcedureAndTerms: null,
                financeSource: '',
                yearsOfFinancing: null,
                provisionSize:null,
                provisionSizePercent:null,
                undefinedQuantityUnitsSupplied: false,
                contractConditionsCanBeChanged1: false,
                contractConditionsCanBeChanged2: false,
                contractConditionsCanBeChanged3: false,
                contractConditionsCanBeChanged4:false,
                unilateralRefusal:false,
                attractionPercent:'',
                definitionCustomerPart:false,
                penalSystemPart:false,
                disabledPeopleOrgPart:false,
                requirementForParticipant:false,
                fz_44:'',
                accountDetailsId: '',
            },

            contractItemChangeOld: {},

            contractItemChange:{
                contractDocumentName: false,
                contractDocumentNumber: false,
                contractDocumentDate: false,
                contractManagerFIO: false,
                contractManagerPhone: false,
                contractManagerEmail: false,
                name: false,
                supplierDefinitionType: false,
                purchaseRegNumber: false,
                purchaseId: false,
                startContractPrice: false,
                justificationMethod: false,
                otherTaxInPrice: false,
                startServicePrice: false,
                startServiceUnitsSum: false,
                maxContractPrice: false,
                contractExecutionPlace: false,
                contractExecutionDeadline: false,
                contractPaymentProcedureAndTerms: false,
                financeSource: false,
                yearsOfFinancing: false,
                provisionSize: false,
                provisionSizeRequest: false,
                undefinedQuantityUnitsSupplied: false,
                contractConditionsCanBeChanged1: false,
                contractConditionsCanBeChanged2: false,
                contractConditionsCanBeChanged3: false,
                contractConditionsCanBeChanged4: false,
                unilateralRefusal: false,
                attractionPercent: false,
                definitionCustomerPart:false,
                penalSystemPart:false,
                disabledPeopleOrgPart:false,
                requirementForParticipant:false,
                fz_44: false,
                accountDetailsId: '',
            },

            inputErrors:[],

            requiredRulesPersentRequest: [
              v => (v == 0 || !!v)|| 'Значение должно быть заполнено',
              v => (makeValidNumber(v) >= 0 && makeValidNumber(v) <= 5 && v !== '') || 'Должно быть от 0 до 5%'
            ],
            requiredRulesPersentContract: [
              v => !!v || 'Значение должно быть заполнено',
              v => (makeValidNumber(v) >= 0.50 && makeValidNumber(v) <= 30) || 'Должно быть от 5 до 30%'
            ],
            rulesPersentRequest: [
              v => ((makeValidNumber(v) >= 0 && makeValidNumber(v) <= 5) || !v) || 'Должно быть от 0 до 5%'
            ],
            rulesPersentContract: [
              v => ((makeValidNumber(v) >= 0.50 && makeValidNumber(v) <= 30) || !v) || 'Должно быть от 5 до 30%'
            ],
            rulesPersentContract2: [
                v => (((makeValidNumber(v) >= 0.50 && makeValidNumber(v) <= 30) || v == 0) || !v) || 'Должно быть от 5 до 30%'
            ],
            requiredRules2048: [
                v => !!v || 'Значение должно быть заполнено',
                v => (v && v.length <= 2048) || 'Должно быть не более 2048 символов'
            ],
            requiredRules1024: [
                v => !!v || 'Значение должно быть заполнено',
                v => (v && v.length <= 1024) || 'Должно быть не более 1024 символов'
            ],
            requiredRules512: [
                v => !!v || 'Значение должно быть заполнено',
                v => (v && v.length <= 512) || 'Должно быть не более 512 символов'
            ],
            requiredRules256: [
                v => !!v || 'Значение должно быть заполнено',
                v => (v && v.length <= 256) || 'Должно быть не более 256 символов'
            ],
            requiredRules128: [
                v => !!v || 'Значение должно быть заполнено',
            ],
            purchaseRegNumberRules: [
                v => !!v || 'Значение должно быть заполнено',
                v => (v.length == 8) || 'Должен содержать 8 цифр'
            ],
            purchaseIdRules: [
                v => !!v || 'Значение должно быть заполнено',
                v => (v && v.length == 36) || 'Должен содержать 36 цифр'
            ],
            requiredRules200: [
                v => !!v || 'Значение должно быть заполнено',
                v => (v && v.length <= 200) || 'Должно быть не более 200 символов'
            ],
            emailRules: [
                v => !!v || 'Значение должно быть заполнено',
                v => v.length <= 100 || 'Должно быть не более 100 символов',
                v => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(v) || 'Адрес элетронной почты должен быть действительным'
                },
            ],
            innRules: [
                v => !!v || 'Значение должно быть заполнено',
                v => (v && v.length == 10) || 'Должен содержать 10 цифр',
            ],
            phoneRules: [
                v => !!v || 'Значение должно быть заполнено',
                v => (v && v.length == 10) || 'Введите телефон в формате +7 (ххх) ххх-хх-хх'
            ],
            requiredRules: [
                v => !!v || 'Значение должно быть заполнено',
            ],

            supplierDefinitionTypes: [
                {
                    name: "Аукцион в электронной форме",
                    val: "AUCTION_EL_FORM"
                },
                {
                    name: "Электронный аукцион на проведение работ по строительству, реконструкции, кап. ремонту, сносу объекта кап. строительства, предусматривающих проектную документацию",
                    val: "CONSTRUCTION_AUCTION_EL_FORM"
                },
                {
                    name: "Открытый конкурс в электронной форме",
                    val: "OPEN_CONTEST_EL_FORM"
                },
                {
                    name: "Конкурс с ограниченным участием",
                    val: "LIMITED_CONTEST"
                },
                {
                    name: "Конкурс с ограниченным участием в электронной форме",
                    val: "LIMITED_CONTEST_EL_FORM"
                },
                {
                    name: "Двухэтапный конкурс в электронной форме",
                    val: "TWO_STAGE_CONTEST_EL_FORM"
                },
                {
                    name: "Запрос котировок в электронной форме",
                    val: "QUOTATION_REQUEST_EL_FORM"
                },
                {
                    name: "Запрос котировок в электронной форме в целях оказания гуманитарной помощи либо ликвидации последствий чрезвычайных ситуаций природного или техногенного характера",
                    val: "HUMANITARIAN_AID_QUOTATION_REQUEST_EL_FORM"
                },
                {
                    name: "Запрос предложений в электронной форме",
                    val: "OFFER_REQUEST_EL_FORM"
                },
                {
                    name: "Закупка товара в случаях, предусмотренных пунктами 4 и 5 части 1 ст. 93 в электронной форме с использованием электронной площадки",
                    val: "SINGLE_SUPPLIER_PURCHASE_EL_FORM"
                }
            ],
            justificationMethodItems: [
                {
                    name: "Метод сопоставимых рыночных цен (анализа рынка)",
                    val: "COMPARABLE_MARKET_PRICE"
                },
                {
                    name: "Нормативный метод",
                    val: "NORMATIVE"
                },
                {
                    name: "Тарифный метод",
                    val: "TARIFF"
                },
                {
                    name: "Проектно-сметный метод",
                    val: "DESIGN_ESTIMATE"
                },
                {
                    name: "Затратный метод",
                    val: "COSTLY"
                },
                {
                    name: "Иной метод",
                    val: "OTHER"
                }
            ],
            allowSave: false,
            token:'',
            role:'',
            user_id:'',
            e1: 0,
            requestsForFiles: [],
            files: [],
            test: [],
            requestParams: [],
            requestParamsId: '',

            FileTypes1:[
                'image/bmp',
                'image/x-bmp',
                'image/x-bitmap',
                'image/x-xbitmap',
                'image/x-win-bitmap',
                'image/x-windows-bmp',
                'image/ms-bmp',
                'image/x-ms-bmp' ,
                'application/bmp',
                'application/x-bmp',
                'application/x-win-bitmap',
                'image/gif',
                'image/jpeg',
                'image/jp2',
                'image/png',
                'image/RAW',
                'image/x-dcraw',
                'application/tga',
                'application/x-tga',
                'application/x-targa' ,
                'image/tga',
                'image/x-tga',
                'image/targa',
                'image/x-targa',
                'image/tiff',
                'image/vnd.ms-photo',
                'image/x-xpixmap',
                'image/x-paintnet',
                'application/pdf',
                'customType',
            ],

            FileTypes2: [
                'application/vnd.oasis.opendocument.text',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/msword',
                'application/vnd.ms-word.document.macroEnabled.12',
                'customType',
            ],

            FileTypes3: [
                'application/pdf',
                'application/x-7z-compressed',
                'application/octet-stream',
                'application/x-rar-compressed',
                'application/zip',
                'application/x-zip',
                'application/x-zip-compressed',
                'application/x-compress',
                'application/x-compressed',
                'multipart/x-zip',
                'customType',
            ],

            FileTypes4: [
                'image/bmp',
                'image/x-bmp',
                'image/x-bitmap',
                'image/x-xbitmap',
                'image/x-win-bitmap',
                'image/x-windows-bmp',
                'image/ms-bmp',
                'image/x-ms-bmp',
                'application/bmp',
                'application/x-bmp',
                'application/x-win-bitmap',
                'image/gif',
                'image/jpeg',
                'image/jp2',
                'image/png',
                'image/x-dcraw',
                'application/tga',
                'application/x-tga',
                'application/x-targa',
                'image/tga',
                'image/x-tga',
                'image/targa',
                'image/RAW',
                'image/x-targa',
                'image/tiff',
                'image/vnd.ms-photo',
                'image/x-xpixmap',
                'image/x-paintnet',
                'application/pdf',
                'application/x-7z-compressed',
                'application/x-rar-compressed',
                'application/octet-stream',
                'application/zip',
                'application/x-zip',
                'application/x-zip-compressed',
                'application/octet-stream',
                'application/x-compress',
                'application/x-compressed',
                'multipart/x-zip',
                'customType',

            ],

            FileTypes5:[
                'image/bmp',
                'image/x-bmp',
                'image/x-bitmap',
                'image/x-xbitmap',
                'image/x-win-bitmap',
                'image/x-windows-bmp',
                'image/ms-bmp',
                'image/x-ms-bmp',
                'application/bmp',
                'application/x-bmp',
                'application/x-win-bitmap',
                'image/gif',
                'image/jpeg',
                'image/jp2',
                'image/png',
                'image/x-dcraw',
                'application/tga',
                'application/x-tga',
                'application/x-targa',
                'image/tga',
                'image/x-tga',
                'image/targa',
                'image/RAW',
                'image/x-targa',
                'image/tiff',
                'image/vnd.ms-photo',
                'image/x-xpixmap',
                'image/x-paintnet',
                'application/pdf',
                'application/vnd.oasis.opendocument.text',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/msword',
                'application/vnd.ms-word.document.macroEnabled.12',
                'customType',
            ],

            FileTypes6: [
                'image/bmp',
                'application/x-win-bitmap',
                'application/x-bmp',
                'application/bmp',
                'image/x-ms-bmp',
                'image/ms-bmp',
                'image/x-windows-bmp',
                'image/x-win-bitmap',
                'image/x-xbitmap',
                'image/x-bitmap',
                'image/x-bmp',
                'image/gif',
                'image/jpeg',
                'image/jp2',
                'image/png',
                'image/x-dcraw',
                'image/x-panasonic-raw',
                'application/tga',
                'application/x-tga',
                'application/x-targa',
                'image/tga',
                'image/x-tga',
                'image/RAW',
                'image/targa',
                'image/x-targa',
                'image/tiff',
                'image/vnd.ms-photo',
                'image/x-xpixmap',
                'image/x-paintnet',
                'application/pdf',
                'application/vnd.oasis.opendocument.text',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/msword',
                'application/vnd.ms-word.document.macroEnabled.12',
                'application/x-7z-compressed',
                'application/x-rar-compressed',
                'application/octet-stream',
                'application/zip',
                'application/x-zip',
                'application/x-zip-compressed',
                'application/octet-stream',
                'application/x-compress',
                'application/x-compressed',
                'multipart/x-zip',
                'application/vnd.ms-word.document.macroEnabled.12',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'customType',
            ],

            FileTypes7: [
                'application/vnd.oasis.opendocument.text',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/msword',
                'application/vnd.ms-word.document.macroEnabled.12',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/pdf',
                'customType',
            ],

            FileTypes8: [
                'application/vnd.oasis.opendocument.text',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/msword',
                'application/vnd.ms-word.document.macroEnabled.12',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'customType',
            ],

        }),

        created () {
            this.role = localStorage.getItem('role');
            this.backUrl = localStorage.getItem('url');

            if(this.role == 'ROLE_CUSTOMER_ADMIN' || this.role ==  'ROLE_CUSTOMER_WORKER'){
                window.addEventListener("beforeunload", this.saveLocal);
            }

            if(localStorage.getItem('role') == 'ROLE_ADMIN' || localStorage.getItem('role') == 'ROLE_EXPERT'){
                this.allowFiledEdit = false
                this.hideFiles = false
            }
            this.token = localStorage.getItem('token');
            this.requestParams = this.$route.params.item
            this.requestParamsId = this.$route.params.id.toString()
            if(this.requestParams && this.requestParams.notificationId) {
                 this.deleteNotification(this.requestParams.notificationId)
            }
            if(this.requestParams && this.requestParams.notStatus){
                this.e1 = 'comments'
            }
            this.getAccountDetails()
            this.getRequest()

            this.getDocuments()
        },

        watch: {
            'contractItem.undefinedQuantityUnitsSupplied'(val){
                if(val){
                    this.contractItem.startContractPrice = ''
                }
            },

            'contractItem.contractDocumentDate': function(val) {
                this.contractItem.contractDocumentDate = this.convertDateTime(val)
            },

            dialog (val) {
                val || this.close()
            },

            supplierDefinitionInfoDialog (val) {
                val || this.closeSupplierDefinitionInfo()
            },

            'contractItem.supplierDefinitionType': function(val){
                if((val == 'OPEN_CONTEST_EL_FORM' || val == 'LIMITED_CONTEST' || val == 'AUCTION_EL_FORM')  && this.contractItem.provisionSize == '' && this.contractItem.startContractPrice){
                    Vue.nextTick(() => this.contractItem.provisionSizePercent = 0.50);
                    Vue.nextTick(() => this.contractItem.provisionSize = makeValidNumber(this.contractItem.startContractPrice) * 0.50 / 100);
                }
            },

            'contractItem.startContractPrice': function(newValue) {
              if(newValue) {
                let lastChar = newValue.toString().split('').pop();
                if(lastChar != '.' && lastChar != ','){
                  Vue.nextTick(() => this.contractItem.startContractPrice = decimalPriceFormat(newValue));
                }
              }
            },

            'contractItem.startServicePrice': function(newValue) {
              if(newValue) {
                let lastChar = newValue.toString().split('').pop();
                if(lastChar != '.' && lastChar != ','){
                  Vue.nextTick(() => this.contractItem.startServicePrice = decimalPriceFormat(newValue));
                }
              }
            },

            'contractItem.startServiceUnitsSum': function(newValue) {
              if(newValue) {
                let lastChar = newValue.toString().split('').pop();
                if(lastChar != '.' && lastChar != ','){
                  Vue.nextTick(() => this.contractItem.startServiceUnitsSum = decimalPriceFormat(newValue));
                }
              }
            },

            'contractItem.maxContractPrice': function(newValue) {
              if(newValue) {
                let lastChar = newValue.toString().split('').pop();
                if(lastChar != '.' && lastChar != ','){
                  Vue.nextTick(() => this.contractItem.maxContractPrice = decimalPriceFormat(newValue));
                }
              }
            },

            'requests.provisionSize': function(newValue) {
              if(newValue) {
                let lastChar = newValue.toString().split('').pop();
                if(lastChar != '.' && lastChar != ','){
                  Vue.nextTick(() => this.requests.provisionSize = decimalPriceFormat(newValue));
                }
              }
            },

            'contractItem.provisionSize': function(newValue) {
              if(newValue) {
                let lastChar = newValue.toString().split('').pop();
                if(lastChar != '.' && lastChar != ','){
                  Vue.nextTick(() => this.contractItem.provisionSize = decimalPriceFormat(newValue));
                }
              }
            },
        },

        computed: {
            pages () {
                return Math.ceil( this.commentsTotal / this.rowsPerPage)
            },
            dateFormatted () {
                    let date2 = new Date(this.contractItem.contractDocumentDate);
                    let year = date2.getFullYear();
                    let month = ("0" + (date2.getMonth() + 1)).slice(-2);
                    let day = ("0" + date2.getDate()).slice(-2);

                    return day + '.' + month + '.' + year;
            },
            yearsFinancing () {
                return Array.from({length: 50}, (value, index) => String(2017 + index))
            },
        },

        beforeDestroy(){
            if(this.role == 'ROLE_CUSTOMER_ADMIN' || this.role ==  'ROLE_CUSTOMER_WORKER'){
                if(this.isRequestChanged) {
                    this.saveLocal()
                }
                window.removeEventListener("beforeunload", this.saveLocal);
            }
        },

        methods: {
            validateForPrice,
            decimalPriceFormat,
            makeValidNumber,
            changeStartContractPrice(val){
                if(val) {
                    if(this.contractItem.supplierDefinitionType != 'QUOTATION_REQUEST_EL_FORM' && makeValidNumber(val) >= 1000000 && !this.requests.provisionSize){
                        this.requests.provisionSizePercent = 0;
                        const result = makeValidNumber(val) * this.requests.provisionSizePercent / 100;
                        this.requests.provisionSize = result.toFixed(2);
                    }
                    if(this.requests.provisionSizePercent && makeValidNumber(this.requests.provisionSizePercent) >= 0 && makeValidNumber(this.requests.provisionSizePercent) <= 5) {
                        const res = makeValidNumber(val)* makeValidNumber(this.requests.provisionSizePercent) / 100;
                        this.requests.provisionSize = res.toFixed(2)
                    }
                    if(this.contractItem.provisionSizePercent){
                        const res2 = makeValidNumber(val) * makeValidNumber(this.contractItem.provisionSizePercent) / 100;
                        this.contractItem.provisionSize = res2.toFixed(2)
                    }
                }else{
                    this.contractItem.provisionSize = ''
                    this.requests.provisionSize = ''
                }
            },

            getDocuments(){
                axios({
                    method: 'get',
                    url: this.backUrl + '/api/requiredDocuments',
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                }).then(res => {
                    this.requiredDocuments = res.data.data
                })
            },

            requiredStatus(val){
                if(this.requiredDocuments.length > 0){
                    return this.requiredDocuments.find(x => x.documentName === val).required
                }
            },

            getRequest() {

                let requestId = this.$route.params.id
                let cancelChangeStatus = this.cancelChangeStatus
                if(this.role == 'ROLE_CUSTOMER_ADMIN' || this.role ==  'ROLE_CUSTOMER_WORKER'){
                    setTimeout(() => {

                        this.$keysInStorage().then(function(keyName) {
                            for(let j = 0 ; j < keyName.length; j++){
                                if(requestId.toString() == keyName[j]){
                                    Vue.set(cancelChangeStatus, 'status', true)

                                }
                            }
                        })
                    }, 0)

                }
                axios({
                    method: 'get',
                    url: this.backUrl + '/api/bids/' + this.$route.params.id,
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                }).then(response => {

                    this.requests = response.data
                    if(this.requests.status !== 'CREATED' && this.requests.status !== 'ON_REWORK'){
                        this.allowFiledEdit = false
                        this.hideFiles = false
                    }
                    this.getContract(this.requests.contractId,true)
                    this.getCustomer(this.requests.customerId)
                    // this.getAccountDetailsSelect(this.requests.accountDetailsId)
                    this.getComments(this.requests.id)
                    this.getFiles()

                })
            },

            getRequestCancel(cancelStatus) {
                axios({
                    method: 'get',
                    url: this.backUrl + '/api/bids/' + this.$route.params.id,
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                }).then(response => {
                    this.requests = response.data
                    this.getContract(this.requests.contractId,cancelStatus)
                    this.getCustomer(this.requests.customerId)
                    // this.getAccountDetailsSelect(this.requests.accountDetailsId)
                    this.getComments(this.requests.id)

                })
            },

            saveLocal(){

                if(this.contractItem.startContractPrice) {
                    Vue.set(this.contractItem, 'startContractPrice', makeValidNumber(this.contractItem.startContractPrice))
                }else{
                    Vue.set(this.contractItem, 'startContractPrice', null)
                }

                if(this.contractItem.undefinedQuantityUnitsSupplied && this.contractItemOld.startContractPrice){
                    Vue.set(this.contractItem, 'startContractPrice', null)
                    Vue.set(this.contractItemOld, 'startContractPrice', null)
                }

                if(!this.contractItem.provisionSize && this.contractItem.provisionSize !== 0) {
                    Vue.set(this.contractItem, 'provisionSize', null)
                }else{
                    Vue.set(this.contractItem, 'provisionSize', makeValidNumber(this.contractItem.provisionSize))
                }

                if((this.requests.provisionSize == '' || this.requests.provisionSize == 0.00) && this.contractItemOld.provisionSizeRequest == null) {
                    this.contractItem.provisionSizeRequest = null
                }else if((this.requests.provisionSize == '' || this.requests.provisionSize == 0.00) && this.contractItemOld.provisionSizeRequest == 0){
                    this.contractItem.provisionSizeRequest = 0
                }else if(this.contractItem.provisionSizeRequest){
                    this.contractItem.provisionSizeRequest = makeValidNumber(this.requests.provisionSize)
                }

                if(this.requests.provisionSizePercent){
                    Vue.set(this.contractItem, 'provisionRequestSizePercent', this.requests.provisionSizePercent)
                }

                if(!this.contractItem.attractionPercent) {
                    Vue.set(this.contractItem, 'attractionPercent', null)
                }

                if(this.contractItem.startServicePrice){
                    Vue.set(this.contractItem, 'startServicePrice', makeValidNumber(this.contractItem.startServicePrice))
                }
                if(this.contractItem.startServiceUnitsSum){
                    Vue.set(this.contractItem, 'startServiceUnitsSum', makeValidNumber(this.contractItem.startServiceUnitsSum))
                }
                if(this.contractItem.maxContractPrice){
                    Vue.set(this.contractItem, 'maxContractPrice', makeValidNumber(this.contractItem.maxContractPrice))
                }

                 Vue.set(this.contractItemOld, 'contractDocumentDate', this.convertDateTime(this.contractItemOld.contractDocumentDate))

                let object1 = this.contractItem,
                    object2 = this.contractItemOld,
                    object3 = {};

                Object.keys(object1).forEach(function (k) {
                    if (object1[k] !== object2[k]) {
                        object3[k] = object1[k];
                    }
                });

                if (Object.keys(object3).length != 0) {
                    this.$setItem(this.requestParamsId, object3)
                } else {
                    this.$removeItem(this.requestParamsId)
                }
            },

            changedRequestItems(){
                setTimeout(() => {
                    let contractItem = this.contractItem
                    let contractItemChange = this.contractItemChange
                    let requestsProvision = this.requests

                    this.$getItem(this.$route.params.id && this.$route.params.id.toString()).then(function(value) {
                        for (let key in value) {
                            if (value.hasOwnProperty(key)) {
                                Vue.set(contractItem, key, value[key])
                                Vue.set(contractItemChange, key,true)
                                if(key == 'provisionSizeRequest'){
                                    requestsProvision.provisionSize = value[key]
                                }else if(key == 'provisionRequestSizePercent'){
                                    requestsProvision.provisionSizePercent = value[key]
                                }
                            }
                        }
                    })

                }, 0)
            },

            cancelChanges () {

                if(confirm('Вы уверены, что хотите вернуться к последним сохранённым изменениям ?')) {
                    let id = this.$route.params.id.toString()
                    this.cancelChangeStatus.status = false
                    this.contractItemChange = this.contractItemChangeOld
                    let contractId = this.getRequestCancel(this.cancelChangeStatus.status)
                    this.$removeItem(id).then(function() {
                        contractId
                    })
                }

            },

            convertDateTime(date){
                if(date){
                    let date2 = new Date(date);
                    let year = date2.getFullYear();
                    let month = ("0" + (date2.getMonth()+1)).slice(-2);
                    let day = ("0" + date2.getDate()).slice(-2);

                    return  year + '-' + month + '-' + day;
                }

            },

            minmaxRequest(value,min,max){
              if(value){
                let newValue = makeValidNumber(value)
                if(newValue < min || isNaN(newValue))
                  this.requests.provisionSizePercent = min;
                else if(newValue > max)
                  this.requests.provisionSizePercent = max;
                else {
                  if(value[value.length -1] == '.' || value[value.length -1] == ','){
                    this.requests.provisionSizePercent = value.slice(0, -1);
                  }

                  if (this.contractItem.startContractPrice) {
                    const result = makeValidNumber(this.contractItem.startContractPrice) * newValue / 100;
                    this.requests.provisionSize = result.toFixed(2)
                  }
                }
              }else {
                this.requests.provisionSize = ''
              }
            },

            minmaxContract(value,min,max){
              if(value){
                let newValue = makeValidNumber(value)
                if(newValue < min || isNaN(newValue))
                  this.contractItem.provisionSizePercent = min;
                else if(newValue > max)
                  this.contractItem.provisionSizePercent = max;
                else {
                    if(value[value.length -1] == '.' || value[value.length -1] == ','){
                        this.contractItem.provisionSizePercent = value.slice(0, -1);
                    }

                  if (this.contractItem.startContractPrice) {
                    const result = makeValidNumber(this.contractItem.startContractPrice) * newValue / 100;
                    this.contractItem.provisionSize = result.toFixed(2)
                  }
                }
              }else {
                this.contractItem.provisionSize = ''
              }
            },

            minmaxAmount(value, min, max){
              if(value) {
                if (value < min || isNaN(value) || (value == 0))
                  return min;
                else if (value > max)
                  return  max;
                else return value;
              }
            },

            minmaxAmount2(value, min, max){
              if(value) {
                if (isNaN(makeValidNumber(value)))
                  return min;
                else if (makeValidNumber(value) > max)
                  return  max;
                else return value;
              }
            },

            deleteNotification(id){
                if(id) {
                    axios({
                        method: 'delete',
                        url: this.backUrl + '/api/notifications/' + id,
                        withCredentials: true,
                        headers: {
                            'Authorization': 'Basic ' + this.token,
                        },
                        data: {},
                    }).then(() => {
                        Event.$emit('notes');
                    })
                }
            },

            saveFile(item){
                axios({
                    method: 'get',
                    url: this.backUrl + '/api/documents/files/' + item.id,
                    withCredentials: true,
                    headers: {
                        'Authorization': 'Basic ' + this.token
                    },

                }).then(response => {
                    let contentType = response.data.headers['Content-Type'][0];
                    // let contentDisp = response.data.headers['Content-Disposition'][0];

                    let uri = 'data:'+contentType+';'+';base64,';
                    let tempLink = document.createElement('a');
                    tempLink.href = uri + response.data.body;
                    tempLink.setAttribute('download', item.filename);
                    tempLink.click();

                })
            },

            deleteFile(item){
                item.deleteStatus = true
            },

            getFiles(){

                if(this.requests.contractProject != null){
                    axios({
                        method: 'get',
                        url: this.backUrl + '/api/documents/files?eq_document_id=' + this.requests.contractProject,
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                    }).then(response => {

                        if(response.data){
                            for (let i = 0 ;i<response.data.data.length; i++){
                                this.contractProjectFilesDetails.push({
                                    id: response.data.data[i].id,
                                    filename: response.data.data[i].filename,
                                    documentId: response.data.data[i].documentId,
                                    extensionType: response.data.data[i].extensionType,
                                    uuid: response.data.data[i].uuid,
                                    deleteStatus: false
                                })
                            }
                        }else{
                            this.contractProjectFilesDetails = []
                        }
                    })
                }
                if(this.requests.contractProjectApplication != null){
                    axios({
                        method: 'get',
                        url: this.backUrl + '/api/documents/files?eq_document_id=' + this.requests.contractProjectApplication,
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                    }).then(response => {
                        if(response.data){
                            for (let i=0;i<response.data.data.length; i++){
                                this.contractProjectApplicationFilesDetails.push({
                                    id: response.data.data[i].id,
                                    filename: response.data.data[i].filename,
                                    documentId: response.data.data[i].documentId,
                                    extensionType: response.data.data[i].extensionType,
                                    uuid: response.data.data[i].uuid,
                                    deleteStatus: false
                                })
                            }
                        }else{
                            this.contractProjectApplicationFilesDetails = []
                        }
                    })
                }
                if(this.requests.defectiveStatements != null){
                    axios({
                        method: 'get',
                        url: this.backUrl + '/api/documents/files?eq_document_id=' + this.requests.defectiveStatements,
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                    }).then(response => {
                        if(response.data){
                            for (let i=0;i<response.data.data.length; i++){
                                this.defectiveStatementsFilesDetails.push({
                                    id: response.data.data[i].id,
                                    filename: response.data.data[i].filename,
                                    documentId: response.data.data[i].documentId,
                                    extensionType: response.data.data[i].extensionType,
                                    uuid: response.data.data[i].uuid,
                                    deleteStatus: false
                                })
                            }
                        }else{
                            this.defectiveStatementsFilesDetails = []
                        }
                    })
                }
                if(this.requests.estimates != null){
                    axios({
                        method: 'get',
                        url: this.backUrl + '/api/documents/files?eq_document_id=' + this.requests.estimates,
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                    }).then(response => {

                        if(response.data){
                            for (let i=0;i<response.data.data.length; i++){
                                this.estimatesFilesDetails.push({
                                    id: response.data.data[i].id,
                                    filename: response.data.data[i].filename,
                                    documentId: response.data.data[i].documentId,
                                    extensionType: response.data.data[i].extensionType,
                                    uuid: response.data.data[i].uuid,
                                    deleteStatus: false
                                })
                            }
                        }else{
                            this.estimatesFilesDetails = []
                        }
                    })
                }
                if(this.requests.evaluationRules != null){
                    axios({
                        method: 'get',
                        url: this.backUrl + '/api/documents/files?eq_document_id=' + this.requests.evaluationRules,
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                    }).then(response => {
                        if(response.data){
                            for (let i=0;i<response.data.data.length; i++){
                                this.evaluationRulesFilesDetails.push({
                                    id: response.data.data[i].id,
                                    filename: response.data.data[i].filename,
                                    documentId: response.data.data[i].documentId,
                                    extensionType: response.data.data[i].extensionType,
                                    uuid: response.data.data[i].uuid,
                                    deleteStatus: false
                                })
                            }
                        } else{
                            this.evaluationRulesFilesDetails = []
                        }
                    })
                }
                if(this.requests.financingProof != null){
                    axios({
                        method: 'get',
                        url: this.backUrl + '/api/documents/files?eq_document_id=' + this.requests.financingProof,
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                    }).then(response => {
                        if(response.data){
                            for (let i=0;i<response.data.data.length; i++){
                                this.financingProofFilesDetails.push({
                                    id: response.data.data[i].id,
                                    filename: response.data.data[i].filename,
                                    documentId: response.data.data[i].documentId,
                                    extensionType: response.data.data[i].extensionType,
                                    uuid: response.data.data[i].uuid,
                                    deleteStatus: false
                                })
                            }
                        }else{
                            this.financingProofFilesDetails = []
                        }
                    })
                }
                if(this.requests.infoForAdvancePayment != null){
                    axios({
                        method: 'get',
                        url: this.backUrl + '/api/documents/files?eq_document_id=' + this.requests.infoForAdvancePayment,
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                    }).then(response => {
                        if(response.data){
                            for (let i=0;i<response.data.data.length; i++){
                                this.infoForAdvancePaymentFilesDetails.push({
                                    id: response.data.data[i].id,
                                    filename: response.data.data[i].filename,
                                    documentId: response.data.data[i].documentId,
                                    extensionType: response.data.data[i].extensionType,
                                    uuid: response.data.data[i].uuid,
                                    deleteStatus: false
                                })
                            }
                        }else{
                            this.infoForAdvancePaymentFilesDetails = []
                        }
                    })
                }
                if(this.requests.infoForStartContractPrice != null){
                    axios({
                        method: 'get',
                        url: this.backUrl + '/api/documents/files?eq_document_id=' + this.requests.infoForStartContractPrice,
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                    }).then(response => {
                        if(response.data){
                            for (let i=0;i<response.data.data.length; i++){
                                this.infoForStartContractPriceFilesDetails.push({
                                    id: response.data.data[i].id,
                                    filename: response.data.data[i].filename,
                                    documentId: response.data.data[i].documentId,
                                    extensionType: response.data.data[i].extensionType,
                                    uuid: response.data.data[i].uuid,
                                    deleteStatus: false
                                })
                            }
                        }else{
                            this.infoForStartContractPriceFilesDetails = []
                        }
                    })
                }
                if(this.requests.letterToAddToCommission != null){
                    axios({
                        method: 'get',
                        url: this.backUrl + '/api/documents/files?eq_document_id=' + this.requests.letterToAddToCommission,
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                    }).then(response => {
                        if(response.data){
                            for (let i=0;i<response.data.data.length; i++){
                                this.letterToAddToCommissionFilesDetails.push({
                                    id: response.data.data[i].id,
                                    filename: response.data.data[i].filename,
                                    documentId: response.data.data[i].documentId,
                                    extensionType: response.data.data[i].extensionType,
                                    uuid: response.data.data[i].uuid,
                                    deleteStatus: false
                                })
                            }
                        }else{
                            this.letterToAddToCommissionFilesDetails = []
                        }
                    })
                }
                if(this.requests.otherFiles != null){
                    axios({
                        method: 'get',
                        url: this.backUrl + '/api/documents/files?eq_document_id=' + this.requests.otherFiles,
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                    }).then(response => {
                        if(response.data){
                            for (let i=0;i<response.data.data.length; i++){
                                this.otherFilesFilesDetails.push({
                                    id: response.data.data[i].id,
                                    filename: response.data.data[i].filename,
                                    documentId: response.data.data[i].documentId,
                                    extensionType: response.data.data[i].extensionType,
                                    uuid: response.data.data[i].uuid,
                                    deleteStatus: false
                                })
                            }
                        }else{
                            this.otherFilesFilesDetails = []
                        }
                    })
                }
                if(this.requests.performanceRequirements != null){
                    axios({
                        method: 'get',
                        url: this.backUrl + '/api/documents/files?eq_document_id=' + this.requests.performanceRequirements,
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                    }).then(response => {
                        if(response.data){
                            for (let i=0;i<response.data.data.length; i++){
                                this.performanceRequirementsFilesDetails.push({
                                    id: response.data.data[i].id,
                                    filename: response.data.data[i].filename,
                                    documentId: response.data.data[i].documentId,
                                    extensionType: response.data.data[i].extensionType,
                                    uuid: response.data.data[i].uuid,
                                    deleteStatus: false
                                })
                            }
                        }else{
                            this.performanceRequirementsFilesDetails = []
                        }
                    })
                }
                if(this.requests.presenceInEASUZ != null){
                    axios({
                        method: 'get',
                        url: this.backUrl + '/api/documents/files?eq_document_id=' + this.requests.presenceInEASUZ,
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                    }).then(response => {
                        if(response.data){
                            for (let i=0;i<response.data.data.length; i++){
                                this.presenceInEASUZFilesDetails.push({
                                    id: response.data.data[i].id,
                                    filename: response.data.data[i].filename,
                                    documentId: response.data.data[i].documentId,
                                    extensionType: response.data.data[i].extensionType,
                                    uuid: response.data.data[i].uuid,
                                    deleteStatus: false
                                })
                            }
                        }else{
                            this.presenceInEASUZFilesDetails = []
                        }
                    })
                }
                if(this.requests.presenceInEIS != null){
                    axios({
                        method: 'get',
                        url: this.backUrl + '/api/documents/files?eq_document_id=' + this.requests.presenceInEIS,
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                    }).then(response => {
                        if(response.data){
                            for (let i=0;i<response.data.data.length; i++){
                                this.presenceInEISFilesDetails.push({
                                    id: response.data.data[i].id,
                                    filename: response.data.data[i].filename,
                                    documentId: response.data.data[i].documentId,
                                    extensionType: response.data.data[i].extensionType,
                                    uuid: response.data.data[i].uuid,
                                    deleteStatus: false
                                })
                            }
                        }else{
                            this.presenceInEISFilesDetails = []
                        }
                    })
                }
                if(this.requests.presenceInPIK != null){
                    axios({
                        method: 'get',
                        url: this.backUrl + '/api/documents/files?eq_document_id=' + this.requests.presenceInPIK,
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                    }).then(response => {

                        if(response.data){
                            for (let i=0;i<response.data.data.length; i++){
                                this.presenceInPIKFilesDetails.push({
                                    id: response.data.data[i].id,
                                    filename: response.data.data[i].filename,
                                    documentId: response.data.data[i].documentId,
                                    extensionType: response.data.data[i].extensionType,
                                    uuid: response.data.data[i].uuid,
                                    deleteStatus: false
                                })
                            }
                        }else{
                            this.presenceInPIKFilesDetails = []
                        }
                    })
                }
                if(this.requests.priceInfo != null){
                    axios({
                        method: 'get',
                        url: this.backUrl + '/api/documents/files?eq_document_id=' + this.requests.priceInfo,
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                    }).then(response => {
                        if(response.data){
                            for (let i=0;i<response.data.data.length; i++){
                                this.priceInfoFilesDetails.push({
                                    id: response.data.data[i].id,
                                    filename: response.data.data[i].filename,
                                    documentId: response.data.data[i].documentId,
                                    extensionType: response.data.data[i].extensionType,
                                    uuid: response.data.data[i].uuid,
                                    deleteStatus: false
                                })
                            }
                        }else{
                            this.priceInfoFilesDetails = []
                        }
                    })
                }
                if(this.requests.procurementPlan != null){
                    axios({
                        method: 'get',
                        url: this.backUrl + '/api/documents/files?eq_document_id=' + this.requests.procurementPlan,
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                    }).then(response => {
                        if(response.data){
                            for (let i=0;i<response.data.data.length; i++){
                                this.procurementPlanFilesDetails.push({
                                    id: response.data.data[i].id,
                                    filename: response.data.data[i].filename,
                                    documentId: response.data.data[i].documentId,
                                    extensionType: response.data.data[i].extensionType,
                                    uuid: response.data.data[i].uuid,
                                    deleteStatus: false
                                })
                            }
                        }else{
                            this.procurementPlanFilesDetails = []
                        }
                    })
                }
                if(this.requests.procurementSchedule != null){
                    axios({
                        method: 'get',
                        url: this.backUrl + '/api/documents/files?eq_document_id=' + this.requests.procurementSchedule,
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                    }).then(response => {
                        if(response.data){
                            for (let i=0;i<response.data.data.length; i++){
                                this.procurementScheduleFilesDetails.push({
                                    id: response.data.data[i].id,
                                    filename: response.data.data[i].filename,
                                    documentId: response.data.data[i].documentId,
                                    extensionType: response.data.data[i].extensionType,
                                    uuid: response.data.data[i].uuid,
                                    deleteStatus: false
                                })
                            }
                        }else{
                            this.procurementScheduleFilesDetails = []
                        }
                    })
                }
                if(this.requests.projects != null){
                    axios({
                        method: 'get',
                        url: this.backUrl + '/api/documents/files?eq_document_id=' + this.requests.projects,
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                    }).then(response => {
                        if(response.data){
                            for (let i=0;i<response.data.data.length; i++){
                                this.projectsFilesDetails.push({
                                    id: response.data.data[i].id,
                                    filename: response.data.data[i].filename,
                                    documentId: response.data.data[i].documentId,
                                    extensionType: response.data.data[i].extensionType,
                                    uuid: response.data.data[i].uuid,
                                    deleteStatus: false
                                })
                            }
                        }else{
                            this.projectsFilesDetails = []
                        }
                    })
                }
                if(this.requests.sketches != null){
                    axios({
                        method: 'get',
                        url: this.backUrl + '/api/documents/files?eq_document_id=' + this.requests.sketches,
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                    }).then(response => {
                        if(response.data){
                            for (let i=0;i<response.data.data.length; i++){
                                this.sketchesFilesDetails.push({
                                    id: response.data.data[i].id,
                                    filename: response.data.data[i].filename,
                                    documentId: response.data.data[i].documentId,
                                    extensionType: response.data.data[i].extensionType,
                                    uuid: response.data.data[i].uuid,
                                    deleteStatus: false
                                })
                            }
                        }else{
                            this.sketchesFilesDetails = []
                        }
                    })
                }
                if(this.requests.startContractPriceCalc != null){
                    axios({
                        method: 'get',
                        url: this.backUrl + '/api/documents/files?eq_document_id=' + this.requests.startContractPriceCalc,
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                    }).then(response => {
                        if(response.data){
                            for (let i=0;i<response.data.data.length; i++){
                                this.startContractPriceCalcFilesDetails.push({
                                    id: response.data.data[i].id,
                                    filename: response.data.data[i].filename,
                                    documentId: response.data.data[i].documentId,
                                    extensionType: response.data.data[i].extensionType,
                                    uuid: response.data.data[i].uuid,
                                    deleteStatus: false
                                })
                            }
                        }else{
                            this.startContractPriceCalcFilesDetails = []
                        }
                    })
                }
                if(this.requests.targetedSubsidySubmission != null){
                    axios({
                        method: 'get',
                        url: this.backUrl + '/api/documents/files?eq_document_id=' + this.requests.targetedSubsidySubmission,
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                    }).then(response => {
                        if(response.data){
                            for (let i=0;i<response.data.data.length; i++){
                                this.targetedSubsidySubmissionFilesDetails.push({
                                    id: response.data.data[i].id,
                                    filename: response.data.data[i].filename,
                                    documentId: response.data.data[i].documentId,
                                    extensionType: response.data.data[i].extensionType,
                                    uuid: response.data.data[i].uuid,
                                    deleteStatus: false
                                })
                            }
                        }else{
                            this.targetedSubsidySubmissionFilesDetails = []
                        }
                    })
                }
                if(this.requests.technicalTask != null){
                    axios({
                        method: 'get',
                        url: this.backUrl + '/api/documents/files?eq_document_id=' + this.requests.technicalTask,
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                    }).then(response => {
                        if(response.data){
                            for (let i=0;i<response.data.data.length; i++){
                                this.technicalTaskFilesDetails.push({
                                    id: response.data.data[i].id,
                                    filename: response.data.data[i].filename,
                                    documentId: response.data.data[i].documentId,
                                    extensionType: response.data.data[i].extensionType,
                                    uuid: response.data.data[i].uuid,
                                    deleteStatus: false
                                })
                            }
                        }else{
                            this.technicalTaskFilesDetails = []
                        }
                    })
                }
            },

            getCustomer(id){
                axios({
                    method: 'get',
                    url: this.backUrl + '/api/customers/' + id,
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                }).then(response => {
                    this.customerItem = response.data
                })
            },

            getAccountDetails(){
                axios({
                    method: 'get',
                    url: this.backUrl + '/api/accountDetails',
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                }).then(response => {
                    this.accountDetailsItems = response.data.data
                    for(let i =0; i < response.data.data.length;i++){
                        this.accountDetails2.push ({
                            id: response.data.data[i].id,
                            personalAccount: 'л/с: ' + response.data.data[i].personalAccount
                        })
                    }
                })
            },

            // getAccountDetailsSelect(id){
            //     axios({
            //         method: 'get',
            //         url: this.backUrl + '/api/accountDetails/' + id,
            //         withCredentials: true,
            //         headers:{
            //             'Authorization': 'Basic ' + this.token
            //         },
            //     }).then(response => {
            //         this.contractItem.accountDetailsId = response.data.id
            //     })
            // },

            getContract(id,cancelChangeStatus){
                axios({
                    method: 'get',
                    url: this.backUrl + '/api/contracts/' + id,
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                }).then(response => {

                    this.contractItem = response.data
                    Vue.set(this.contractItem, 'provisionSizeRequest', this.requests.provisionSize ? makeValidNumber(this.requests.provisionSize) : null)
                    Vue.set(this.contractItem, 'provisionRequestSizePercent', this.requests.provisionSizePercent)
                    if(!this.contractItem.attractionPercent){
                        Vue.set(this.contractItem, 'attractionPercent', null)
                    }

                    this.contractItemOld = Object.assign({}, response.data)

                    this.contractItemChangeOld = Object.assign({}, this.contractItemChange)

                    if(this.role == 'ROLE_CUSTOMER_ADMIN' || this.role ==  'ROLE_CUSTOMER_WORKER') {
                        if(cancelChangeStatus) {
                            this.changedRequestItems()
                        }
                    }
                })

            },

            getComments(id){

                let startIndex = (this.commentsPagination - 1) * this.rowsPerPage
                axios({
                    method: 'get',
                    url: this.backUrl + `/api/bids/comments/${id}?start_index=${startIndex}&count=${this.rowsPerPage}`,
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                }).then(response => {
                    if(response.data) {
                        this.comments = response.data.data
                        if (response.data.metadata) {
                            this.commentsTotal = response.data.metadata.total_count
                        }

                        for (let i = 0; i < this.comments.length; i++) {
                            axios({
                                method: 'get',
                                url: this.backUrl + '/api/users/' + this.comments[i].createdBy,
                                withCredentials: true,
                                headers: {
                                    'Authorization': 'Basic ' + this.token
                                },
                            }).then(response => {
                                Vue.set(this.comments[i], 'createdBy', response.data.fullname)

                            })
                            if (this.comments[i].commentFileId) {
                                axios({
                                    method: 'get',
                                    url: this.backUrl + '/api/documents/files?eq_document_id=' + this.comments[i].commentFileId,
                                    withCredentials: true,
                                    headers: {
                                        'Authorization': 'Basic ' + this.token
                                    },
                                }).then(response => {
                                    if (response.data) {
                                        Vue.set(this.comments[i], 'files', response.data.data)
                                    }
                                })
                            }
                        }
                    }
                })
            },

            close () {
                this.dialog = false
            },

            openSupplierDefinitionInfo (id) {
                if(id){
                    this.accountDetailsItemsFiltered = this.accountDetailsItems.filter(item  => item.id == id);
                    this.supplierDefinitionInfoDialog = true
                }

            },

            closeSupplierDefinitionInfo () {
                this.supplierDefinitionInfoDialog = false
                    setTimeout(() => {
                        this.accountDetailsItemsFiltered = []
                    }, 300)
            },

            nextStep(){
                this.close()
                this.e1 = this.step
            },

            validateStep1 () {
                if(this.role == 'ROLE_ADMIN' || this.role == 'ROLE_EXPERT'){
                    this.e1 = 2
                }else {
                    if (this.e1 == 1 && this.$refs.form1.validate()) {
                        this.e1 = 2
                    } else if (this.e1 == 1) {
                        this.step = 2
                        this.dialog = true
                    } else {
                        this.e1 = 2
                    }
                }
            },

            validateStep2 () {
                if(this.role == 'ROLE_ADMIN' || this.role == 'ROLE_EXPERT'){
                    this.e1 = 3
                }else {
                    if ((this.e1 == 1 && this.$refs.form1.validate()) || (this.e1 == 2 && this.$refs.form2.validate())) {
                        this.e1 = 3
                    } else if (this.e1 == 1 || this.e1 == 2) {
                        this.step = 3
                        this.dialog = true
                    } else {
                        this.e1 = 3
                    }
                }
            },

            validateStep3 () {
                if(this.role == 'ROLE_ADMIN' || this.role == 'ROLE_EXPERT'){
                    this.e1 = 4
                }else {
                    if ((this.e1 == 1 && this.$refs.form1.validate()) || (this.e1 == 2 && this.$refs.form2.validate()) || (this.e1 == 3 && this.$refs.form3.validate())) {
                        this.e1 = 4
                    } else if (this.e1 == 1 || this.e1 == 2 || this.e1 == 3) {
                        this.step = 4
                        this.dialog = true
                    } else {
                        this.e1 = 4
                    }
                }
            },

            allowSaveCheck () {
                Object.keys(this.fileErrors).forEach(k => delete this.fileErrors[k])

                let reqErrorText = "Прикрепление файла обязательно"

                let procurementPlanFiles = true
                let procurementScheduleFiles = true
                let technicalTaskFiles = true
                let estimatesFiles = true
                let defectiveStatementsFiles = true
                let projectsFiles = true
                let sketchesFiles = true
                let performanceRequirementsFiles = true
                let targetedSubsidySubmissionFiles = true
                let priceInfoFiles = true
                let infoForAdvancePaymentFiles = true
                let contractProjectFiles = true
                let contractProjectApplicationFiles = true
                let evaluationRulesFiles = true
                let infoForStartContractPriceFiles = true
                let startContractPriceCalcFiles = true
                let financingProofFiles = true
                let presenceInEISFiles = true
                let presenceInEASUZFiles = true
                let presenceInPIKFiles = true
                let letterToAddToCommissionFiles = true
                let otherFilesFiles = true

                for (let i = 0; i < this.estimatesFilesDetails.length; i++){
                    if(this.estimatesFilesDetails[i].deleteStatus == false){
                        estimatesFiles = false
                    }
                }
                for (let i = 0; i < this.defectiveStatementsFilesDetails.length; i++){
                    if(this.defectiveStatementsFilesDetails[i].deleteStatus == false){
                        defectiveStatementsFiles = false
                    }
                }
                for (let i = 0; i < this.projectsFilesDetails.length; i++){
                    if(this.projectsFilesDetails[i].deleteStatus == false){
                        projectsFiles = false
                    }
                }
                for (let i = 0; i < this.sketchesFilesDetails.length; i++){
                    if(this.sketchesFilesDetails[i].deleteStatus == false){
                        sketchesFiles = false
                    }
                }
                for (let i = 0; i < this.performanceRequirementsFilesDetails.length; i++){
                    if(this.performanceRequirementsFilesDetails[i].deleteStatus == false){
                        performanceRequirementsFiles = false
                    }
                }
                for (let i = 0; i < this.targetedSubsidySubmissionFilesDetails.length; i++){
                    if(this.targetedSubsidySubmissionFilesDetails[i].deleteStatus == false){
                        targetedSubsidySubmissionFiles = false
                    }
                }
                for (let i = 0; i < this.priceInfoFilesDetails.length; i++){
                    if(this.priceInfoFilesDetails[i].deleteStatus == false){
                        priceInfoFiles = false
                    }
                }
                for (let i = 0; i < this.infoForAdvancePaymentFilesDetails.length; i++){
                    if(this.infoForAdvancePaymentFilesDetails[i].deleteStatus == false){
                        infoForAdvancePaymentFiles = false
                    }
                }
                for (let i = 0; i < this.financingProofFilesDetails.length; i++){
                    if(this.financingProofFilesDetails[i].deleteStatus == false){
                        financingProofFiles = false
                    }
                }
                for (let i = 0; i < this.otherFilesFilesDetails.length; i++){
                    if(this.otherFilesFilesDetails[i].deleteStatus == false){
                        otherFilesFiles = false
                    }
                }
                for (let i = 0; i < this.procurementPlanFilesDetails.length; i++){
                    if(this.procurementPlanFilesDetails[i].deleteStatus == false){
                        procurementPlanFiles = false
                    }
                }
                for (let i = 0; i < this.procurementScheduleFilesDetails.length; i++){
                    if(this.procurementScheduleFilesDetails[i].deleteStatus == false){
                        procurementScheduleFiles = false
                    }
                }
                for (let i = 0; i < this.technicalTaskFilesDetails.length; i++){
                    if(this.technicalTaskFilesDetails[i].deleteStatus == false){
                        technicalTaskFiles = false
                    }
                }
                for (let i = 0; i < this.contractProjectFilesDetails.length; i++){
                    if(this.contractProjectFilesDetails[i].deleteStatus == false){
                        contractProjectFiles = false
                    }
                }
                for (let i = 0; i < this.contractProjectApplicationFilesDetails.length; i++){
                    if(this.contractProjectApplicationFilesDetails[i].deleteStatus == false){
                        contractProjectApplicationFiles = false
                    }
                }
                for (let i = 0; i < this.evaluationRulesFilesDetails.length; i++){
                    if(this.evaluationRulesFilesDetails[i].deleteStatus == false){
                        evaluationRulesFiles = false
                    }
                }
                for (let i = 0; i < this.infoForStartContractPriceFilesDetails.length; i++){
                    if(this.infoForStartContractPriceFilesDetails[i].deleteStatus == false){
                        infoForStartContractPriceFiles = false
                    }
                }
                for (let i = 0; i < this.startContractPriceCalcFilesDetails.length; i++){
                    if(this.startContractPriceCalcFilesDetails[i].deleteStatus == false){
                        startContractPriceCalcFiles = false
                    }
                }
                for (let i = 0; i < this.presenceInEISFilesDetails.length; i++){
                    if(this.presenceInEISFilesDetails[i].deleteStatus == false){
                        presenceInEISFiles = false
                    }
                }
                for (let i = 0; i < this.presenceInEASUZFilesDetails.length; i++){
                    if(this.presenceInEASUZFilesDetails[i].deleteStatus == false){
                        presenceInEASUZFiles = false
                    }
                }
                for (let i = 0; i < this.presenceInPIKFilesDetails.length; i++){
                    if(this.presenceInPIKFilesDetails[i].deleteStatus == false){
                        presenceInPIKFiles = false
                    }
                }
                for (let i = 0; i < this.letterToAddToCommissionFilesDetails.length; i++){
                    if(this.letterToAddToCommissionFilesDetails[i].deleteStatus == false){
                        letterToAddToCommissionFiles = false
                    }
                }

                if ((this.$refs.procurementPlanpond.getFiles().length < 1 || !this.$refs.procurementPlanpond.getFiles().some(item => item.status != 8)) && procurementPlanFiles && this.requiredStatus('procurementPlan')) {
                    this.fileErrors.procurementPlan = reqErrorText
                }else if((this.$refs.procurementSchedulepond.getFiles().length < 1 || !this.$refs.procurementSchedulepond.getFiles().some(item => item.status != 8)) && procurementScheduleFiles && this.requiredStatus('procurementSchedule')){
                    this.fileErrors.procurementSchedule = reqErrorText
                }else if((this.$refs.technicalTaskpond.getFiles().length < 1 || !this.$refs.technicalTaskpond.getFiles().some(item => item.status != 8)) && technicalTaskFiles && this.requiredStatus('technicalTask')){
                    this.fileErrors.technicalTask = reqErrorText
                }else if((this.$refs.estimatespond.getFiles().length < 1 || !this.$refs.estimatespond.getFiles().some(item => item.status != 8)) && estimatesFiles && this.requiredStatus('estimates')){
                    this.fileErrors.estimates = reqErrorText
                }else if((this.$refs.defectiveStatementspond.getFiles().length < 1 || !this.$refs.defectiveStatementspond.getFiles().some(item => item.status != 8)) && defectiveStatementsFiles && this.requiredStatus('defectiveStatements')){
                    this.fileErrors.defectiveStatements = reqErrorText
                }else if((this.$refs.projectspond.getFiles().length < 1 || !this.$refs.projectspond.getFiles().some(item => item.status != 8)) && projectsFiles && this.requiredStatus('projects')){
                    this.fileErrors.projects = reqErrorText
                }else if((this.$refs.sketchespond.getFiles().length < 1 || !this.$refs.sketchespond.getFiles().some(item => item.status != 8)) && sketchesFiles && this.requiredStatus('sketches')){
                    this.fileErrors.sketches = reqErrorText
                }else if((this.$refs.performanceRequirementspond.getFiles().length < 1 || !this.$refs.performanceRequirementspond.getFiles().some(item => item.status != 8)) && performanceRequirementsFiles && this.requiredStatus('performanceRequirements')){
                    this.fileErrors.performanceRequirements = reqErrorText
                }else if((this.$refs.targetedSubsidySubmissionpond.getFiles().length < 1 || !this.$refs.targetedSubsidySubmissionpond.getFiles().some(item => item.status != 8)) && targetedSubsidySubmissionFiles && this.requiredStatus('targetedSubsidySubmission')){
                    this.fileErrors.targetedSubsidySubmission = reqErrorText
                }else if((this.$refs.priceInfopond.getFiles().length < 1 || !this.$refs.priceInfopond.getFiles().some(item => item.status != 8)) && priceInfoFiles && this.requiredStatus('priceInfo')){
                    this.fileErrors.priceInfo = reqErrorText
                }else if((this.$refs.infoForAdvancePaymentpond.getFiles().length < 1 || !this.$refs.infoForAdvancePaymentpond.getFiles().some(item => item.status != 8)) && infoForAdvancePaymentFiles && this.requiredStatus('infoForAdvancePayment')){
                    this.fileErrors.infoForAdvancePayment = reqErrorText
                }else if((this.$refs.contractProjectpond.getFiles().length < 1 || !this.$refs.contractProjectpond.getFiles().some(item => item.status != 8)) && contractProjectFiles && this.requiredStatus('contractProject')){
                    this.fileErrors.contractProject = reqErrorText
                }else if((this.$refs.contractProjectApplicationpond.getFiles().length < 1 || !this.$refs.contractProjectApplicationpond.getFiles().some(item => item.status != 8)) && contractProjectApplicationFiles && this.requiredStatus('contractProjectApplication')){
                    this.fileErrors.contractProjectApplication = reqErrorText
                }else if((this.contractItem.supplierDefinitionType == 'OPEN_CONTEST_EL_FORM' || this.contractItem.supplierDefinitionType == 'LIMITED_CONTEST') && (this.$refs.evaluationRulespond.getFiles().length < 1 || !this.$refs.evaluationRulespond.getFiles().some(item => item.status != 8)) && evaluationRulesFiles && this.requiredStatus('evaluationRules')){
                    this.fileErrors.evaluationRules = reqErrorText
                }else if((this.$refs.infoForStartContractPricepond.getFiles().length < 1 || !this.$refs.infoForStartContractPricepond.getFiles().some(item => item.status != 8)) && infoForStartContractPriceFiles && this.requiredStatus('infoForStartContractPrice')){
                    this.fileErrors.infoForStartContractPrice = reqErrorText
                }else if((this.$refs.startContractPriceCalcpond.getFiles().length < 1 || !this.$refs.startContractPriceCalcpond.getFiles().some(item => item.status != 8)) && startContractPriceCalcFiles && this.requiredStatus('startContractPriceCalc')){
                    this.fileErrors.startContractPriceCalc = reqErrorText
                }else if((this.$refs.financingProofpond.getFiles().length < 1 || !this.$refs.financingProofpond.getFiles().some(item => item.status != 8)) && financingProofFiles && this.requiredStatus('financingProof')){
                    this.fileErrors.financingProof = reqErrorText
                }else if((this.$refs.presenceInEISpond.getFiles().length < 1 || !this.$refs.presenceInEISpond.getFiles().some(item => item.status != 8)) && presenceInEISFiles && this.requiredStatus('presenceInEIS')){
                    this.fileErrors.presenceInEIS = reqErrorText
                }else if((this.$refs.presenceInEASUZpond.getFiles().length < 1 || !this.$refs.presenceInEASUZpond.getFiles().some(item => item.status != 8)) && presenceInEASUZFiles && this.requiredStatus('presenceInEASUZ')){
                    this.fileErrors.presenceInEASUZ = reqErrorText
                }else if((this.$refs.presenceInPIKpond.getFiles().length < 1 || !this.$refs.presenceInPIKpond.getFiles().some(item => item.status != 8)) && presenceInPIKFiles && this.requiredStatus('presenceInPIK')){
                    this.fileErrors.presenceInPIK = reqErrorText
                }else if((this.$refs.letterToAddToCommissionpond.getFiles().length < 1 || !this.$refs.letterToAddToCommissionpond.getFiles().some(item => item.status != 8)) && letterToAddToCommissionFiles && this.requiredStatus('letterToAddToCommission')){
                    this.fileErrors.letterToAddToCommission = reqErrorText
                }else if((this.$refs.otherFilespond.getFiles().length < 1 || !this.$refs.otherFilespond.getFiles().some(item => item.status != 8)) && otherFilesFiles && this.requiredStatus('otherFiles')){
                    this.fileErrors.otherFiles = reqErrorText
                }else{
                    this.fileErrors = []
                    this.allowSave =true
                }

            },

            save() {
                this.allowSaveCheck()

                if(this.allowSave && this.$refs.form1.validate() && this.$refs.form2.validate() && this.$refs.form3.validate()){
                    this.saveLoading = true
                    this.deleteDoc1()
                }else{
                    this.saveDialog = true
                }
            },

            deleteDoc1(){
                if (this.procurementPlanFilesDetails.length > 0) {
                    for (let del1 = 0; del1 < this.$refs.procurementPlanpond.$attrs.documentInfo.length; del1++) {
                        if (this.$refs.procurementPlanpond.$attrs.documentInfo[del1].deleteStatus == true){
                            axios({
                                method: 'delete',
                                url: this.backUrl + '/api/documents/files',
                                withCredentials: true,
                                headers: {
                                    'Authorization': 'Basic ' + this.token
                                },
                                data: {
                                    id: this.$refs.procurementPlanpond.$attrs.documentInfo[del1].id,
                                    uuid: this.$refs.procurementPlanpond.$attrs.documentInfo[del1].uuid,
                                },
                            }).then(() => {

                                if((del1 + 1) == this.$refs.procurementPlanpond.$attrs.documentInfo.length){
                                    this.saveDoc1()
                                }

                            }).catch(err => {
                                this.noError(err.response.data.rows)
                            })
                        }else{
                            if((del1 + 1) == this.$refs.procurementPlanpond.$attrs.documentInfo.length){
                                this.saveDoc1()
                            }
                        }
                    }
                }else{
                    this.saveDoc1()
                }
            },
            deleteDoc2(){
                if (this.procurementScheduleFilesDetails.length > 0) {
                    for (let del2 = 0; del2 < this.$refs.procurementSchedulepond.$attrs.documentInfo.length; del2++) {
                        if (this.$refs.procurementSchedulepond.$attrs.documentInfo[del2].deleteStatus == true) {
                            axios({
                                method: 'delete',
                                url: this.backUrl + '/api/documents/files',
                                withCredentials: true,
                                headers: {
                                    'Authorization': 'Basic ' + this.token
                                },
                                data: {
                                    id: this.$refs.procurementSchedulepond.$attrs.documentInfo[del2].id,
                                    uuid: this.$refs.procurementSchedulepond.$attrs.documentInfo[del2].uuid,
                                },
                            }).then(() => {

                                if((del2 + 1) == this.$refs.procurementSchedulepond.$attrs.documentInfo.length){
                                    this.saveDoc2()
                                }

                            }).catch(err => {
                                this.noError(err.response.data.rows)
                            })
                        }else{
                            if((del2 + 1) == this.$refs.procurementSchedulepond.$attrs.documentInfo.length){
                                this.saveDoc2()
                            }
                        }
                    }
                }else{
                    this.saveDoc2()
                }
            },
            deleteDoc3(){
                if (this.technicalTaskFilesDetails.length > 0) {
                    for (let del3 = 0; del3 < this.$refs.technicalTaskpond.$attrs.documentInfo.length; del3++) {
                        if (this.$refs.technicalTaskpond.$attrs.documentInfo[del3].deleteStatus == true){
                            axios({
                                method: 'delete',
                                url: this.backUrl + '/api/documents/files',
                                withCredentials: true,
                                headers: {
                                    'Authorization': 'Basic ' + this.token
                                },
                                data: {
                                    id: this.$refs.technicalTaskpond.$attrs.documentInfo[del3].id,
                                    uuid: this.$refs.technicalTaskpond.$attrs.documentInfo[del3].uuid,
                                },
                            }).then(() => {

                                if((del3 + 1) == this.$refs.technicalTaskpond.$attrs.documentInfo.length){
                                    this.saveDoc3()
                                }

                            }).catch(err => {
                                this.noError(err.response.data.rows)
                            })
                        }else{
                            if((del3 + 1) == this.$refs.technicalTaskpond.$attrs.documentInfo.length){
                                this.saveDoc3()
                            }
                        }
                    }
                }else{
                    this.saveDoc3()
                }
            },
            deleteDoc4(){
                if (this.estimatesFilesDetails.length > 0) {
                    for (let del4 = 0; del4 < this.$refs.estimatespond.$attrs.documentInfo.length; del4++) {
                        if (this.$refs.estimatespond.$attrs.documentInfo[del4].deleteStatus == true) {
                            axios({
                                method: 'delete',
                                url: this.backUrl + '/api/documents/files',
                                withCredentials: true,
                                headers: {
                                    'Authorization': 'Basic ' + this.token
                                },
                                data: {
                                    id: this.$refs.estimatespond.$attrs.documentInfo[del4].id,
                                    uuid: this.$refs.estimatespond.$attrs.documentInfo[del4].uuid,
                                },
                            }).then(() => {

                                if((del4 + 1) == this.$refs.estimatespond.$attrs.documentInfo.length){
                                    this.saveDoc4()
                                }

                            }).catch(err => {
                                this.noError(err.response.data.rows)
                            })
                        }else{
                            if((del4 + 1) == this.$refs.estimatespond.$attrs.documentInfo.length){
                                this.saveDoc4()
                            }
                        }
                    }
                }else{
                    this.saveDoc4()
                }
            },
            deleteDoc5(){
                if (this.defectiveStatementsFilesDetails.length > 0) {
                    for (let del5 = 0; del5 < this.$refs.defectiveStatementspond.$attrs.documentInfo.length; del5++) {
                        if (this.$refs.defectiveStatementspond.$attrs.documentInfo[del5].deleteStatus == true) {
                            axios({
                                method: 'delete',
                                url: this.backUrl + '/api/documents/files',
                                withCredentials: true,
                                headers: {
                                    'Authorization': 'Basic ' + this.token
                                },
                                data: {
                                    id: this.$refs.defectiveStatementspond.$attrs.documentInfo[del5].id,
                                    uuid: this.$refs.defectiveStatementspond.$attrs.documentInfo[del5].uuid,
                                },
                            }).then(() => {

                                if((del5 + 1) == this.$refs.defectiveStatementspond.$attrs.documentInfo.length){
                                    this.saveDoc5()
                                }

                            }).catch(err => {
                                this.noError(err.response.data.rows)
                            })
                        }else{
                            if((del5 + 1) == this.$refs.defectiveStatementspond.$attrs.documentInfo.length){
                                this.saveDoc5()
                            }
                        }
                    }
                }else{
                    this.saveDoc5()
                }
            },
            deleteDoc6(){
                if (this.projectsFilesDetails.length > 0) {
                    for (let del6 = 0; del6 < this.$refs.projectspond.$attrs.documentInfo.length; del6++) {
                        if (this.$refs.projectspond.$attrs.documentInfo[del6].deleteStatus == true) {
                            axios({
                                method: 'delete',
                                url: this.backUrl + '/api/documents/files',
                                withCredentials: true,
                                headers: {
                                    'Authorization': 'Basic ' + this.token
                                },
                                data: {
                                    id: this.$refs.projectspond.$attrs.documentInfo[del6].id,
                                    uuid: this.$refs.projectspond.$attrs.documentInfo[del6].uuid,
                                },
                            }).then(() => {

                                if((del6 + 1) == this.$refs.projectspond.$attrs.documentInfo.length){
                                    this.saveDoc6()
                                }

                            }).catch(err => {
                                this.noError(err.response.data.rows)
                            })
                        }else{
                            if((del6 + 1) == this.$refs.projectspond.$attrs.documentInfo.length){
                                this.saveDoc6()
                            }
                        }
                    }
                }else{
                    this.saveDoc6()
                }
            },
            deleteDoc7(){
                if (this.sketchesFilesDetails.length > 0) {
                    for (let del7 = 0; del7 < this.$refs.sketchespond.$attrs.documentInfo.length; del7++) {
                        if (this.$refs.sketchespond.$attrs.documentInfo[del7].deleteStatus == true) {
                            axios({
                                method: 'delete',
                                url: this.backUrl + '/api/documents/files',
                                withCredentials: true,
                                headers: {
                                    'Authorization': 'Basic ' + this.token
                                },
                                data: {
                                    id: this.$refs.sketchespond.$attrs.documentInfo[del7].id,
                                    uuid: this.$refs.sketchespond.$attrs.documentInfo[del7].uuid,
                                },
                            }).then(() => {

                                if((del7 + 1) == this.$refs.sketchespond.$attrs.documentInfo.length){
                                    this.saveDoc7()
                                }

                            }).catch(err => {
                                this.noError(err.response.data.rows)
                            })
                        }else{
                            if((del7 + 1) == this.$refs.sketchespond.$attrs.documentInfo.length){
                                this.saveDoc7()
                            }
                        }
                    }
                }else{
                    this.saveDoc7()
                }
            },
            deleteDoc8(){
                if (this.performanceRequirementsFilesDetails.length > 0) {
                    for (let del8 = 0; del8 < this.$refs.performanceRequirementspond.$attrs.documentInfo.length; del8++) {
                        if (this.$refs.performanceRequirementspond.$attrs.documentInfo[del8].deleteStatus == true) {
                            axios({
                                method: 'delete',
                                url: this.backUrl + '/api/documents/files',
                                withCredentials: true,
                                headers: {
                                    'Authorization': 'Basic ' + this.token
                                },
                                data: {
                                    id: this.$refs.performanceRequirementspond.$attrs.documentInfo[del8].id,
                                    uuid: this.$refs.performanceRequirementspond.$attrs.documentInfo[del8].uuid,
                                },
                            }).then(() => {

                                if((del8 + 1) == this.$refs.performanceRequirementspond.$attrs.documentInfo.length){
                                    this.saveDoc8()
                                }

                            }).catch(err => {
                                this.noError(err.response.data.rows)
                            })
                        }else{
                            if((del8 + 1) == this.$refs.performanceRequirementspond.$attrs.documentInfo.length){
                                this.saveDoc8()
                            }
                        }
                    }
                }else{
                    this.saveDoc8()
                }
            },
            deleteDoc9(){
                if (this.targetedSubsidySubmissionFilesDetails.length > 0) {
                    for (let del9 = 0; del9 < this.$refs.targetedSubsidySubmissionpond.$attrs.documentInfo.length; del9++) {
                        if (this.$refs.targetedSubsidySubmissionpond.$attrs.documentInfo[del9].deleteStatus == true) {
                            axios({
                                method: 'delete',
                                url: this.backUrl + '/api/documents/files',
                                withCredentials: true,
                                headers: {
                                    'Authorization': 'Basic ' + this.token
                                },
                                data: {
                                    id: this.$refs.targetedSubsidySubmissionpond.$attrs.documentInfo[del9].id,
                                    uuid: this.$refs.targetedSubsidySubmissionpond.$attrs.documentInfo[del9].uuid,
                                },
                            }).then(() => {

                                if((del9 + 1) == this.$refs.targetedSubsidySubmissionpond.$attrs.documentInfo.length){
                                    this.saveDoc9()
                                }

                            }).catch(err => {
                                this.noError(err.response.data.rows)
                            })
                        }else{
                            if((del9 + 1) == this.$refs.targetedSubsidySubmissionpond.$attrs.documentInfo.length){
                                this.saveDoc9()
                            }
                        }
                    }
                }else{
                    this.saveDoc9()
                }
            },
            deleteDoc10(){
                if (this.priceInfoFilesDetails.length > 0) {
                    for (let del10 = 0; del10 < this.$refs.priceInfopond.$attrs.documentInfo.length; del10++) {
                        if (this.$refs.priceInfopond.$attrs.documentInfo[del10].deleteStatus == true) {
                            axios({
                                method: 'delete',
                                url: this.backUrl + '/api/documents/files',
                                withCredentials: true,
                                headers: {
                                    'Authorization': 'Basic ' + this.token
                                },
                                data: {
                                    id: this.$refs.priceInfopond.$attrs.documentInfo[del10].id,
                                    uuid: this.$refs.priceInfopond.$attrs.documentInfo[del10].uuid,
                                },
                            }).then(() => {

                                if((del10 + 1) == this.$refs.priceInfopond.$attrs.documentInfo.length){
                                    this.saveDoc10()
                                }

                            }).catch(err => {
                                this.noError(err.response.data.rows)
                            })
                        }else{
                            if((del10 + 1) == this.$refs.priceInfopond.$attrs.documentInfo.length){
                                this.saveDoc10()
                            }
                        }
                    }
                }else{
                    this.saveDoc10()
                }
            },
            deleteDoc11(){
                if (this.infoForAdvancePaymentFilesDetails.length > 0) {
                    for (let del11 = 0; del11 < this.$refs.infoForAdvancePaymentpond.$attrs.documentInfo.length; del11++) {
                        if (this.$refs.infoForAdvancePaymentpond.$attrs.documentInfo[del11].deleteStatus == true) {
                            axios({
                                method: 'delete',
                                url: this.backUrl + '/api/documents/files',
                                withCredentials: true,
                                headers: {
                                    'Authorization': 'Basic ' + this.token
                                },
                                data: {
                                    id: this.$refs.infoForAdvancePaymentpond.$attrs.documentInfo[del11].id,
                                    uuid: this.$refs.infoForAdvancePaymentpond.$attrs.documentInfo[del11].uuid,
                                },
                            }).then(() => {

                                if((del11 + 1) == this.$refs.infoForAdvancePaymentpond.$attrs.documentInfo.length){
                                    this.saveDoc11()
                                }

                            }).catch(err => {
                                this.noError(err.response.data.rows)
                            })
                        }else{
                            if((del11 + 1) == this.$refs.infoForAdvancePaymentpond.$attrs.documentInfo.length){
                                this.saveDoc11()
                            }
                        }
                    }
                }else{
                    this.saveDoc11()
                }
            },
            deleteDoc12(){
                if (this.contractProjectFilesDetails.length > 0) {
                    for (let del12 = 0; del12 < this.$refs.contractProjectpond.$attrs.documentInfo.length; del12++) {
                        if (this.$refs.contractProjectpond.$attrs.documentInfo[del12].deleteStatus == true) {
                            axios({
                                method: 'delete',
                                url: this.backUrl + '/api/documents/files',
                                withCredentials: true,
                                headers: {
                                    'Authorization': 'Basic ' + this.token
                                },
                                data: {
                                    id: this.$refs.contractProjectpond.$attrs.documentInfo[del12].id,
                                    uuid: this.$refs.contractProjectpond.$attrs.documentInfo[del12].uuid,
                                },
                            }).then(() => {

                                if((del12 + 1) == this.$refs.contractProjectpond.$attrs.documentInfo.length){
                                    this.saveDoc12()
                                }

                            }).catch(err => {
                                this.noError(err.response.data.rows)
                            })
                        }else{
                            if((del12 + 1) == this.$refs.contractProjectpond.$attrs.documentInfo.length){
                                this.saveDoc12()
                            }
                        }
                    }
                }else{
                    this.saveDoc12()
                }
            },
            deleteDoc13(){
                if (this.contractProjectApplicationFilesDetails.length > 0) {
                    for (let del13 = 0; del13 < this.$refs.contractProjectApplicationpond.$attrs.documentInfo.length; del13++) {
                        if (this.$refs.contractProjectApplicationpond.$attrs.documentInfo[del13].deleteStatus == true) {
                            axios({
                                method: 'delete',
                                url: this.backUrl + '/api/documents/files',
                                withCredentials: true,
                                headers: {
                                    'Authorization': 'Basic ' + this.token
                                },
                                data: {
                                    id: this.$refs.contractProjectApplicationpond.$attrs.documentInfo[del13].id,
                                    uuid: this.$refs.contractProjectApplicationpond.$attrs.documentInfo[del13].uuid,
                                },
                            }).then(() => {

                                if((del13 + 1) == this.$refs.contractProjectApplicationpond.$attrs.documentInfo.length){
                                    this.saveDoc13()
                                }

                            }).catch(err => {
                                this.noError(err.response.data.rows)
                            })
                        }else{
                            if((del13 + 1) == this.$refs.contractProjectApplicationpond.$attrs.documentInfo.length){
                                this.saveDoc13()
                            }
                        }
                    }
                }else{
                    this.saveDoc13()
                }
            },
            deleteDoc14(){
                if ((this.contractItem.supplierDefinitionType == 'OPEN_CONTEST_EL_FORM' || this.contractItem.supplierDefinitionType == 'LIMITED_CONTEST') && this.evaluationRulesFilesDetails.length > 0) {
                    for (let del14 = 0; del14 < this.$refs.evaluationRulespond.$attrs.documentInfo.length; del14++) {
                        if (this.$refs.evaluationRulespond.$attrs.documentInfo[del14].deleteStatus == true) {
                            axios({
                                method: 'delete',
                                url: this.backUrl + '/api/documents/files',
                                withCredentials: true,
                                headers: {
                                    'Authorization': 'Basic ' + this.token
                                },
                                data: {
                                    id: this.$refs.evaluationRulespond.$attrs.documentInfo[del14].id,
                                    uuid: this.$refs.evaluationRulespond.$attrs.documentInfo[del14].uuid,
                                },
                            }).then(() => {

                                if((del14 + 1) == this.$refs.evaluationRulespond.$attrs.documentInfo.length){
                                    this.saveDoc14()
                                }

                            }).catch(err => {
                                this.noError(err.response.data.rows)
                            })
                        }else{
                            if((del14 + 1) == this.$refs.evaluationRulespond.$attrs.documentInfo.length){
                                this.saveDoc14()
                            }
                        }
                    }
                }else{
                    this.saveDoc14()
                }
            },
            deleteDoc15(){
                if (this.infoForStartContractPriceFilesDetails.length > 0) {
                    for (let del15 = 0; del15 < this.$refs.infoForStartContractPricepond.$attrs.documentInfo.length; del15++) {
                        if (this.$refs.infoForStartContractPricepond.$attrs.documentInfo[del15].deleteStatus == true) {
                            axios({
                                method: 'delete',
                                url: this.backUrl + '/api/documents/files',
                                withCredentials: true,
                                headers: {
                                    'Authorization': 'Basic ' + this.token
                                },
                                data: {
                                    id: this.$refs.infoForStartContractPricepond.$attrs.documentInfo[del15].id,
                                    uuid: this.$refs.infoForStartContractPricepond.$attrs.documentInfo[del15].uuid,
                                },
                            }).then(() => {

                                if((del15 + 1) == this.$refs.infoForStartContractPricepond.$attrs.documentInfo.length){
                                    this.saveDoc15()
                                }

                            }).catch(err => {
                                this.noError(err.response.data.rows)
                            })
                        }else{
                            if((del15 + 1) == this.$refs.infoForStartContractPricepond.$attrs.documentInfo.length){
                                this.saveDoc15()
                            }
                        }
                    }
                }else{
                    this.saveDoc15()
                }
            },
            deleteDoc16(){
                if (this.startContractPriceCalcFilesDetails.length > 0) {
                    for (let del16 = 0; del16 < this.$refs.startContractPriceCalcpond.$attrs.documentInfo.length; del16++) {
                        if (this.$refs.startContractPriceCalcpond.$attrs.documentInfo[del16].deleteStatus == true) {
                            axios({
                                method: 'delete',
                                url: this.backUrl + '/api/documents/files',
                                withCredentials: true,
                                headers: {
                                    'Authorization': 'Basic ' + this.token
                                },
                                data: {
                                    id: this.$refs.startContractPriceCalcpond.$attrs.documentInfo[del16].id,
                                    uuid: this.$refs.startContractPriceCalcpond.$attrs.documentInfo[del16].uuid,
                                },
                            }).then(() => {

                                if((del16 + 1) == this.$refs.startContractPriceCalcpond.$attrs.documentInfo.length){
                                    this.saveDoc16()
                                }

                            }).catch(err => {
                                this.noError(err.response.data.rows)
                            })
                        }else{
                            if((del16 + 1) == this.$refs.startContractPriceCalcpond.$attrs.documentInfo.length){
                                this.saveDoc16()
                            }
                        }
                    }
                }else{
                    this.saveDoc16()
                }
            },
            deleteDoc17(){
                if (this.financingProofFilesDetails.length > 0) {
                    for (let del17 = 0; del17 < this.$refs.financingProofpond.$attrs.documentInfo.length; del17++) {
                        if (this.$refs.financingProofpond.$attrs.documentInfo[del17].deleteStatus == true) {
                            axios({
                                method: 'delete',
                                url: this.backUrl + '/api/documents/files',
                                withCredentials: true,
                                headers: {
                                    'Authorization': 'Basic ' + this.token
                                },
                                data: {
                                    id: this.$refs.financingProofpond.$attrs.documentInfo[del17].id,
                                    uuid: this.$refs.financingProofpond.$attrs.documentInfo[del17].uuid,
                                },
                            }).then(() => {

                                if((del17 + 1) == this.$refs.financingProofpond.$attrs.documentInfo.length){
                                    this.saveDoc17()
                                }

                            }).catch(err => {
                                this.noError(err.response.data.rows)
                            })
                        }else{
                            if((del17 + 1) == this.$refs.financingProofpond.$attrs.documentInfo.length){
                                this.saveDoc17()
                            }
                        }
                    }
                }else{
                    this.saveDoc17()
                }
            },
            deleteDoc18(){
                if (this.presenceInEISFilesDetails.length > 0) {
                    for (let del18 = 0; del18 < this.$refs.presenceInEISpond.$attrs.documentInfo.length; del18++) {
                        if (this.$refs.presenceInEISpond.$attrs.documentInfo[del18].deleteStatus == true) {
                            axios({
                                method: 'delete',
                                url: this.backUrl + '/api/documents/files',
                                withCredentials: true,
                                headers: {
                                    'Authorization': 'Basic ' + this.token
                                },
                                data: {
                                    id: this.$refs.presenceInEISpond.$attrs.documentInfo[del18].id,
                                    uuid: this.$refs.presenceInEISpond.$attrs.documentInfo[del18].uuid,
                                },
                            }).then(() => {

                                if((del18 + 1) == this.$refs.presenceInEISpond.$attrs.documentInfo.length){
                                    this.saveDoc18()
                                }

                            }).catch(err => {
                                this.noError(err.response.data.rows)
                            })
                        }else{
                            if((del18 + 1) == this.$refs.presenceInEISpond.$attrs.documentInfo.length){
                                this.saveDoc18()
                            }
                        }
                    }
                }else{
                    this.saveDoc18()
                }
            },
            deleteDoc19(){
                if (this.presenceInEASUZFilesDetails.length > 0) {
                    for (let del19 = 0; del19 < this.$refs.presenceInEASUZpond.$attrs.documentInfo.length; del19++) {
                        if (this.$refs.presenceInEASUZpond.$attrs.documentInfo[del19].deleteStatus == true) {
                            axios({
                                method: 'delete',
                                url: this.backUrl + '/api/documents/files',
                                withCredentials: true,
                                headers: {
                                    'Authorization': 'Basic ' + this.token
                                },
                                data: {
                                    id: this.$refs.presenceInEASUZpond.$attrs.documentInfo[del19].id,
                                    uuid: this.$refs.presenceInEASUZpond.$attrs.documentInfo[del19].uuid,
                                },
                            }).then(() => {

                                if((del19 + 1) == this.$refs.presenceInEASUZpond.$attrs.documentInfo.length){
                                    this.saveDoc19()
                                }

                            }).catch(err => {
                                this.noError(err.response.data.rows)
                            })
                        }else{
                            if((del19 + 1) == this.$refs.presenceInEASUZpond.$attrs.documentInfo.length){
                                this.saveDoc19()
                            }
                        }
                    }
                }else{
                    this.saveDoc19()
                }
            },
            deleteDoc20(){
                if (this.presenceInPIKFilesDetails.length > 0) {
                    for (let del20 = 0; del20 < this.$refs.presenceInPIKpond.$attrs.documentInfo.length; del20++) {
                        if (this.$refs.presenceInPIKpond.$attrs.documentInfo[del20].deleteStatus == true) {
                            axios({
                                method: 'delete',
                                url: this.backUrl + '/api/documents/files',
                                withCredentials: true,
                                headers: {
                                    'Authorization': 'Basic ' + this.token
                                },
                                data: {
                                    id: this.$refs.presenceInPIKpond.$attrs.documentInfo[del20].id,
                                    uuid: this.$refs.presenceInPIKpond.$attrs.documentInfo[del20].uuid,
                                },
                            }).then(() => {

                                if((del20 + 1) == this.$refs.presenceInPIKpond.$attrs.documentInfo.length){
                                    this.saveDoc20()
                                }

                            }).catch(err => {
                                this.noError(err.response.data.rows)
                            })
                        }else{
                            if((del20 + 1) == this.$refs.presenceInPIKpond.$attrs.documentInfo.length){
                                this.saveDoc20()
                            }
                        }
                    }
                }else{
                    this.saveDoc20()
                }
            },
            deleteDoc21(){
                if (this.letterToAddToCommissionFilesDetails.length > 0) {
                    for (let del21 = 0; del21 < this.$refs.letterToAddToCommissionpond.$attrs.documentInfo.length; del21++) {
                        if (this.$refs.letterToAddToCommissionpond.$attrs.documentInfo[del21].deleteStatus == true) {
                            axios({
                                method: 'delete',
                                url: this.backUrl + '/api/documents/files',
                                withCredentials: true,
                                headers: {
                                    'Authorization': 'Basic ' + this.token
                                },
                                data: {
                                    id: this.$refs.letterToAddToCommissionpond.$attrs.documentInfo[del21].id,
                                    uuid: this.$refs.letterToAddToCommissionpond.$attrs.documentInfo[del21].uuid,
                                },
                            }).then(() => {

                                if((del21 + 1) == this.$refs.letterToAddToCommissionpond.$attrs.documentInfo.length){
                                    this.saveDoc21()
                                }

                            }).catch(err => {
                                this.noError(err.response.data.rows)
                            })
                        }else{
                            if((del21 + 1) == this.$refs.letterToAddToCommissionpond.$attrs.documentInfo.length){
                                this.saveDoc21()
                            }
                        }
                    }
                }else{
                    this.saveDoc21()
                }
            },
            deleteDoc22(){
                if (this.otherFilesFilesDetails.length > 0) {
                    for (let del22 = 0; del22 < this.$refs.otherFilespond.$attrs.documentInfo.length; del22++) {
                        if (this.$refs.otherFilespond.$attrs.documentInfo[del22].deleteStatus == true) {
                            axios({
                                method: 'delete',
                                url: this.backUrl + '/api/documents/files',
                                withCredentials: true,
                                headers: {
                                    'Authorization': 'Basic ' + this.token
                                },
                                data: {
                                    id: this.$refs.otherFilespond.$attrs.documentInfo[del22].id,
                                    uuid: this.$refs.otherFilespond.$attrs.documentInfo[del22].uuid,
                                },
                            }).then(() => {

                                if((del22 + 1) == this.$refs.otherFilespond.$attrs.documentInfo.length){
                                    this.saveDoc22()
                                }

                            }).catch(err => {
                                this.noError(err.response.data.rows)
                            })
                        }else{
                            if((del22 + 1) == this.$refs.otherFilespond.$attrs.documentInfo.length){
                                this.saveDoc22()
                            }
                        }
                    }
                }else{
                    this.saveDoc22()
                }
            },

            saveDoc1(){
                if(this.$refs.procurementPlanpond.getFiles().length < 1){
                    this.deleteDoc2()
                }else {
                    for (let save1 = 0; save1 < this.$refs.procurementPlanpond.getFiles().length; save1++) {
                        if (this.$refs.procurementPlanpond.getFiles()[save1].status != 8) {
                            let formData1 = new FormData();

                            formData1.append('filename', this.$refs.procurementPlanpond.getFiles()[save1].file.name);
                            formData1.append('data', this.$refs.procurementPlanpond.getFiles()[save1].file);
                            formData1.append('documentId', this.requests.procurementPlan);


                            axios.post(this.backUrl + '/api/documents/files',
                                formData1,
                                {
                                    withCredentials: true,
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        'Authorization': 'Basic ' + localStorage.getItem('token')
                                    }
                                }).then(() => {

                                if ((save1 + 1) == this.$refs.procurementPlanpond.getFiles().length) {
                                    this.deleteDoc2()
                                }
                            }).catch(err => {
                                if (err.response.data.rows && err.response.data.rows.filename) {
                                    this.duplicatName()
                                }else if(err.response.data.description == 'Не пустой файл должен быть прикреплен'){
                                    this.emptyDocument()
                                }else {
                                    this.noError(err.response.data.rows)
                                }
                            })
                        }else{
                            if ((save1 + 1) == this.$refs.procurementPlanpond.getFiles().length) {
                                this.deleteDoc2()
                            }
                        }
                    }
                }
            },
            saveDoc2(){
                if(this.$refs.procurementSchedulepond.getFiles().length < 1){
                    this.deleteDoc3()
                }else {
                    for (let save2 = 0; save2 < this.$refs.procurementSchedulepond.getFiles().length; save2++) {
                        if (this.$refs.procurementSchedulepond.getFiles()[save2].status != 8) {
                            let formData2 = new FormData();
                            formData2.append('filename', this.$refs.procurementSchedulepond.getFiles()[save2].file.name);
                            formData2.append('data', this.$refs.procurementSchedulepond.getFiles()[save2].file);
                            formData2.append('documentId', this.requests.procurementSchedule);

                            axios.post(this.backUrl + '/api/documents/files',
                                formData2,
                                {
                                    withCredentials: true,
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        'Authorization': 'Basic ' + localStorage.getItem('token')
                                    }
                                }).then(() => {

                                if ((save2 + 1) == this.$refs.procurementSchedulepond.getFiles().length) {
                                    this.deleteDoc3()
                                }
                            }).catch(err => {
                                if (err.response.data.rows && err.response.data.rows.filename) {
                                    this.duplicatName()
                                }else if(err.response.data.description == 'Не пустой файл должен быть прикреплен'){
                                    this.emptyDocument()
                                }else {
                                    this.noError(err.response.data.rows)
                                }
                            })
                        }else{
                            if ((save2 + 1) == this.$refs.procurementSchedulepond.getFiles().length) {
                                this.deleteDoc3()
                            }
                        }
                    }
                }
            },
            saveDoc3(){
                if(this.$refs.technicalTaskpond.getFiles().length < 1){
                    this.deleteDoc4()
                }else {
                    for (let save3 = 0; save3 < this.$refs.technicalTaskpond.getFiles().length; save3++) {
                        if (this.$refs.technicalTaskpond.getFiles()[save3].status != 8) {
                            let formData3 = new FormData();
                            formData3.append('filename', this.$refs.technicalTaskpond.getFiles()[save3].file.name);
                            formData3.append('data', this.$refs.technicalTaskpond.getFiles()[save3].file);
                            formData3.append('documentId', this.requests.technicalTask);
                            axios.post(this.backUrl + '/api/documents/files',
                                formData3,
                                {
                                    withCredentials: true,
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        'Authorization': 'Basic ' + localStorage.getItem('token')
                                    }
                                }).then(() => {

                                if ((save3 + 1) == this.$refs.technicalTaskpond.getFiles().length) {
                                    this.deleteDoc4()
                                }
                            }).catch(err => {
                                if (err.response.data.rows && err.response.data.rows.filename) {
                                    this.duplicatName()
                                }else if(err.response.data.description == 'Не пустой файл должен быть прикреплен'){
                                    this.emptyDocument()
                                }else {
                                    this.noError(err.response.data.rows)
                                }
                            })
                        }else{
                            if ((save3 + 1) == this.$refs.technicalTaskpond.getFiles().length) {
                                this.deleteDoc4()
                            }
                        }
                    }
                }
            },
            saveDoc4(){
                if(this.$refs.estimatespond.getFiles().length < 1){
                    this.deleteDoc5()
                }else {
                    for (let save4 = 0; save4 < this.$refs.estimatespond.getFiles().length; save4++) {
                        if (this.$refs.estimatespond.getFiles()[save4].status != 8) {
                            let formData4 = new FormData();
                            formData4.append('filename', this.$refs.estimatespond.getFiles()[save4].file.name);
                            formData4.append('data', this.$refs.estimatespond.getFiles()[save4].file);
                            formData4.append('documentId', this.requests.estimates);

                            axios.post(this.backUrl + '/api/documents/files',
                                formData4,
                                {
                                    withCredentials: true,
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        'Authorization': 'Basic ' + localStorage.getItem('token')
                                    }
                                }).then(() => {

                                if ((save4 + 1) == this.$refs.estimatespond.getFiles().length) {
                                    this.deleteDoc5()
                                }
                            }).catch(err => {
                                if (err.response.data.rows && err.response.data.rows.filename) {
                                    this.duplicatName()
                                }else if(err.response.data.description == 'Не пустой файл должен быть прикреплен'){
                                    this.emptyDocument()
                                }else {
                                    this.noError(err.response.data.rows)
                                }
                            })
                        }else{
                            if ((save4 + 1) == this.$refs.estimatespond.getFiles().length) {
                                this.deleteDoc5()
                            }
                        }
                    }
                }
            },
            saveDoc5(){
                if(this.$refs.defectiveStatementspond.getFiles().length < 1){
                    this.deleteDoc6()
                }else {
                    for (let save5 = 0; save5 < this.$refs.defectiveStatementspond.getFiles().length; save5++) {
                        if (this.$refs.defectiveStatementspond.getFiles()[save5].status != 8) {
                            let formData5 = new FormData();
                            formData5.append('filename', this.$refs.defectiveStatementspond.getFiles()[save5].file.name);
                            formData5.append('data', this.$refs.defectiveStatementspond.getFiles()[save5].file);
                            formData5.append('documentId', this.requests.defectiveStatements);

                            axios.post(this.backUrl + '/api/documents/files',
                                formData5,
                                {
                                    withCredentials: true,
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        'Authorization': 'Basic ' + localStorage.getItem('token')
                                    }
                                }).then(() => {

                                if ((save5 + 1) == this.$refs.defectiveStatementspond.getFiles().length) {
                                    this.deleteDoc6()
                                }
                            }).catch(err => {
                                if (err.response.data.rows && err.response.data.rows.filename) {
                                    this.duplicatName()
                                }else if(err.response.data.description == 'Не пустой файл должен быть прикреплен'){
                                    this.emptyDocument()
                                }else {
                                    this.noError(err.response.data.rows)
                                }
                            })
                        }else{
                            if ((save5 + 1) == this.$refs.defectiveStatementspond.getFiles().length) {
                                this.deleteDoc6()
                            }
                        }
                    }
                }
            },
            saveDoc6(){
                if(this.$refs.projectspond.getFiles().length < 1){
                    this.deleteDoc7()
                }else {
                    for (let save6 = 0; save6 < this.$refs.projectspond.getFiles().length; save6++) {
                        if (this.$refs.projectspond.getFiles()[save6].status != 8) {
                            let formData6 = new FormData();
                            formData6.append('filename', this.$refs.projectspond.getFiles()[save6].file.name);
                            formData6.append('data', this.$refs.projectspond.getFiles()[save6].file);
                            formData6.append('documentId', this.requests.projects);

                            axios.post(this.backUrl + '/api/documents/files',
                                formData6,
                                {
                                    withCredentials: true,
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        'Authorization': 'Basic ' + localStorage.getItem('token')
                                    }
                                }).then(() => {

                                if ((save6 + 1) == this.$refs.projectspond.getFiles().length) {
                                    this.deleteDoc7()
                                }
                            }).catch(err => {
                                if (err.response.data.rows && err.response.data.rows.filename) {
                                    this.duplicatName()
                                }else if(err.response.data.description == 'Не пустой файл должен быть прикреплен'){
                                    this.emptyDocument()
                                }else {
                                    this.noError(err.response.data.rows)
                                }
                            })
                        }else{
                            if ((save6 + 1) == this.$refs.projectspond.getFiles().length) {
                                this.deleteDoc7()
                            }
                        }
                    }
                }
            },
            saveDoc7(){
                if(this.$refs.sketchespond.getFiles().length < 1){
                    this.deleteDoc8()
                }else {
                    for (let save7 = 0; save7 < this.$refs.sketchespond.getFiles().length; save7++) {
                        if (this.$refs.sketchespond.getFiles()[save7].status != 8) {
                            let formData7 = new FormData();
                            formData7.append('filename', this.$refs.sketchespond.getFiles()[save7].file.name);
                            formData7.append('data', this.$refs.sketchespond.getFiles()[save7].file);
                            formData7.append('documentId', this.requests.sketches);

                            axios.post(this.backUrl + '/api/documents/files',
                                formData7,
                                {
                                    withCredentials: true,
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        'Authorization': 'Basic ' + localStorage.getItem('token')
                                    }
                                }).then(() => {

                                if ((save7 + 1) == this.$refs.sketchespond.getFiles().length) {
                                    this.deleteDoc8()
                                }
                            }).catch(err => {
                                if (err.response.data.rows && err.response.data.rows.filename) {
                                    this.duplicatName()
                                }else if(err.response.data.description == 'Не пустой файл должен быть прикреплен'){
                                    this.emptyDocument()
                                }else {
                                    this.noError(err.response.data.rows)
                                }
                            })
                        }else{
                            if ((save7 + 1) == this.$refs.sketchespond.getFiles().length) {
                                this.deleteDoc8()
                            }
                        }
                    }
                }
            },
            saveDoc8(){
                if(this.$refs.performanceRequirementspond.getFiles().length < 1){
                    this.deleteDoc9()
                }else {
                    for (let save8 = 0; save8 < this.$refs.performanceRequirementspond.getFiles().length; save8++) {
                        if (this.$refs.performanceRequirementspond.getFiles()[save8].status != 8) {
                            let formData8 = new FormData();
                            formData8.append('filename', this.$refs.performanceRequirementspond.getFiles()[save8].file.name);
                            formData8.append('data', this.$refs.performanceRequirementspond.getFiles()[save8].file);
                            formData8.append('documentId', this.requests.performanceRequirements);

                            axios.post(this.backUrl + '/api/documents/files',
                                formData8,
                                {
                                    withCredentials: true,
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        'Authorization': 'Basic ' + localStorage.getItem('token')
                                    }
                                }).then(() => {

                                if ((save8 + 1) == this.$refs.performanceRequirementspond.getFiles().length) {
                                    this.deleteDoc9()
                                }
                            }).catch(err => {
                                if (err.response.data.rows && err.response.data.rows.filename) {
                                    this.duplicatName()
                                }else if(err.response.data.description == 'Не пустой файл должен быть прикреплен'){
                                    this.emptyDocument()
                                }else {
                                    this.noError(err.response.data.rows)
                                }
                            })
                        }else{
                            if ((save8 + 1) == this.$refs.performanceRequirementspond.getFiles().length) {
                                this.deleteDoc9()
                            }
                        }
                    }
                }
            },
            saveDoc9(){
                if(this.$refs.targetedSubsidySubmissionpond.getFiles().length < 1){
                    this.deleteDoc10()
                }else {
                    for (let save9 = 0; save9 < this.$refs.targetedSubsidySubmissionpond.getFiles().length; save9++) {
                        if (this.$refs.targetedSubsidySubmissionpond.getFiles()[save9].status != 8) {
                            let formData9 = new FormData();
                            formData9.append('filename', this.$refs.targetedSubsidySubmissionpond.getFiles()[save9].file.name);
                            formData9.append('data', this.$refs.targetedSubsidySubmissionpond.getFiles()[save9].file);
                            formData9.append('documentId', this.requests.targetedSubsidySubmission);

                            axios.post(this.backUrl + '/api/documents/files',
                                formData9,
                                {
                                    withCredentials: true,
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        'Authorization': 'Basic ' + localStorage.getItem('token')
                                    }
                                }).then(() => {

                                if ((save9 + 1) == this.$refs.targetedSubsidySubmissionpond.getFiles().length) {
                                    this.deleteDoc10()
                                }
                            }).catch(err => {
                                if (err.response.data.rows && err.response.data.rows.filename) {
                                    this.duplicatName()
                                }else if(err.response.data.description == 'Не пустой файл должен быть прикреплен'){
                                    this.emptyDocument()
                                }else {
                                    this.noError(err.response.data.rows)
                                }
                            })
                        }else{
                            if ((save9 + 1) == this.$refs.targetedSubsidySubmissionpond.getFiles().length) {
                                this.deleteDoc10()
                            }
                        }
                    }
                }
            },
            saveDoc10(){
                if(this.$refs.priceInfopond.getFiles().length < 1){
                    this.deleteDoc11()
                }else {
                    for (let save10 = 0; save10 < this.$refs.priceInfopond.getFiles().length; save10++) {
                        if (this.$refs.priceInfopond.getFiles()[save10].status != 8) {
                            let formData10 = new FormData();
                            formData10.append('filename', this.$refs.priceInfopond.getFiles()[save10].file.name);
                            formData10.append('data', this.$refs.priceInfopond.getFiles()[save10].file);
                            formData10.append('documentId', this.requests.priceInfo);

                            axios.post(this.backUrl + '/api/documents/files',
                                formData10,
                                {
                                    withCredentials: true,
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        'Authorization': 'Basic ' + localStorage.getItem('token')
                                    }
                                }).then(() => {

                                if ((save10 + 1) == this.$refs.priceInfopond.getFiles().length) {
                                    this.deleteDoc11()
                                }
                            }).catch(err => {
                                if (err.response.data.rows && err.response.data.rows.filename) {
                                    this.duplicatName()
                                }else if(err.response.data.description == 'Не пустой файл должен быть прикреплен'){
                                    this.emptyDocument()
                                }else {
                                    this.noError(err.response.data.rows)
                                }
                            })
                        }else{
                            if ((save10 + 1) == this.$refs.priceInfopond.getFiles().length) {
                                this.deleteDoc11()
                            }
                        }
                    }
                }
            },
            saveDoc11(){
                if(this.$refs.infoForAdvancePaymentpond.getFiles().length < 1){
                    this.deleteDoc12()
                }else {
                    for (let save11 = 0; save11 < this.$refs.infoForAdvancePaymentpond.getFiles().length; save11++) {
                        if (this.$refs.infoForAdvancePaymentpond.getFiles()[save11].status != 8) {
                            let formData11 = new FormData();
                            formData11.append('filename', this.$refs.infoForAdvancePaymentpond.getFiles()[save11].file.name);
                            formData11.append('data', this.$refs.infoForAdvancePaymentpond.getFiles()[save11].file);
                            formData11.append('documentId', this.requests.infoForAdvancePayment);

                            axios.post(this.backUrl + '/api/documents/files',
                                formData11,
                                {
                                    withCredentials: true,
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        'Authorization': 'Basic ' + localStorage.getItem('token')
                                    }
                                }).then(() => {

                                if ((save11 + 1) == this.$refs.infoForAdvancePaymentpond.getFiles().length) {
                                    this.deleteDoc12()
                                }
                            }).catch(err => {
                                if (err.response.data.rows && err.response.data.rows.filename) {
                                    this.duplicatName()
                                }else if(err.response.data.description == 'Не пустой файл должен быть прикреплен'){
                                    this.emptyDocument()
                                }else {
                                    this.noError(err.response.data.rows)
                                }
                            })
                        }else{
                            if ((save11 + 1) == this.$refs.infoForAdvancePaymentpond.getFiles().length) {
                                this.deleteDoc12()
                            }
                        }
                    }
                }
            },
            saveDoc12(){
                if(this.$refs.contractProjectpond.getFiles().length < 1){
                    this.deleteDoc13()
                }else {
                    for (let save12 = 0; save12 < this.$refs.contractProjectpond.getFiles().length; save12++) {
                        if (this.$refs.contractProjectpond.getFiles()[save12].status != 8) {
                            let formData12 = new FormData();
                            formData12.append('filename', this.$refs.contractProjectpond.getFiles()[save12].file.name);
                            formData12.append('data', this.$refs.contractProjectpond.getFiles()[save12].file);
                            formData12.append('documentId', this.requests.contractProject);

                            axios.post(this.backUrl + '/api/documents/files',
                                formData12,
                                {
                                    withCredentials: true,
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        'Authorization': 'Basic ' + localStorage.getItem('token')
                                    }
                                }).then(() => {

                                if ((save12 + 1) == this.$refs.contractProjectpond.getFiles().length) {
                                    this.deleteDoc13()
                                }
                            }).catch(err => {
                                if (err.response.data.rows && err.response.data.rows.filename) {
                                    this.duplicatName()
                                }else if(err.response.data.description == 'Не пустой файл должен быть прикреплен'){
                                    this.emptyDocument()
                                }else {
                                    this.noError(err.response.data.rows)
                                }
                            })
                        }else{
                            if ((save12 + 1) == this.$refs.contractProjectpond.getFiles().length) {
                                this.deleteDoc13()
                            }
                        }
                    }
                }
            },
            saveDoc13(){
                if(this.$refs.contractProjectApplicationpond.getFiles().length < 1){
                    this.deleteDoc14()
                }else {
                    for (let save13 = 0; save13 < this.$refs.contractProjectApplicationpond.getFiles().length; save13++) {
                        if (this.$refs.contractProjectApplicationpond.getFiles()[save13].status != 8) {
                            let formData13 = new FormData();
                            formData13.append('filename', this.$refs.contractProjectApplicationpond.getFiles()[save13].file.name);
                            formData13.append('data', this.$refs.contractProjectApplicationpond.getFiles()[save13].file);
                            formData13.append('documentId', this.requests.contractProjectApplication);

                            axios.post(this.backUrl + '/api/documents/files',
                                formData13,
                                {
                                    withCredentials: true,
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        'Authorization': 'Basic ' + localStorage.getItem('token')
                                    }
                                }).then(() => {

                                if ((save13 + 1) == this.$refs.contractProjectApplicationpond.getFiles().length) {
                                    this.deleteDoc14()
                                }
                            }).catch(err => {
                                if (err.response.data.rows && err.response.data.rows.filename) {
                                    this.duplicatName()
                                }else if(err.response.data.description == 'Не пустой файл должен быть прикреплен'){
                                    this.emptyDocument()
                                }else {
                                    this.noError(err.response.data.rows)
                                }
                            })
                        }else{
                            if ((save13 + 1) == this.$refs.contractProjectApplicationpond.getFiles().length) {
                                this.deleteDoc14()
                            }
                        }
                    }
                }
            },
            saveDoc14(){
                if(this.contractItem.supplierDefinitionType == 'OPEN_CONTEST_EL_FORM' || this.contractItem.supplierDefinitionType == 'LIMITED_CONTEST' ){
                    if(this.$refs.evaluationRulespond.getFiles().length < 1){
                        this.deleteDoc15()
                    }else {
                        for (let save14 = 0; save14 < this.$refs.evaluationRulespond.getFiles().length; save14++) {
                            if (this.$refs.evaluationRulespond.getFiles()[save14].status != 8) {
                                let formData14 = new FormData();
                                formData14.append('filename', this.$refs.evaluationRulespond.getFiles()[save14].file.name);
                                formData14.append('data', this.$refs.evaluationRulespond.getFiles()[save14].file);
                                formData14.append('documentId', this.requests.evaluationRules);

                                axios.post(this.backUrl + '/api/documents/files',
                                    formData14,
                                    {
                                        withCredentials: true,
                                        headers: {
                                            'Content-Type': 'multipart/form-data',
                                            'Authorization': 'Basic ' + localStorage.getItem('token')
                                        }
                                    }).then(() => {

                                    if ((save14 + 1) == this.$refs.evaluationRulespond.getFiles().length) {
                                        this.deleteDoc15()
                                    }
                                }).catch(err => {
                                    if (err.response.data.rows && err.response.data.rows.filename) {
                                        this.duplicatName()
                                    }else if(err.response.data.description == 'Не пустой файл должен быть прикреплен'){
                                        this.emptyDocument()
                                    }else {
                                        this.noError(err.response.data.rows)
                                    }
                                })
                            }else{
                                if ((save14 + 1) == this.$refs.evaluationRulespond.getFiles().length) {
                                    this.deleteDoc15()
                                }
                            }
                        }
                    }
                }else{
                    this.deleteDoc15()
                }
            },
            saveDoc15(){
                if(this.$refs.infoForStartContractPricepond.getFiles().length < 1){
                    this.deleteDoc16()
                }else {
                    for (let save15 = 0; save15 < this.$refs.infoForStartContractPricepond.getFiles().length; save15++) {
                        if (this.$refs.infoForStartContractPricepond.getFiles()[save15].status != 8) {
                            let formData15 = new FormData();
                            formData15.append('filename', this.$refs.infoForStartContractPricepond.getFiles()[save15].file.name);
                            formData15.append('data', this.$refs.infoForStartContractPricepond.getFiles()[save15].file);
                            formData15.append('documentId', this.requests.infoForStartContractPrice);

                            axios.post(this.backUrl + '/api/documents/files',
                                formData15,
                                {
                                    withCredentials: true,
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        'Authorization': 'Basic ' + localStorage.getItem('token')
                                    }
                                }).then(() => {

                                if ((save15 + 1) == this.$refs.infoForStartContractPricepond.getFiles().length) {
                                    this.deleteDoc16()
                                }
                            }).catch(err => {
                                if (err.response.data.rows && err.response.data.rows.filename) {
                                    this.duplicatName()
                                }else if(err.response.data.description == 'Не пустой файл должен быть прикреплен'){
                                    this.emptyDocument()
                                }else {
                                    this.noError(err.response.data.rows)
                                }
                            })
                        }else{
                            if ((save15 + 1) == this.$refs.infoForStartContractPricepond.getFiles().length) {
                                this.deleteDoc16()
                            }
                        }
                    }
                }
            },
            saveDoc16(){
                if(this.$refs.startContractPriceCalcpond.getFiles().length < 1){
                    this.deleteDoc17()
                }else {
                    for (let save16 = 0; save16 < this.$refs.startContractPriceCalcpond.getFiles().length; save16++) {
                        if (this.$refs.startContractPriceCalcpond.getFiles()[save16].status != 8) {
                            let formData16 = new FormData();
                            formData16.append('filename', this.$refs.startContractPriceCalcpond.getFiles()[save16].file.name);
                            formData16.append('data', this.$refs.startContractPriceCalcpond.getFiles()[save16].file);
                            formData16.append('documentId', this.requests.startContractPriceCalc);

                            axios.post(this.backUrl + '/api/documents/files',
                                formData16,
                                {
                                    withCredentials: true,
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        'Authorization': 'Basic ' + localStorage.getItem('token')
                                    }
                                }).then(() => {

                                if ((save16 + 1) == this.$refs.startContractPriceCalcpond.getFiles().length) {
                                    this.deleteDoc17()
                                }
                            }).catch(err => {
                                if (err.response.data.rows && err.response.data.rows.filename) {
                                    this.duplicatName()
                                }else if(err.response.data.description == 'Не пустой файл должен быть прикреплен'){
                                    this.emptyDocument()
                                }else {
                                    this.noError(err.response.data.rows)
                                }
                            })
                        }else{
                            if ((save16 + 1) == this.$refs.startContractPriceCalcpond.getFiles().length) {
                                this.deleteDoc17()
                            }
                        }
                    }
                }
            },
            saveDoc17(){
                if(this.$refs.financingProofpond.getFiles().length < 1){
                    this.deleteDoc18()
                }else {
                    for (let save17 = 0; save17 < this.$refs.financingProofpond.getFiles().length; save17++) {
                        if (this.$refs.financingProofpond.getFiles()[save17].status != 8) {
                            let formData17 = new FormData();
                            formData17.append('filename', this.$refs.financingProofpond.getFiles()[save17].file.name);
                            formData17.append('data', this.$refs.financingProofpond.getFiles()[save17].file);
                            formData17.append('documentId', this.requests.financingProof);

                            axios.post(this.backUrl + '/api/documents/files',
                                formData17,
                                {
                                    withCredentials: true,
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        'Authorization': 'Basic ' + localStorage.getItem('token')
                                    }
                                }).then(() => {

                                if ((save17 + 1) == this.$refs.financingProofpond.getFiles().length) {
                                    this.deleteDoc18()
                                }
                            }).catch(err => {
                                if (err.response.data.rows && err.response.data.rows.filename) {
                                    this.duplicatName()
                                }else if(err.response.data.description == 'Не пустой файл должен быть прикреплен'){
                                    this.emptyDocument()
                                }else {
                                    this.noError(err.response.data.rows)
                                }
                            })
                        }else{
                            if ((save17 + 1) == this.$refs.financingProofpond.getFiles().length) {
                                this.deleteDoc18()
                            }
                        }
                    }
                }
            },
            saveDoc18(){
                if(this.$refs.presenceInEISpond.getFiles().length < 1){
                    this.deleteDoc19()
                }else {
                    for (let save18 = 0; save18 < this.$refs.presenceInEISpond.getFiles().length; save18++) {
                        if (this.$refs.presenceInEISpond.getFiles()[save18].status != 8) {
                            let formData18 = new FormData();
                            formData18.append('filename', this.$refs.presenceInEISpond.getFiles()[save18].file.name);
                            formData18.append('data', this.$refs.presenceInEISpond.getFiles()[save18].file);
                            formData18.append('documentId', this.requests.presenceInEIS);

                            axios.post(this.backUrl + '/api/documents/files',
                                formData18,
                                {
                                    withCredentials: true,
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        'Authorization': 'Basic ' + localStorage.getItem('token')
                                    }
                                }).then(() => {

                                if ((save18 + 1) == this.$refs.presenceInEISpond.getFiles().length) {
                                    this.deleteDoc19()
                                }
                            }).catch(err => {
                                if (err.response.data.rows && err.response.data.rows.filename) {
                                    this.duplicatName()
                                }else if(err.response.data.description == 'Не пустой файл должен быть прикреплен'){
                                    this.emptyDocument()
                                }else {
                                    this.noError(err.response.data.rows)
                                }
                            })
                        }else{
                            if ((save18 + 1) == this.$refs.presenceInEISpond.getFiles().length) {
                                this.deleteDoc19()
                            }
                        }
                    }
                }
            },
            saveDoc19(){
                if(this.$refs.presenceInEASUZpond.getFiles().length < 1){
                    this.deleteDoc20()
                }else {
                    for (let save19 = 0; save19 < this.$refs.presenceInEASUZpond.getFiles().length; save19++) {
                        if (this.$refs.presenceInEASUZpond.getFiles()[save19].status != 8) {
                            let formData19 = new FormData();
                            formData19.append('filename', this.$refs.presenceInEASUZpond.getFiles()[save19].file.name);
                            formData19.append('data', this.$refs.presenceInEASUZpond.getFiles()[save19].file);
                            formData19.append('documentId', this.requests.presenceInEASUZ);

                            axios.post(this.backUrl + '/api/documents/files',
                                formData19,
                                {
                                    withCredentials: true,
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        'Authorization': 'Basic ' + localStorage.getItem('token')
                                    }
                                }).then(() => {

                                if ((save19 + 1) == this.$refs.presenceInEASUZpond.getFiles().length) {
                                    this.deleteDoc20()
                                }
                            }).catch(err => {
                                if (err.response.data.rows && err.response.data.rows.filename) {
                                    this.duplicatName()
                                }else if(err.response.data.description == 'Не пустой файл должен быть прикреплен'){
                                    this.emptyDocument()
                                }else {
                                    this.noError(err.response.data.rows)
                                }
                            })
                        }else{
                            if ((save19 + 1) == this.$refs.presenceInEASUZpond.getFiles().length) {
                                this.deleteDoc20()
                            }
                        }
                    }
                }
            },
            saveDoc20(){
                if(this.$refs.presenceInPIKpond.getFiles().length < 1){
                    this.deleteDoc21()
                }else {
                    for (let save20 = 0; save20 < this.$refs.presenceInPIKpond.getFiles().length; save20++) {
                        if (this.$refs.presenceInPIKpond.getFiles()[save20].status != 8) {
                            let formData20 = new FormData();
                            formData20.append('filename', this.$refs.presenceInPIKpond.getFiles()[save20].file.name);
                            formData20.append('data', this.$refs.presenceInPIKpond.getFiles()[save20].file);
                            formData20.append('documentId', this.requests.presenceInPIK);

                            axios.post(this.backUrl + '/api/documents/files',
                                formData20,
                                {
                                    withCredentials: true,
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        'Authorization': 'Basic ' + localStorage.getItem('token')
                                    }
                                }).then(() => {

                                if ((save20 + 1) == this.$refs.presenceInPIKpond.getFiles().length) {
                                    this.deleteDoc21()
                                }
                            }).catch(err => {
                                if (err.response.data.rows && err.response.data.rows.filename) {
                                    this.duplicatName()
                                }else if(err.response.data.description == 'Не пустой файл должен быть прикреплен'){
                                    this.emptyDocument()
                                }else {
                                    this.noError(err.response.data.rows)
                                }
                            })
                        }else{
                            if ((save20 + 1) == this.$refs.presenceInPIKpond.getFiles().length) {
                                this.deleteDoc21()
                            }
                        }
                    }
                }
            },
            saveDoc21(){
                if(this.$refs.letterToAddToCommissionpond.getFiles().length < 1){
                    this.deleteDoc22()
                }else {
                    for (let save21 = 0; save21 < this.$refs.letterToAddToCommissionpond.getFiles().length; save21++) {
                        if (this.$refs.letterToAddToCommissionpond.getFiles()[save21].status != 8) {
                            let formData21 = new FormData();
                            formData21.append('filename', this.$refs.letterToAddToCommissionpond.getFiles()[save21].file.name);
                            formData21.append('data', this.$refs.letterToAddToCommissionpond.getFiles()[save21].file);
                            formData21.append('documentId', this.requests.letterToAddToCommission);

                            axios.post(this.backUrl + '/api/documents/files',
                                formData21,
                                {
                                    withCredentials: true,
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        'Authorization': 'Basic ' + localStorage.getItem('token')
                                    }
                                }).then(() => {

                                if ((save21 + 1) == this.$refs.letterToAddToCommissionpond.getFiles().length) {
                                    this.deleteDoc22()
                                }
                            }).catch(err => {
                                if (err.response.data.rows && err.response.data.rows.filename) {
                                    this.duplicatName()
                                }else if(err.response.data.description == 'Не пустой файл должен быть прикреплен'){
                                    this.emptyDocument()
                                }else {
                                    this.noError(err.response.data.rows)
                                }
                            })
                        }else{
                            if ((save21 + 1) == this.$refs.letterToAddToCommissionpond.getFiles().length) {
                                this.deleteDoc22()
                            }
                        }
                    }
                }
            },
            saveDoc22(){
                if(this.$refs.otherFilespond.getFiles().length < 1){
                    this.saveBid()
                }else {
                    for (let save22 = 0; save22 < this.$refs.otherFilespond.getFiles().length; save22++) {
                        if (this.$refs.otherFilespond.getFiles()[save22].status != 8) {
                            let formData22 = new FormData();
                            formData22.append('filename', this.$refs.otherFilespond.getFiles()[save22].file.name);
                            formData22.append('data', this.$refs.otherFilespond.getFiles()[save22].file);
                            formData22.append('documentId', this.requests.otherFiles);

                            axios.post(this.backUrl + '/api/documents/files',
                                formData22,
                                {
                                    withCredentials: true,
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        'Authorization': 'Basic ' + localStorage.getItem('token')
                                    }
                                }).then(() => {

                                if ((save22 + 1) == this.$refs.otherFilespond.getFiles().length) {
                                    this.saveBid()
                                }
                            }).catch(err => {
                                if (err.response.data.rows && err.response.data.rows.filename) {
                                    this.duplicatName()
                                }else if(err.response.data.description == 'Не пустой файл должен быть прикреплен'){
                                    this.emptyDocument()
                                }else {
                                    this.noError(err.response.data.rows)
                                }
                            })
                        }else{
                            if ((save22 + 1) == this.$refs.otherFilespond.getFiles().length) {
                                this.saveBid()
                            }
                        }
                    }
                }
            },


            saveBid(){
                this.errFileName = null
                this.errorMessage = null

                if(!this.contractItem.undefinedQuantityUnitsSupplied){
                    this.contractItem.startServicePrice = ''
                    this.contractItem.startServiceUnitsSum = ''
                    this.contractItem.maxContractPrice = ''
                }
                axios({
                    method: 'put',
                    url: this.backUrl + '/api/contracts',
                    withCredentials: true,
                    headers: {
                        'Authorization': 'Basic ' + this.token
                    },
                    data: {
                        id: this.contractItem.id,
                        uuid: this.contractItem.uuid,
                        contractDocumentName: this.contractItem.contractDocumentName,
                        contractDocumentNumber: this.contractItem.contractDocumentNumber,
                        contractDocumentDate: this.contractItem.contractDocumentDate,
                        contractManagerFIO: this.contractItem.contractManagerFIO,
                        contractManagerPhone: this.contractItem.contractManagerPhone,
                        contractManagerEmail: this.contractItem.contractManagerEmail,
                        name: this.contractItem.name,
                        supplierDefinitionType: this.contractItem.supplierDefinitionType,
                        purchaseRegNumber: this.contractItem.purchaseRegNumber,
                        purchaseId: this.contractItem.purchaseId,
                        startContractPrice: makeValidNumber(this.contractItem.startContractPrice),
                        justificationMethod: this.contractItem.justificationMethod,
                        otherTaxInPrice: this.contractItem.otherTaxInPrice,
                        startServicePrice: makeValidNumber(this.contractItem.startServicePrice),
                        startServiceUnitsSum: makeValidNumber(this.contractItem.startServiceUnitsSum),
                        maxContractPrice: makeValidNumber(this.contractItem.maxContractPrice),
                        contractExecutionPlace: this.contractItem.contractExecutionPlace,
                        contractExecutionDeadline: this.contractItem.contractExecutionDeadline,
                        contractPaymentProcedureAndTerms: this.contractItem.contractPaymentProcedureAndTerms,
                        financeSource: this.contractItem.financeSource,
                        yearsOfFinancing: this.contractItem.yearsOfFinancing,
                        provisionSize: makeValidNumber(this.contractItem.provisionSize),
                        provisionSizePercent: makeValidNumber(this.contractItem.provisionSizePercent),
                        undefinedQuantityUnitsSupplied: this.contractItem.undefinedQuantityUnitsSupplied,
                        contractConditionsCanBeChanged1: this.contractItem.contractConditionsCanBeChanged1,
                        contractConditionsCanBeChanged2: this.contractItem.contractConditionsCanBeChanged2,
                        contractConditionsCanBeChanged3: this.contractItem.contractConditionsCanBeChanged3,
                        contractConditionsCanBeChanged4: this.contractItem.contractConditionsCanBeChanged4,
                        unilateralRefusal: this.contractItem.unilateralRefusal,
                        attractionPercent: this.contractItem.attractionPercent,
                        definitionCustomerPart: this.contractItem.definitionCustomerPart,
                        penalSystemPart: this.contractItem.penalSystemPart,
                        disabledPeopleOrgPart: this.contractItem.disabledPeopleOrgPart,
                        requirementForParticipant: this.contractItem.requirementForParticipant,
                        fz_44: this.contractItem.fz_44,
                        accountDetailsId: this.contractItem.accountDetailsId,


                    },
                }).then(() => {

                    axios({
                        method: 'put',
                        url: this.backUrl + '/api/bids',
                        withCredentials: true,
                        headers: {
                            'Authorization': 'Basic ' + this.token
                        },
                        data: {
                            id: this.requests.id,
                            uuid: this.requests.uuid,
                            provisionSize: makeValidNumber(this.requests.provisionSize),
                            provisionSizePercent: makeValidNumber(this.requests.provisionSizePercent),
                            accountDetailsId: this.contractItem.accountDetailsId,
                            procurementPlan: this.requests.procurementPlan,
                            procurementSchedule: this.requests.procurementSchedule,
                            technicalTask: this.requests.technicalTask,
                            estimates: this.requests.estimates,
                            defectiveStatements: this.requests.defectiveStatements,
                            projects: this.requests.projects,
                            sketches: this.requests.sketches,
                            performanceRequirements: this.requests.performanceRequirements,
                            targetedSubsidySubmission: this.requests.targetedSubsidySubmission,
                            priceInfo: this.requests.priceInfo,
                            infoForAdvancePayment: this.requests.infoForAdvancePayment,
                            contractProject: this.requests.contractProject,
                            contractProjectApplication: this.requests.contractProjectApplication,
                            evaluationRules: this.requests.evaluationRules,
                            infoForStartContractPrice: this.requests.infoForStartContractPrice,
                            startContractPriceCalc: this.requests.startContractPriceCalc,
                            financingProof: this.requests.financingProof,
                            presenceInEIS: this.requests.presenceInEIS,
                            presenceInEASUZ: this.requests.presenceInEASUZ,
                            presenceInPIK: this.requests.presenceInPIK,
                            letterToAddToCommission: this.requests.letterToAddToCommission,
                            otherFiles: this.requests.otherFiles,

                        },
                    }).then(() => {
                        if(this.cancelChangeStatus.status){
                            let id = this.requests.id.toString()
                            this.$removeItem(id)
                        }
                        this.isRequestChanged = false

                        this.saveLoading = false
                        this.successRequest = true
                        setTimeout(() => (
                            this.successRequest = false,
                            this.$router.push('/requests')
                        ), 1500)

                    })
                    .catch( error => {
                        this.isRequestChanged = true
                        this.errorMessage = error.response.data.rows
                        this.errorDialog = true
                    }).finally(() => (this.saveLoading = false));

                }).catch( error => {
                    this.errorMessage = error.response.data.rows
                    this.errorDialog = true
                }).finally(() => (this.saveLoading = false));
            },

            noError(val){
                this.errFileName = val
                this.saveLoading = false
                this.errorDialog = true
            },

            duplicatName(){
                this.saveLoading = false
                this.duplicateDialog = true
            },

            emptyDocument(){
                this.saveLoading = false
                this.emptyDocumentDialog = true
            },

            convertDate(val){

                let date = new Date(val);
                let year = date.getFullYear();
                let mounth = ("0" + (date.getMonth()+1)).slice(-2);
                let day = ("0" + date.getDate()).slice(-2);
                let hours = ("0" + date.getHours()).slice(-2);
                let minutes = ("0" + date.getMinutes()).slice(-2);


                return  day + '.' + mounth + '.' + year + ' ' + hours + ':' + minutes.substr(-2);
            },

            showStatus(status){
                if(this.role == "ROLE_ADMIN" || this.role == "ROLE_EXPERT"){
                    if (status == "CREATED"){
                        return "СОЗДАНА"
                    }else if (status == "SEND_AFTER_CREATE"){
                        return "НОВАЯ"
                    }else if (status == "ASSIGNED"){
                        return "В РАБОТЕ"
                    }else if (status == "ON_REWORK"){
                        return "ЗАМЕЧАНИЯ"
                    }else if (status == "SEND_AFTER_REWORK"){
                        return "УСТРАНЕНИЕ ЗАМЕЧАНИЙ"
                    }else if (status == "WITHDRAWN"){
                        return "ОТОЗВАНА"
                    }else if (status == "CANCELED"){
                        return "ОТКЛОНЕНА"
                    }else if (status == "APPROVED"){
                        return "ПРИНЯТА"
                    }else{
                        return ''
                    }
                }else{
                    if (status == "CREATED"){
                        return "СОЗДАНА"
                    }else if (status == "SEND_AFTER_CREATE"){
                        return "ОТПРАВЛЕНА"
                    }else if (status == "ASSIGNED"){
                        return "НА ПРОВЕРКЕ"
                    }else if (status == "ON_REWORK"){
                        return "ЗАМЕЧАНИЯ"
                    }else if (status == "SEND_AFTER_REWORK"){
                        return "УСТРАНЕНИЕ ЗАМЕЧАНИЙ"
                    }else if (status == "WITHDRAWN"){
                        return "ОТОЗВАНА"
                    }else if (status == "CANCELED"){
                        return "ОТКЛОНЕНА"
                    }else if (status == "APPROVED"){
                        return "ПРИНЯТА"
                    }else{
                        return ''
                    }
                }
            },

            detectorFunction1:(source) => {
                return new Promise((resolve, reject) => {
                    let fileName = source.name;
                    let allowedExtensions = /(\.bmp|\.gif|\.jpeg|\.jpg|\.jpe|\.jp2|\.png|\.raw|\.tga|\.tiff|\.tif|\.wdp|\.hdp|\.xpm|\.pdn|\.pdf)$/i;
                    if(!allowedExtensions.exec(fileName)){
                        reject()
                    }else{
                        resolve("customType")
                    }
                })
            },
            detectorFunction2:(source) => {
                return new Promise((resolve, reject) => {
                    let fileName = source.name;
                    let allowedExtensions = /(\.odt|\.docx|\.doc|\.docm)$/i;
                    if(!allowedExtensions.exec(fileName)){
                        reject()
                    }else{
                        resolve("customType")
                    }
                })
            },
            detectorFunction3:(source) => {
                return new Promise((resolve, reject) => {
                    let fileName = source.name;
                    let allowedExtensions = /(\.pdf|\.7z|\.rar|\.zip)$/i;
                    if(!allowedExtensions.exec(fileName)){
                        reject()
                    }else{
                        resolve("customType")
                    }
                })
            },
            detectorFunction4:(source) => {
                return new Promise((resolve, reject) => {
                    let fileName = source.name;
                    let allowedExtensions = /(\.bmp|\.gif|\.jpeg|\.jpg|\.jpe|\.jp2|\.png|\.raw|\.tga|\.tiff|\.tif|\.wdp|\.hdp|\.xpm|\.pdn|\.pdf|\.7z|\.rar|\.zip)$/i;
                    if(!allowedExtensions.exec(fileName)){
                        reject()
                    }else{
                        resolve("customType")
                    }
                })
            },
            detectorFunction5:(source) => {
                return new Promise((resolve, reject) => {
                    let fileName = source.name;
                    let allowedExtensions = /(\.bmp|\.gif|\.jpeg|\.jpg|\.jpe|\.jp2|\.png|\.raw|\.tga|\.tiff|\.tif|\.wdp|\.hdp|\.xpm|\.pdn|\.pdf|\.odt|\.docx|\.doc|\.docm)$/i;
                    if(!allowedExtensions.exec(fileName)){
                        reject()
                    }else{
                        resolve("customType")
                    }
                })
            },
            detectorFunction6:(source) => {
                return new Promise((resolve, reject) => {
                    let fileName = source.name;
                    let allowedExtensions = /(\.bmp|\.gif|\.jpeg|\.jpg|\.jpe|\.jp2|\.png|\.raw|\.tga|\.tiff|\.tif|\.wdp|\.hdp|\.xpm|\.pdn|\.pdf|\.odt|\.docx|\.doc|\.docm|\.7z|\.rar|\.zip|\.xlsx|\.xls)$/i;
                    if(!allowedExtensions.exec(fileName)){
                        reject()
                    }else{
                        resolve("customType")
                    }
                })
            },
            detectorFunction7:(source) => {
                return new Promise((resolve, reject) => {
                    let fileName = source.name;
                    let allowedExtensions = /(\.odt|\.docx|\.doc|\.docm|\.pdf|\.xlsx|\.xlsx)$/i;
                    if(!allowedExtensions.exec(fileName)){
                        reject()
                    }else{
                        resolve("customType")
                    }
                })
            },
            detectorFunction8:(source) => {
                return new Promise((resolve, reject) => {
                    let fileName = source.name;
                    let allowedExtensions = /(\.odt|\.docx|\.doc|\.docm|\.xlsx|\.xlsx)$/i;
                    if(!allowedExtensions.exec(fileName)){
                        reject()
                    }else{
                        resolve("customType")
                    }
                })
            },
        }

    }

</script>

<style>
    .fa-download{
        font-size: 15px!important;
    }
    .success-card{
        color: #4caf50!important;
        font-weight: bold;
        text-align: center;
        font-size: 18px;
        padding: 30px;
    }
    .comment-paging{
        padding: 50px 0;
    }
    .request-edit .theme--light.v-input--is-disabled input,.request-edit .theme--light.v-input--is-disabled textarea, .request-edit .theme--light.v-select .v-select__selection--disabled{
        color:rgba(0,0,0,.87)!important;
    }
    .only-numbers input[type='number'] {
        -moz-appearance:textfield;
    }
    .only-numbers input::-webkit-outer-spin-button,
    .only-numbers input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
    .filepond--wrapper label:hover{
        cursor:pointer;
    }
    .download-file, .remove-file{
        margin-left: 0!important;
    }
    .remove-file .v-icon {
        font-size: 20px;
    }
    .request-edit .v-stepper__step:hover{
        background: rgba(0,0,0,.06);
        cursor: pointer;
    }
    .cancel-changes{
        text-align: center;
        margin-bottom: 20px;
    }
    .persent-btn{
        margin-top: 15px!important;
    }
    .comment-block{
        padding: 0 10px!important;
    }
    /*input[type=number]::-webkit-inner-spin-button,*/
    /*input[type=number]::-webkit-outer-spin-button {*/
        /*-webkit-appearance: none;*/
        /*margin: 0;*/
    /*}*/
</style>
